export const catalogs = {
	en: {
		groups: {
			devices: "Devices",
			groups: "Groups",
			all: "All devices",
		},
		maps: {
			center: {
				lat: 38.8846411,
				lng: -100.6161784,
			},
			zoom: "5",
			type: "1",
			infowindow: {
				tabs: {
					gral: "General",
					details: "Details",
					admin: "Admin",
					technical: "Technical details",
					client: "Client details",
					drivers: "Drivers",
				},
				status: {
					nosignal: "WITHOUT SIGNAL",
					stop: "STOPPED",
					idle: "IDLING",
					move: "IN MOVEMENT",
					nosignalgps: "WITHOUT GPS SIGNAL",
					sleep: "IN SLEEP MODE",
					stopcommand: "WITH ENGINE STOP COMMAND",
					sleepnogps: "SLEEP MODE / NO GPS",
					noenergy: "NO ENERGY SOURCE",
					gpsbattery: "GPS LOW BATTERY",
				},
				date: "Today | Yesterday | {date}",
				brand: "Brand",
				make: "Make",
				model: "Model",
				year: "Year",
				speedlimit: "Speed treshold",
				street: "Street",
				gas: "Gasoline",
				postspeed: "Posted speed",
				plates: "Plates",
				mileage: "Speed",
				quickactions: "Quick actions",
				businessname: "Business name",
				imei: "imei",
				phone: "Phone",
				port: "Device port",
				device: "Device",
				alias: "Alias",
				contact: "Contact",
				user: "User",
				movil: "Mobile",
				city: "City",
				coords: "Coordinates",
			},
			styles: {
				stylers: [
					{ visibility: "simplified" },
					{ hue: "#006eff" },
					{ lightness: 4 },
					{ gamma: 0.52 },
					{ saturation: -32 },
				],
			},
		},
		units: {
			distance: 0.625,
			temperature: {
				min: -40,
				max: 85,
			},
			temperatureDetail: {
				C: {
					min: -40,
					max: 85,
				},
				F: {
					min: -40,
					max: 185,
				},
			},
			gasoline: {
				min: 0,
				max: 100,
			},
			storage: 1024,
		},
		langs: [
			{ value: "ES", label: "Spanish" },
			{ value: "EN", label: "English" },
		],
		week: [
			{ value: "monday", label: "Monday", short: "Mon" },
			{ value: "tuesday", label: "Tuesday", short: "Tue" },
			{ value: "wednesday", label: "Wednesday", short: "Wed" },
			{ value: "thursday", label: "Thursday", short: "Thu" },
			{ value: "friday", label: "Friday", short: "Fri" },
			{ value: "saturday", label: "Saturday", short: "Sat" },
			{ value: "sunday", label: "Sunday", short: "Sun" },
		],
		months: [
			{ value: "01", label: "January", short: "Jan" },
			{ value: "02", label: "February", short: "Feb" },
			{ value: "03", label: "March", short: "Mar" },
			{ value: "04", label: "April", short: "Apr" },
			{ value: "05", label: "May", short: "May" },
			{ value: "06", label: "June", short: "June" },
			{ value: "07", label: "July", short: "July" },
			{ value: "08", label: "August", short: "Aug" },
			{ value: "09", label: "September", short: "Sept" },
			{ value: "10", label: "October", short: "Oct" },
			{ value: "11", label: "November", short: "Nov" },
			{ value: "12", label: "December", short: "Dec" },
		],
		measurements: [
			{ value: "KM", label: "Miles" },
			{ value: "HR", label: "Hours" },
		],
		markers: [
			{ value: "car", label: "Car", img: "car-green.svg" },
			{ value: "bus", label: "Bus", img: "bus-green.svg" },
			{ value: "truck", label: "Semi Truck", img: "truck-green.svg" },
			{ value: "sweeper", label: "Sweeper", img: "sweeper-green.svg" },
			{ value: "pickup", label: "Pickup", img: "pickup-green.svg" },
			{ value: "moto", label: "Motorcycle", img: "moto-green.svg" },
			{ value: "tesla", label: "Tesla", img: "tesla-green.svg" },
			{ value: "van", label: "Van", img: "van-green.svg" },
			{ value: "suv", label: "SUV", img: "suv-green.svg" },
			{
				value: "lighttruck",
				label: "Box Truck",
				img: "lighttruck-green.svg",
			},
			{
				value: "jettruck",
				label: "Jet Truck",
				img: "jettruck-green.svg",
			},
			{
				value: "snowplower",
				label: "Snow Plower",
				img: "snowplower-green.svg",
			},
			{ value: "flatbed", label: "Flatbed", img: "flatbed-green.svg" },
			{ value: "crane", label: "Crane", img: "crane-green.svg" },
			{ value: "forklift", label: "Forklift", img: "forklift-green.svg" },
			{
				value: "scissor",
				label: "Scissor Lift",
				img: "scissor-green.svg",
			},
			{ value: "welder", label: "Welder", img: "welder-green.svg" },
			{ value: "manlift", label: "Tow Truck", img: "manlift-green.svg" },
			{
				value: "lightplant",
				label: "Lightplant",
				img: "lightplant-green.svg",
			},
			{ value: "ram", label: "RAM", img: "ram-green.svg" },
			{ value: "tesla3", label: "Tesla 3", img: "tesla3-green.svg" },
			{
				value: "minicharger",
				label: "Mini Charger",
				img: "minicharger-green.svg",
			},
			{
				value: "excavator",
				label: "Excavator",
				img: "excavator-green.svg",
			},
			{
				value: "generator",
				label: "Generator",
				img: "generator-green.svg",
			},
			{
				value: "compressor",
				label: "Compressor",
				img: "compressor-green.svg",
			},
			{
				value: "otrailer",
				label: "Open trailer",
				img: "otrailer-green.svg",
			},
			{
				value: "ctrailer",
				label: "Closed trailer",
				img: "ctrailer-green.svg",
			},
		],
		workshifts: [
			{ value: "AM", label: "Morning" },
			{ value: "PM", label: "Evening" },
			{ value: "FULL", label: "Complete" },
		],
		alarms: [
			{
				code: "035",
				label: "Entry geofence",
				short: "Entry",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="29.764" height="20.387" viewBox="0 0 29.764 20.387"><g transform="translate(-215.031 -403.778)"><path class="a" d="M221.459,403.778a6.416,6.416,0,0,0-5.807,9.17h-.008l.054.1a6.508,6.508,0,0,0,.391.69l4.1,7.249a1.264,1.264,0,0,0,2.18.033l4.244-6.983c.223-.379.439-.735.652-1.085a6.417,6.417,0,0,0-5.808-9.17Zm0,10.095a3.666,3.666,0,1,1,3.666-3.666h0A3.666,3.666,0,0,1,221.459,413.873Z"/><path class="b" d="M220.413,413.182a3.1,3.1,0,0,0,3.76-1.37h-1.705A2.315,2.315,0,0,0,220.413,413.182Z"/><path class="b" d="M244.6,420.645l-2.939-7.32a2.328,2.328,0,0,0-2.134-1.513H228.194a6.944,6.944,0,0,1-.477,1.355l-.08.132h11.888a.849.849,0,0,1,.753.58l2.94,7.321a1.2,1.2,0,0,1-.1,1.1.789.789,0,0,1-.645.374h-4v0H237.32v0H224.379v0h-4.849a.791.791,0,0,1-.646-.374,1.2,1.2,0,0,1-.108-1.1l.4-.992-.935-1.655-.839,2.093a2.667,2.667,0,0,0,.257,2.491,2.251,2.251,0,0,0,1.877,1.027h22.93a2.25,2.25,0,0,0,1.878-1.028A2.669,2.669,0,0,0,244.6,420.645Z"/><path class="b" d="M225.02,422.179h12.187l-.9-3.951-11.385,1.343-.452,2.6h.554Z"/><path class="b" d="M219.3,422.028a.293.293,0,0,0,.242.147h3.784l.432-2.484-.966,1.589a1.771,1.771,0,0,1-.637.618,1.75,1.75,0,0,1-.867.23,1.792,1.792,0,0,1-.474-.064,1.753,1.753,0,0,1-1.064-.831l-.264-.467-.249.621A.7.7,0,0,0,219.3,422.028Z"/><path class="b" d="M227.043,414.291l-1.689,2.78-.236,1.357,10.937-1.29-.763-3.34h-7.954C227.24,413.962,227.141,414.126,227.043,414.291Z"/><path class="b" d="M242.687,422.042a.7.7,0,0,0,.068-.653l-2.941-7.324a.364.364,0,0,0-.321-.267h-3.054l1.915,8.381h4.114A.282.282,0,0,0,242.687,422.042Z"/></g></svg>',
				active: false,
				visible: false,
			},
			{
				code: "036",
				label: "Output geofence",
				short: "Exit",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="27.592" height="22.401" viewBox="0 0 27.592 22.401"><g transform="translate(-472.203 -401.764)"><path class="a" d="M499.6,420.645l-2.939-7.32a2.3,2.3,0,0,0-.708-.963l-.789,1.3a.843.843,0,0,1,.112.22l2.94,7.321a1.2,1.2,0,0,1-.109,1.1.789.789,0,0,1-.645.374H474.53a.791.791,0,0,1-.646-.374,1.2,1.2,0,0,1-.108-1.1l2.933-7.321a.851.851,0,0,1,.754-.581h14.43l-.842-1.488H477.467a2.327,2.327,0,0,0-2.135,1.514l-2.933,7.321a2.667,2.667,0,0,0,.257,2.491,2.251,2.251,0,0,0,1.877,1.027h22.93a2.251,2.251,0,0,0,1.878-1.028A2.669,2.669,0,0,0,499.6,420.645Z"/><path class="b" d="M493.736,401.764a4.543,4.543,0,0,0-4.113,6.5h-.006l.038.068a4.517,4.517,0,0,0,.277.489l2.907,5.135a.9.9,0,0,0,1.543.024l3.007-4.946c.158-.268.311-.52.461-.769a4.545,4.545,0,0,0-4.114-6.5Zm0,7.15a2.6,2.6,0,1,1,2.6-2.6h0a2.6,2.6,0,0,1-2.6,2.6Z"/><path class="a" d="M479.787,413.8l-.373,2.152-2.663-.833.433-1.08a.349.349,0,0,1,.3-.239Zm-5.547,7.588a.7.7,0,0,0,.063.641.293.293,0,0,0,.242.147h3.785l.89-5.12-2.884-.9Zm16.052-7.588h-9.369l-.8,4.629,10.937-1.29Zm-10.373,5.772-.452,2.6h12.739l-.9-3.947Zm14.4-4.855a1.389,1.389,0,0,1-.7.188,1.4,1.4,0,0,1-1.214-.7l-.231-.408h-.736l1.914,8.376h4.107a.282.282,0,0,0,.219-.136.708.708,0,0,0,.071-.652l-2.9-7.217-.043.07A1.4,1.4,0,0,1,494.32,414.716Z"/></g></svg>',
				active: false,
				visible: false,
			},
			{
				code: "002",
				label: "Engine on",
				short: "Engine on",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="21.869" height="26.086" viewBox="0 0 21.869 26.086"><g transform="translate(-728.426 -400.077)"><path class="a" d="M745.693,405.027h-.619a.309.309,0,0,1-.276-.333V400.41a.309.309,0,0,1,.276-.333h.619a.309.309,0,0,1,.276.333V404.7A.309.309,0,0,1,745.693,405.027Z"/><path class="b" d="M738.22,409.971v-4.248a1.342,1.342,0,0,0-1.372-1.311h0a1.343,1.343,0,0,0-1.371,1.311v10.586a1.342,1.342,0,0,1-1.372,1.311l-4.308-1.655a1.343,1.343,0,0,0-1.371,1.311v.289a1.3,1.3,0,0,0,.722,1.155l2.927,1.5,2.487,1.277a1.3,1.3,0,0,1,.722,1.155v2.2a1.341,1.341,0,0,0,1.37,1.311h6.189a1.341,1.341,0,0,0,1.371-1.31h0v-2.6a1.266,1.266,0,0,1,.214-.7l1.915-1.481a1.273,1.273,0,0,0,.214-.7v-5.989a1.342,1.342,0,0,0-1.372-1.311h-.007l-5.578-.8a1.342,1.342,0,0,1-1.38-1.3Z"/><path class="a" d="M745.343,409.943a5.051,5.051,0,0,1-4.869-5.192,4.894,4.894,0,0,1,2.85-4.191.229.229,0,0,1,.3.123h0l.25.619a.22.22,0,0,1-.116.282,3.8,3.8,0,1,0,3.184-.026.22.22,0,0,1-.12-.281l.24-.623a.228.228,0,0,1,.3-.13h0a4.918,4.918,0,0,1-2.026,9.417Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "003",
				label: "Engine off",
				short: "Engine off",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="22.85" height="26.976" viewBox="0 0 22.85 26.976"><g transform="translate(-983.297 -399.189)"><path class="a" d="M1004.061,403.814l1.729-1.729a1.219,1.219,0,0,0,0-1.724l-.815-.815a1.219,1.219,0,0,0-1.724,0h0l-1.729,1.729a.859.859,0,0,1-1.213,0h0l-1.729-1.729a1.217,1.217,0,0,0-1.722,0h0l-.815.815a1.219,1.219,0,0,0,0,1.724h0l1.729,1.729a.856.856,0,0,1,0,1.212h0l-1.729,1.729a1.219,1.219,0,0,0,0,1.724h0l.815.815a1.218,1.218,0,0,0,1.723,0h0l1.729-1.729a.858.858,0,0,1,1.213,0h0l1.729,1.729a1.219,1.219,0,0,0,1.724,0h0l.815-.815a1.219,1.219,0,0,0,0-1.724l-1.729-1.729a.857.857,0,0,1,0-1.212Z"/><path class="a" d="M993.09,409.972v-4.248a1.343,1.343,0,0,0-1.371-1.311h0a1.342,1.342,0,0,0-1.372,1.311V416.31a1.342,1.342,0,0,1-1.372,1.311l-4.307-1.655a1.342,1.342,0,0,0-1.372,1.311v.289a1.3,1.3,0,0,0,.722,1.155l2.928,1.5,2.486,1.277a1.3,1.3,0,0,1,.722,1.155v2.2a1.342,1.342,0,0,0,1.372,1.311h6.184a1.342,1.342,0,0,0,1.372-1.311v-2.6a1.265,1.265,0,0,1,.214-.7l1.916-1.471a1.274,1.274,0,0,0,.215-.7v-5.989a1.342,1.342,0,0,0-1.374-1.311h-.006l-5.578-.8a1.343,1.343,0,0,1-1.379-1.306Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "030",
				label: "Stop",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="30.279" height="28.225" viewBox="0 0 30.279 28.225"><path class="a" d="M1266.068,413.341l-6.724-12.225a1.888,1.888,0,0,0-1.654-.977h-12.012a4.206,4.206,0,0,0-3.686,2.18l-5.448,9.9a4.2,4.2,0,0,0,0,4.055l5.447,9.9a4.209,4.209,0,0,0,3.687,2.18h10.64a4.206,4.206,0,0,0,3.687-2.18l6.063-11.024A1.879,1.879,0,0,0,1266.068,413.341Zm-2.659,2.029-5.26,9.564a2.32,2.32,0,0,1-2.031,1.2H1254v-3.786l.005-.393a.961.961,0,0,1,.238-.622l2.87-3.276a.963.963,0,0,0,.238-.633v-4.9a.962.962,0,0,0-.962-.961h-.02a.963.963,0,0,0-.961.961v3.247h-.684v-8.93h0a.961.961,0,0,0-.961-.961h-.007a.962.962,0,0,0-.961.961v5.877h-.48V405.8a.962.962,0,0,0-.961-.961h-.106a.961.961,0,0,0-.961.961v7h-.633v-6.172a.961.961,0,1,0-1.922,0v6.506h-.559v-4a.773.773,0,0,0-1.545,0v8.67a.964.964,0,0,0,.072.367l1.281,3.107a.948.948,0,0,1,.073.356l.006.557h0v3.945h-1.181a2.318,2.318,0,0,1-2.031-1.2l-5.26-9.564a2.317,2.317,0,0,1,0-2.235l5.26-9.564a2.318,2.318,0,0,1,2.031-1.2h10.24a2.32,2.32,0,0,1,2.031,1.2l5.26,9.564A2.318,2.318,0,0,1,1263.409,415.37Z" transform="translate(-1236.024 -400.139)"/></svg>',
				active: false,
				visible: true,
			},
			{
				code: "",
				label: "Geofences",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="27.591" height="25.113" viewBox="0 0 27.591 25.113"><path class="a" d="M1495.814,413.938l-.374,2.151-2.669-.835.431-1.077a.352.352,0,0,1,.3-.239Zm-5.554,7.587a.7.7,0,0,0,.064.641.3.3,0,0,0,.243.148h3.79l.89-5.121-2.892-.9Zm23.221.789a.285.285,0,0,0,.219-.137.709.709,0,0,0,.071-.653l-2.94-7.319a.364.364,0,0,0-.321-.268h-3.051l1.914,8.377Zm-18,0h12.738l-.9-3.948-11.383,1.343Zm.652-3.752,10.937-1.29-.762-3.335h-1.282l-1.673,2.753a1.791,1.791,0,0,1-.637.619,1.768,1.768,0,0,1-2.406-.667l-1.529-2.7h-1.844Zm19.482,2.221-2.94-7.32a2.328,2.328,0,0,0-2.134-1.513h-4.307l-.905,1.488h5.208a.849.849,0,0,1,.754.58l2.94,7.321a1.2,1.2,0,0,1-.109,1.1.79.79,0,0,1-.645.375h-22.93a.79.79,0,0,1-.646-.375,1.2,1.2,0,0,1-.109-1.1l2.933-7.321a.853.853,0,0,1,.755-.58h5.018l-.842-1.488h-4.172a2.326,2.326,0,0,0-2.135,1.515l-2.934,7.321a2.669,2.669,0,0,0,.258,2.49,2.25,2.25,0,0,0,1.877,1.028h22.93a2.249,2.249,0,0,0,1.878-1.029A2.672,2.672,0,0,0,1515.619,420.783Zm-13.6-21.591a6.418,6.418,0,0,1,5.808,9.171c-.213.349-.429.706-.652,1.084l-4.244,6.983a1.265,1.265,0,0,1-2.18-.034l-4.1-7.249a6.5,6.5,0,0,1-.391-.69l-.054-.1h.008a6.417,6.417,0,0,1,5.807-9.171Zm0,10.094a3.666,3.666,0,1,0-3.666-3.666,3.666,3.666,0,0,0,3.666,3.666Z" transform="translate(-1488.224 -399.191)"/></svg>',
				active: false,
				visible: false,
			},
			{
				code: "028",
				label: "Deceleration",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="31.552" height="12.003" viewBox="0 0 31.552 12.003"><g transform="translate(-216.002 -513.061)"><path class="a" d="M221.983,522.89h-5.609a.373.373,0,0,1-.372-.372h0a.371.371,0,0,1,.372-.372h5.609a.372.372,0,0,1,0,.744Z"/><path class="a" d="M224.983,519.79h-8.609a.373.373,0,0,1-.372-.372h0a.371.371,0,0,1,.372-.372h8.609a.369.369,0,1,1,0,.738Z"/><path class="a" d="M225.193,516.655h-8.609a.372.372,0,0,1,0-.744h6.084a.342.342,0,0,0,.434.068l.113-.069h1.978a.373.373,0,0,1,.372.372h0a.371.371,0,0,1-.372.366Z"/><path class="a" d="M228.128,513.177h-8.606a.372.372,0,0,0-.374.372v.009a.365.365,0,0,0,.374.36h7.054l-.009,0h1.561v-.006a.372.372,0,0,0,.372-.368h0A.373.373,0,0,0,228.128,513.177Z"/><path class="a" d="M242.28,520.758a2.153,2.153,0,1,0,2.153,2.153A2.153,2.153,0,0,0,242.28,520.758Zm0,3.548a1.4,1.4,0,1,1,1.4-1.4A1.395,1.395,0,0,1,242.28,524.306Z"/><path class="a" d="M246.36,521.678a.263.263,0,0,1,.24-.175h.913l.035-.4a2.022,2.022,0,0,0-.039-.581l-.256-1.153a1.713,1.713,0,0,0-1.122-1.294l-5.017-1.6c-.032-.009-.059-.019-.091-.031l-.4.247a.931.931,0,0,1-.5.148.946.946,0,0,1-.638-.247l-3.444-3.038.242-.121-.2-.127a1.536,1.536,0,0,0-.817-.245h-7.019a1.526,1.526,0,0,0-.682.167l-.484.247a.406.406,0,0,1-.18.255l-3.8,2.249a.316.316,0,0,1-.174.049.382.382,0,0,1-.36-.294h-.013a.846.846,0,0,1-.109.023l-1.042.177a1.72,1.72,0,0,0-1.364,1.583l-.125,1.338a1.891,1.891,0,0,1-.266.815,1.9,1.9,0,0,0-.275.992v.466a1.9,1.9,0,0,0,.33,1.081l.081.117a1.644,1.644,0,0,0,.744.6l1.61.635a1.47,1.47,0,0,0,.549.1h.384a2.622,2.622,0,0,1-.121-.75,2.653,2.653,0,1,1,5.306,0,2.622,2.622,0,0,1-.121.75h11.612a2.622,2.622,0,0,1-.121-.75,2.653,2.653,0,1,1,5.306,0,2.619,2.619,0,0,1-.114.728,1.262,1.262,0,0,0,.164-.016l1.279-.341a1.588,1.588,0,0,0,.841-.56l-.761.083h-.026a.253.253,0,0,1-.209-.115.311.311,0,0,1-.031-.288Zm-7.909-4.9a.407.407,0,0,1-.38.276h-12.05a.41.41,0,0,1-.391-.292.476.476,0,0,1,.153-.536l3.366-2.6a.411.411,0,0,1,.238-.083h5.831a.414.414,0,0,1,.265.107l2.851,2.6A.479.479,0,0,1,238.451,516.78Z"/><path class="a" d="M225.6,520.758a2.153,2.153,0,1,0,2.153,2.153A2.153,2.153,0,0,0,225.6,520.758Zm0,3.548a1.4,1.4,0,1,1,1.395-1.4A1.395,1.395,0,0,1,225.6,524.306Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "027",
				label: "Acceleration",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="31.867" height="9.985" viewBox="0 0 31.867 9.985"><g transform="translate(-470.258 -514.078)"><path class="a" d="M481.336,523.667H470.8c-.3,0-.54-.166-.54-.371s.242-.373.54-.373h10.536c.3,0,.543.167.543.373S481.636,523.667,481.336,523.667Z"/><path class="a" d="M481.336,520.686H470.8c-.3,0-.54-.166-.54-.371s.242-.373.54-.373h10.536c.3,0,.543.167.543.373s-.24.366-.54.366Z"/><path class="a" d="M483.643,517.551H471.108c-.3,0-.543-.166-.543-.371s.243-.371.543-.371h12.535c.3,0,.541.166.541.371s-.243.366-.54.366Z"/><path class="a" d="M487.125,514.822H485.4a.33.33,0,0,0,.094-.17l-.333.17h-9.778c-.3,0-.54-.166-.54-.371s.242-.373.54-.373h12.536c.3,0,.543.167.543.373a.324.324,0,0,1-.167.267h-.927a.322.322,0,0,0-.193.066l-.048.038Z"/><path class="a" d="M497.837,520.567a1.748,1.748,0,1,0,1.748,1.748A1.748,1.748,0,0,0,497.837,520.567Zm0,2.91a1.168,1.168,0,1,1,1.168-1.168A1.168,1.168,0,0,1,497.837,523.477Z"/><path class="a" d="M501.15,521.306a.211.211,0,0,1,.2-.139h.741l.028-.322a1.586,1.586,0,0,0-.03-.471l-.208-.938a1.4,1.4,0,0,0-.914-1.051l-4.072-1.3a.389.389,0,0,1-.054-.019l-.017-.007-.322.2a.751.751,0,0,1-.411.119.778.778,0,0,1-.517-.2l-2.8-2.468.2-.1-.162-.1a1.246,1.246,0,0,0-.665-.2h-5.7a1.211,1.211,0,0,0-.556.135l-.395.2a.309.309,0,0,1-.145.205l-3.083,1.828a.288.288,0,0,1-.142.038.315.315,0,0,1-.292-.238c-.034.007-.067.015-.1.02l-.845.145a1.4,1.4,0,0,0-1.107,1.286l-.1,1.085a1.515,1.515,0,0,1-.216.662,1.516,1.516,0,0,0-.223.806v.375a1.575,1.575,0,0,0,.266.875l.069.1a1.3,1.3,0,0,0,.6.487l1.307.517a1.177,1.177,0,0,0,.446.084h.213a2.226,2.226,0,0,1-.094-.608,2.248,2.248,0,0,1,4.5,0,2.225,2.225,0,0,1-.094.608h9.232a2.225,2.225,0,0,1-.094-.608,2.248,2.248,0,0,1,4.5,0,2.217,2.217,0,0,1-.083.573c.01,0,.021,0,.031,0l1.04-.274a1.287,1.287,0,0,0,.681-.457l-.616.069h-.021a.2.2,0,0,1-.171-.095.242.242,0,0,1-.026-.23Zm-6.421-3.963a.333.333,0,0,1-.309.223h-9.787a.333.333,0,0,1-.314-.239.382.382,0,0,1,.122-.434l2.733-2.115a.315.315,0,0,1,.193-.066H492.1a.33.33,0,0,1,.216.084l2.316,2.115A.392.392,0,0,1,494.729,517.343Z"/><path class="a" d="M484.3,520.567a1.748,1.748,0,1,0,1.748,1.748A1.748,1.748,0,0,0,484.3,520.567Zm0,2.91a1.168,1.168,0,1,1,1.168-1.168A1.168,1.168,0,0,1,484.3,523.477Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "037",
				label: "Minimum unfulfilled time",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18.191" height="25.117" viewBox="0 0 18.191 25.117"><g transform="translate(-731.678 -507.024)"><path class="a" d="M747.347,532.141H734.2a2.524,2.524,0,0,1-2.52-2.52v-4.2a2.518,2.518,0,0,1,1.081-2.069l3.325-2.313a1.378,1.378,0,0,0-.058-2.3l-2.858-1.785a2.507,2.507,0,0,1-1.185-2.138v-5.272a2.522,2.522,0,0,1,2.519-2.52h12.846a2.524,2.524,0,0,1,2.521,2.52v5.292A2.53,2.53,0,0,1,748.624,517l-2.967,1.739a1.369,1.369,0,0,0-.681,1.144,1.351,1.351,0,0,0,.6,1.186l3.186,2.163a2.521,2.521,0,0,1,1.1,2.085v4.3A2.524,2.524,0,0,1,747.347,532.141ZM734.5,508.161a1.38,1.38,0,0,0-1.377,1.378v5.272a1.371,1.371,0,0,0,.647,1.17l2.859,1.785a2.52,2.52,0,0,1,.1,4.206l-3.325,2.314a1.381,1.381,0,0,0-.591,1.132v4.2A1.38,1.38,0,0,0,734.2,531h13.149a1.38,1.38,0,0,0,1.379-1.378v-4.3a1.378,1.378,0,0,0-.6-1.14l-3.186-2.164a2.519,2.519,0,0,1,.142-4.259l2.967-1.738a1.384,1.384,0,0,0,.682-1.19v-5.292a1.38,1.38,0,0,0-1.379-1.378Z"/><path class="a" d="M733.935,527.382v2.125a.377.377,0,0,0,.377.377h12.922a.379.379,0,0,0,.377-.377v-2.125Z"/></g></svg>',
				active: false,
				visible: false,
			},
			{
				code: "038",
				label: "Maximum time exceeded",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18.191" height="25.117" viewBox="0 0 18.191 25.117"><g transform="translate(-986.678 -507.024)"><path class="a" d="M1002.347,532.141H989.2a2.524,2.524,0,0,1-2.52-2.52v-4.2a2.521,2.521,0,0,1,1.081-2.069l3.325-2.313a1.378,1.378,0,0,0-.058-2.3l-2.858-1.785a2.507,2.507,0,0,1-1.185-2.138v-5.272a2.522,2.522,0,0,1,2.519-2.52h12.846a2.524,2.524,0,0,1,2.521,2.52v5.292a2.531,2.531,0,0,1-1.246,2.174l-2.967,1.739a1.369,1.369,0,0,0-.681,1.144,1.351,1.351,0,0,0,.6,1.186l3.186,2.163a2.521,2.521,0,0,1,1.1,2.085v4.3A2.525,2.525,0,0,1,1002.347,532.141ZM989.5,508.161a1.379,1.379,0,0,0-1.378,1.378v5.272a1.371,1.371,0,0,0,.647,1.17l2.859,1.785a2.52,2.52,0,0,1,.1,4.206l-3.325,2.314a1.381,1.381,0,0,0-.591,1.132v4.2A1.38,1.38,0,0,0,989.2,531h13.149a1.38,1.38,0,0,0,1.379-1.378v-4.3a1.375,1.375,0,0,0-.6-1.14l-3.186-2.164a2.52,2.52,0,0,1,.143-4.259l2.966-1.738a1.385,1.385,0,0,0,.682-1.19v-5.292a1.38,1.38,0,0,0-1.379-1.378Z"/><path class="a" d="M1002.233,529.885H989.311a.376.376,0,0,1-.375-.378v-4.031a.375.375,0,0,1,.161-.31l3.277-2.279a3.631,3.631,0,0,0,1.447-3.879,3.78,3.78,0,0,0-1.718-2.262l-2.686-1.677a.377.377,0,0,1-.178-.32v-5.1a.379.379,0,0,1,.378-.378h8.449l.618.708-1.394,1.458,1,1.725-1,2.255,2.421-2.455-1.027-1.393,2.64-2.3h.909a.379.379,0,0,1,.378.378v5.113a.384.384,0,0,1-.186.325l-2.911,1.706a3.621,3.621,0,0,0-1.74,3.8,3.727,3.727,0,0,0,1.634,2.414l3.037,2.062a.376.376,0,0,1,.166.313V529.5a.379.379,0,0,1-.377.381Z"/></g></svg>',
				active: false,
				visible: false,
			},
			{
				code: "997",
				label: "Engine error",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24.938" height="24.939" viewBox="0 0 24.938 24.939"><g transform="translate(-1238.402 -503.85)"><path class="a" d="M1263.274,527.878l-11.857-23.68a.629.629,0,0,0-1.125,0l-11.823,23.68a.629.629,0,0,0,.563.911h23.68a.629.629,0,0,0,.562-.911Zm-11.139-2.357a.87.87,0,0,1-.87.87h-.462a.871.871,0,0,1-.87-.87v-.727a.87.87,0,0,1,.87-.87h.462a.869.869,0,0,1,.87.87Zm0-3.749a.674.674,0,0,1-.674.674h-.854a.674.674,0,0,1-.674-.674v-8.629a.674.674,0,0,1,.674-.674h.854a.674.674,0,0,1,.674.674Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "026",
				label: "Revolutions per minute",
				short: "RPM",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="25.35" height="26.264" viewBox="0 0 25.35 26.264"><g transform="translate(-218.326 -608.23)"><path class="a" d="M236.452,623.073a.885.885,0,0,1-.519-.037l-5.174-1.991a1.165,1.165,0,0,1-.716-.823l-1.2-5.185a.888.888,0,0,1,1.713-.467c.006.022.012.044.016.067l.988,4.266a1.167,1.167,0,0,0,.716.823l4.247,1.634a.923.923,0,0,1,.6,1.036A.89.89,0,0,1,236.452,623.073Z"/><path class="a" d="M219.53,627.047a.753.753,0,0,1,.671-.752c.517-.052,1.138-.084,1.8-.084a4.2,4.2,0,0,1,2.658.647,2.087,2.087,0,0,1,.756,1.719,2.183,2.183,0,0,1-1.451,2.025v.036a2.077,2.077,0,0,1,1.1,1.537c.125.455.251.945.365,1.364a.754.754,0,0,1-.528.926.77.77,0,0,1-.2.027h-.349a.747.747,0,0,1-.718-.517c-.106-.339-.231-.81-.372-1.4-.22-1.025-.574-1.3-1.329-1.317h-.561v2.475a.756.756,0,0,1-.756.756h-.328a.755.755,0,0,1-.756-.756h0Zm1.841,2.871h.732c.927,0,1.476-.463,1.476-1.183,0-.756-.512-1.135-1.366-1.146a4.735,4.735,0,0,0-.841.06Z"/><path class="a" d="M226.765,627.047a.759.759,0,0,1,.689-.754c.486-.049,1.084-.079,1.823-.079a3.938,3.938,0,0,1,2.512.658,2.4,2.4,0,0,1,.879,1.9,2.624,2.624,0,0,1-.757,1.951,3.806,3.806,0,0,1-2.67.865,4.816,4.816,0,0,1-.635-.036v2.183a.757.757,0,0,1-.756.756h-.333a.756.756,0,0,1-.756-.756h0Zm1.841,3.069a2.822,2.822,0,0,0,.622.048c.988,0,1.6-.5,1.6-1.341,0-.756-.524-1.207-1.451-1.207a3.152,3.152,0,0,0-.769.073Z"/><path class="a" d="M240.634,631.343c-.037-.988-.074-2.183-.074-3.378h-.036c-.256,1.049-.6,2.22-.915,3.183l-.836,2.676a.756.756,0,0,1-.722.532h-.318A.757.757,0,0,1,237,633.8l-.725-2.628c-.268-.963-.548-2.134-.744-3.207h-.024c-.049,1.11-.085,2.378-.147,3.4l-.112,2.4a.757.757,0,0,1-.756.721H234.3a.756.756,0,0,1-.756-.758v-.042l.428-6.706a.758.758,0,0,1,.756-.708h1.2a.757.757,0,0,1,.726.543l.645,2.2c.256.951.512,1.976.695,2.94h.037c.231-.951.512-2.037.78-2.951l.709-2.207a.755.755,0,0,1,.72-.525H241.4a.757.757,0,0,1,.756.715l.369,6.706a.757.757,0,0,1-.713.8h-.333a.757.757,0,0,1-.756-.727Z"/><path class="a" d="M240.316,612.23,238,614.806a9.351,9.351,0,0,1,.948,1.306l3.252-1.286A12.737,12.737,0,0,0,240.316,612.23Z"/><path class="a" d="M243.676,621.913h-3.463a9.144,9.144,0,0,1-.8,2.843h3.706A12.631,12.631,0,0,0,243.676,621.913Z"/><path class="a" d="M232.314,611.722a9.18,9.18,0,0,1,3.741,1.393l2.327-2.585a12.628,12.628,0,0,0-6.068-2.3Z"/><path class="a" d="M239.95,618.482c.075.281.136.566.185.856h3.488a12.616,12.616,0,0,0-.441-2.134Z"/><path class="a" d="M222.647,624.756a9.221,9.221,0,0,1,7.092-13.033v-3.487a12.692,12.692,0,0,0-10.8,16.52Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "025",
				label: "Idle",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20.002" height="27.644" viewBox="0 0 20.002 27.644"><g transform="translate(-475.999 -608.525)"><path class="a" d="M495.776,625a.286.286,0,0,0,.222-.319l-.071-.481a.286.286,0,0,0-.266-.243l-1.193-.065a.283.283,0,0,0-.146.031l-.324.167a.274.274,0,0,0-.133.3l-1.645-2.829a2.067,2.067,0,0,0-1.788-1.028H481.57a2.066,2.066,0,0,0-1.785,1.033l-1.651,2.862a.28.28,0,0,0-.133-.34l-.324-.167a.283.283,0,0,0-.146-.031l-1.193.065a.286.286,0,0,0-.266.243l-.07.481a.284.284,0,0,0,.222.319l1.3.281a.272.272,0,0,0,.129-.017l-1.08,1.872a2.058,2.058,0,0,0-.276,1.007l-.044,3.557a2.052,2.052,0,0,0,.348,1.165,1.06,1.06,0,0,0-.218.619v1.6a1.083,1.083,0,1,0,2.167,0v-1.259l7.377.653v.009l.055-.005.054.005-.006-.007,7.46-.654v1.258a1.084,1.084,0,1,0,2.167,0v-1.6a1.061,1.061,0,0,0-.218-.62,2.061,2.061,0,0,0,.346-1.163l-.045-3.552a2.078,2.078,0,0,0-.28-1.014l-1.086-1.867a.269.269,0,0,0,.1.013Zm-17.312-.273,1.82-3.272a.447.447,0,0,1,.39-.229h10.674a.447.447,0,0,1,.387.223l1.884,3.272a.446.446,0,0,1-.387.669H478.855a.446.446,0,0,1-.391-.663Zm2.38,4.565a.294.294,0,0,1-.157.031l-3.721-.3a.291.291,0,0,1-.266-.314.283.283,0,0,1,.024-.1l.522-1.171a.292.292,0,0,1,.326-.166l2.724.573a.291.291,0,0,1,.2.149l.475.9A.292.292,0,0,1,480.844,629.3Zm8.592.264-3.393.345-3.312-.306-1.036-1.4h8.635Zm5.352-2.113.523,1.171a.29.29,0,0,1-.243.409l-3.721.3a.288.288,0,0,1-.165-.035.292.292,0,0,1-.116-.4l.475-.9a.291.291,0,0,1,.2-.149l2.721-.566A.291.291,0,0,1,494.788,627.447Z"/><rect class="a" width="3.575" height="10.213" rx="1.005" transform="translate(481.148 608.525)"/><rect class="a" width="3.575" height="10.213" rx="1.005" transform="translate(487.276 608.525)"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "071",
				label: "Route deviation",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="29.392" height="26.504" viewBox="0 0 29.392 26.504"><path class="a" d="M755.737,632.321l-2.266-13.014a1.355,1.355,0,0,0-1.338-1.126H730.441a1.363,1.363,0,0,0-1.329,1.082l-2.718,13.014a1.357,1.357,0,0,0,1.329,1.635H754.4a1.358,1.358,0,0,0,1.339-1.591Zm-8.391-10.832.008.074a.747.747,0,0,1-.663.82h-.072a.74.74,0,0,1-.738-.664l-.007-.074a.743.743,0,0,1,.659-.82c.023,0,.047,0,.071,0A.739.739,0,0,1,747.346,621.489Zm-1.555-2.894h.071a.738.738,0,0,1,.747.666l.01.074a.74.74,0,0,1-.66.817h-.082a.744.744,0,0,1-.738-.663l-.009-.074A.749.749,0,0,1,745.791,618.595ZM731.258,631.8a.794.794,0,0,1-.744.587.59.59,0,0,1-.172-.022.763.763,0,0,1-.458-.326.684.684,0,0,1-.082-.545l.021-.072a.743.743,0,0,1,.718-.554h0a.753.753,0,0,1,.641.369A.737.737,0,0,1,731.258,631.8Zm.583-2.234a.8.8,0,0,1-.746.594.635.635,0,0,1-.168-.022l-.026-.006a.711.711,0,0,1-.518-.863l.019-.072a.741.741,0,0,1,.718-.558h0a.723.723,0,0,1,.185.024.744.744,0,0,1,.536.9Zm.9-1.542a.8.8,0,0,1-.5.173.726.726,0,0,1-.567-.255l-.012-.014a.712.712,0,0,1,.077-1l.069-.059a.747.747,0,0,1,.467-.165h0a.746.746,0,0,1,.466,1.325Zm1.691-.557h-.074a.744.744,0,1,1,0-1.488h.074a.744.744,0,0,1,0,1.488Zm2.3,0a.775.775,0,0,1-.782-.745c0-.011,0-.021,0-.032a.71.71,0,0,1,.709-.711h.074a.744.744,0,0,1,0,1.488Zm2.3,0h-.072a.744.744,0,1,1,0-1.488h.072a.744.744,0,1,1,0,1.488Zm2.3,0h-.077a.744.744,0,0,1,0-1.488h.077a.744.744,0,0,1,0,1.488Zm2.323,0h-.1a.744.744,0,0,1,0-1.488l.014,0a.8.8,0,0,1,.809.72A.75.75,0,0,1,743.662,627.467Zm2.589-1.046-.06.055a.735.735,0,0,1-.5.193.743.743,0,0,1-.743-.788.731.731,0,0,1,.245-.507l.05-.047a.737.737,0,0,1,.494-.2.747.747,0,0,1,.753.778A.739.739,0,0,1,746.251,626.421Zm1.248-2.435v.059a.744.744,0,0,1-.734.636.568.568,0,0,1-.108-.01.743.743,0,0,1-.489-.291.735.735,0,0,1-.14-.551l.01-.054a.742.742,0,0,1,.738-.656c.026,0,.052,0,.077.005a.75.75,0,0,1,.652.829A.189.189,0,0,0,747.5,623.986Zm-1.65-6.958.008.074a.744.744,0,0,1-.659.819.752.752,0,0,1-.082,0,.741.741,0,0,1-.737-.663l-.008-.074a.743.743,0,0,1,1.478-.16Zm.008-2.157a.743.743,0,0,1-.658.819h0a.752.752,0,0,1-.082,0,.741.741,0,0,1-.737-.663l-.008-.074a.743.743,0,1,1,1.478-.159Zm-4.54-5.559a1.115,1.115,0,0,1,1.577-1.577l2.219,2.218,2.214-2.214a1.115,1.115,0,0,1,1.577,1.577l-2.214,2.215,2.214,2.214a1.116,1.116,0,0,1-.788,1.9v0a1.11,1.11,0,0,1-.788-.327l-2.215-2.214-2.218,2.218a1.115,1.115,0,0,1-1.577-1.577l2.219-2.218Z" transform="translate(-726.365 -607.408)"/></svg>',
				active: false,
				visible: false,
			},
			{
				code: "007",
				label: "Low battery",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="17.854" height="29.789" viewBox="0 0 17.854 29.789"><path class="a" d="M1002.233,629.577h-12.7v3.565a.966.966,0,0,0,1.009.9h10.68a1,1,0,0,0,1.012-.924Zm-4.446,2.307h-3.811v-.743h3.811Zm6.077-21.32h-3.615a.943.943,0,0,1-.943-.944.945.945,0,0,0-.945-.944h-5.03a.945.945,0,0,0-.944.944.944.944,0,0,1-.944.944H987.9a.944.944,0,0,0-.943.944v26.013a.944.944,0,0,0,.943.944h15.967a.945.945,0,0,0,.945-.944V611.508A.945.945,0,0,0,1003.864,610.564Zm-1.131,22.577a1.47,1.47,0,0,1-1.534,1.4H990.563a1.47,1.47,0,0,1-1.53-1.4v-.623c0-.013,0-.025,0-.038V616.609a2.062,2.062,0,0,1,2.059-2.058h9.58a2.06,2.06,0,0,1,2.016,1.646,2.009,2.009,0,0,1,.044.42v12.46h0ZM997.906,617.9h-1.052a.482.482,0,0,1-.482-.482h0v-1.053h-.743v1.053a.482.482,0,0,1-.482.482h-1.052v.743h1.052a.482.482,0,0,1,.482.482h0v1.052h.743v-1.052a.484.484,0,0,1,.482-.483h1.052Z" transform="translate(-986.954 -608.676)"/></svg>',
				active: false,
				visible: true,
			},
			{
				code: "006",
				label: "GPS Unplugged",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="17.852" height="29.787" viewBox="0 0 17.852 29.787"><path class="a" d="M1259.806,613.417h-17.852v-1.606a.943.943,0,0,1,.943-.943h3.547a.943.943,0,0,0,.942-.943.945.945,0,0,1,.946-.943h5.029a.943.943,0,0,1,.942.943.944.944,0,0,0,.944.943h3.617a.943.943,0,0,1,.942.943Zm-17.852,24.409a.943.943,0,0,0,.943.943h15.967a.943.943,0,0,0,.941-.944v-1.54h-17.851Zm0-23.909v12.409h0l7.38-4.607a1.605,1.605,0,0,1,2.456,1.362V626.1l8.014-4.908v-7.28Zm10.628,3.56h-1.052a.482.482,0,0,0-.482.482v1.052h-.744v-1.052h0a.482.482,0,0,0-.482-.482h-1.052v-.743h1.052a.482.482,0,0,0,.482-.482V615.2h.744v1.053h0a.482.482,0,0,0,.482.482h1.052Zm7.223,6.329-7.8,4.777a1.6,1.6,0,0,1-2.445-1.364v-3.012l-7.607,4.75v6.828h17.852V623.806Zm-7.223,8.754h-3.813v-.743h3.813Z" transform="translate(-1241.954 -608.982)"/></svg>',
				active: false,
				visible: true,
			},
			{
				code: "032",
				label: "Overspeed",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="31.545" height="28.278" viewBox="0 0 31.545 28.278"><path class="a" d="M231.8,736.221a.414.414,0,0,1-.4.532l-.224,0a.415.415,0,0,1-.4-.527l.209-.748c.1-.348.118-.512.207-.868h.164c.089.356.119.509.226.865Zm10.483-2.152v4.477a2.931,2.931,0,0,1-2.931,2.931h-18.2a2.931,2.931,0,0,1-2.931-2.931v-4.477a2.931,2.931,0,0,1,2.931-2.931h18.2A2.931,2.931,0,0,1,242.28,734.069Zm-14.3,4.811-.284-5.18a.415.415,0,0,0-.415-.392H226.2a.415.415,0,0,0-.4.287l-.549,1.71c-.2.668-.4,1.457-.571,2.157h-.026c-.133-.7-.321-1.448-.508-2.148l-.5-1.708a.415.415,0,0,0-.4-.3H222.14a.415.415,0,0,0-.414.388l-.33,5.18v.026a.415.415,0,0,0,.415.415h.419a.413.413,0,0,0,.415-.4l.089-1.887c.044-.749.071-1.676.107-2.488h.017c.144.785.344,1.645.544,2.345l.558,2.023a.415.415,0,0,0,.4.3h.44a.413.413,0,0,0,.4-.291l.641-2.054c.232-.7.481-1.56.668-2.327h.027c0,.87.027,1.748.054,2.47l.068,1.906a.416.416,0,0,0,.415.4h.514A.414.414,0,0,0,227.978,738.88Zm5.934-.109-1.607-5.18a.414.414,0,0,0-.4-.292h-1.171a.413.413,0,0,0-.4.293l-1.583,5.18a.433.433,0,0,0-.018.124.415.415,0,0,0,.418.412h.532a.417.417,0,0,0,.4-.3l.259-.935a.416.416,0,0,1,.393-.316h1.1a.417.417,0,0,1,.4.3l.286.951a.414.414,0,0,0,.4.3h.591a.438.438,0,0,0,.125-.018A.416.416,0,0,0,233.912,738.771Zm5.126-.084-1.3-2.246a.411.411,0,0,1,0-.415l1.215-2.1a.414.414,0,0,0-.359-.622h-.568a.414.414,0,0,0-.376.24l-.4.856c-.151.349-.267.617-.41,1h-.017c-.143-.34-.277-.634-.455-1l-.413-.861a.415.415,0,0,0-.374-.235h-.589a.414.414,0,0,0-.361.618l1.211,2.145a.416.416,0,0,1,0,.41l-1.267,2.215a.411.411,0,0,0-.054.2.415.415,0,0,0,.415.415h.57a.415.415,0,0,0,.377-.241l.388-.847c.187-.419.339-.731.464-1.079h.017c.169.348.312.66.535,1.079l.429.859a.413.413,0,0,0,.371.229l.592,0a.411.411,0,0,0,.208-.056A.415.415,0,0,0,239.038,738.687Zm-3.045-14.97-6.468-.616h0c-.083-.008-.167-.012-.251-.012a2.526,2.526,0,1,0,1.42,4.614h0l5.447-3.361a.338.338,0,0,0-.148-.625Zm-17.4,3.454a10.9,10.9,0,0,1,.537-2.01.793.793,0,0,0-.391-.969l-1.783-.927a.8.8,0,0,0-1.078.343.731.731,0,0,0-.05.119,15.814,15.814,0,0,0-.751,3.263.79.79,0,0,0,.7.869c.03,0,.06,0,.09,0H217.8A.807.807,0,0,0,218.594,727.171Zm2.3-5.106a11.082,11.082,0,0,1,1.915-1.865.786.786,0,0,0,.178-1.037l-1.278-2.071a.8.8,0,0,0-1.1-.257.73.73,0,0,0-.11.082,15.966,15.966,0,0,0-2.863,3.227.79.79,0,0,0,.236,1.092.714.714,0,0,0,.07.04l1.951,1.015A.807.807,0,0,0,220.894,722.065Zm11.475-3.7a10.98,10.98,0,0,1,2.647,1.114.785.785,0,0,0,1.025-.231l2.342-3.22a.8.8,0,0,0-.291-1.185,15.779,15.779,0,0,0-5.361-1.636.79.79,0,0,0-.865.707c0,.021,0,.043,0,.064l-.1,3.593A.806.806,0,0,0,232.369,718.361Zm5.392,3.392a9.565,9.565,0,0,1,2.572,5.417.791.791,0,0,0,.789.692h4.7a.793.793,0,0,0,.8-.788c0-.027,0-.054,0-.08a14.8,14.8,0,0,0-5.212-9.871.8.8,0,0,0-1.17.13l-2.535,3.485A.807.807,0,0,0,237.761,721.753Zm-8.908-3.761a.845.845,0,0,0,.7-.711h0l.089-3.243a.8.8,0,0,0-.78-.82.811.811,0,0,0-.14.009,15.806,15.806,0,0,0-4.845,1.455.8.8,0,0,0-.39,1.062.808.808,0,0,0,.044.082L225,718.211a.806.806,0,0,0,.953.329,10.936,10.936,0,0,1,2.9-.549Z" transform="translate(-215.074 -713.199)"/></svg>',
				active: false,
				visible: true,
			},
			{
				code: "004",
				label: "Open door",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18.84" height="29.637" viewBox="0 0 18.84 29.637"><g transform="translate(-475.1 -713.352)"><path class="a" d="M479.529,725l-3.449,5.3a1.168,1.168,0,0,1-.98.532l3.379-5.251a1.174,1.174,0,0,1,.714-.505Zm14.4.006a.085.085,0,0,1-.109.051l-1.062-.4v14.544a3.789,3.789,0,0,1-3.783,3.783h-5.667a3.788,3.788,0,0,1-3.784-3.784v-8.369h.555l.078,4.869a.174.174,0,0,0,.173.176.172.172,0,0,0,.127-.052l1.178-1.177a.176.176,0,0,0,.051-.124v-3.691h0v-2.448a1.125,1.125,0,0,0-.079-.421l-1.45-3.756v.145a.086.086,0,0,1-.057.081l-1.665.62a.086.086,0,0,1-.11-.049.088.088,0,0,1,0-.062l.14-.348a.084.084,0,0,1,.044-.047l1.295-.573a.089.089,0,0,0,.034-.027l.131-.177a.231.231,0,0,0-.193-.112.25.25,0,0,0-.254.219v-6.748a3.787,3.787,0,0,1,3.784-3.781h5.667a3.787,3.787,0,0,1,3.784,3.781v6.981l.987.437a.1.1,0,0,1,.044.047l.139.348A.088.088,0,0,1,493.934,725.006Zm-13.431-8.2,2.321-2.5a.242.242,0,0,0,.044-.065l.081-.171a.258.258,0,0,0-.12-.343.255.255,0,0,0-.18-.016l-.616.164a4.689,4.689,0,0,0-2.016,2.065l-.133.575a.257.257,0,0,0,.169.3l.18.06A.257.257,0,0,0,480.5,716.806Zm2.348,9.965h6.589a1.224,1.224,0,0,0,1.193-.951l.863-3.756a1.226,1.226,0,0,0-.919-1.469c-.032-.007-.065-.013-.1-.018l-4.148-.6a1.26,1.26,0,0,0-.368,0l-4.164.66a1.224,1.224,0,0,0-1.017,1.4c0,.029.01.058.017.086l.86,3.7A1.226,1.226,0,0,0,482.851,726.771Zm7.71,11.213-.268-1.548a1.225,1.225,0,0,0-1.207-1.016h-5.954a1.223,1.223,0,0,0-1.2.971l-.328,1.55a1.242,1.242,0,0,0-.022.149,1.225,1.225,0,0,0,1.116,1.325l3.3.282a1.079,1.079,0,0,0,.212,0l3.25-.284c.034,0,.068-.007.1-.013A1.225,1.225,0,0,0,490.561,737.984Zm1.543-14.119a.175.175,0,0,0-.345-.046l-1.177,4.323a.175.175,0,0,0-.006.046v6.335a.175.175,0,0,0,.051.124l1.178,1.177a.174.174,0,0,0,.247,0,.171.171,0,0,0,.052-.119Zm.2-7.344-.21-.912a4.692,4.692,0,0,0-1.727-1.671l-.828-.221a.257.257,0,0,0-.316.179.255.255,0,0,0,.016.18l.081.171a.24.24,0,0,0,.044.065l2.321,2.5a.255.255,0,0,0,.269.069l.181-.06A.257.257,0,0,0,492.3,716.521Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "",
				label: "Maintenance",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24.703" height="24.701" viewBox="0 0 24.703 24.701"><g transform="translate(-1494.018 -612.009)"><path class="a" d="M1497.109,615.88v-3.093a.772.772,0,0,1,1.544-.013v.013h0v3.093a.772.772,0,0,1-1.544.013Z"/><path class="a" d="M1510.23,616.651a.77.77,0,0,0,.772-.765v-3.1a.772.772,0,1,0-1.545,0v3.093a.77.77,0,0,0,.768.772h.005Z"/><rect class="a" width="3.09" height="3.089" transform="translate(1497.108 621.286)"/><rect class="a" width="3.089" height="3.085" transform="translate(1497.109 625.918)"/><rect class="a" width="3.092" height="3.089" transform="translate(1501.738 621.286)"/><rect class="a" width="3.092" height="3.089" transform="translate(1501.738 625.918)"/><path class="a" d="M1495.564,630.4V619.738h16.988v3.093h1.545v-6.022a1.684,1.684,0,0,0-1.668-1.7h-.649v.772a1.547,1.547,0,1,1-3.093.081h0v-.853h-9.266v.772a1.547,1.547,0,1,1-3.093.078q0-.039,0-.078v-.772h-.638a1.685,1.685,0,0,0-1.672,1.7v0h0V630.4a1.686,1.686,0,0,0,1.672,1.695h9.14v-1.541h-9.14a.146.146,0,0,1-.129-.151Z"/><rect class="a" width="3.09" height="3.089" transform="translate(1506.375 621.286)"/><path class="a" d="M1517.743,629.713h-.015l-.211-.011a.344.344,0,0,1-.307-.266,5.086,5.086,0,0,0-.3-.881.342.342,0,0,1,.078-.4l.164-.145a1.062,1.062,0,0,0,.094-1.5h0l-.115-.129a1.061,1.061,0,0,0-1.5-.094l0,0h0l-.163.144a.334.334,0,0,1-.4.031,4.954,4.954,0,0,0-.837-.41.343.343,0,0,1-.223-.338l.012-.211a1.065,1.065,0,0,0-1-1.128h0l-.169-.013a1.068,1.068,0,0,0-1.129,1l-.011.211a.345.345,0,0,1-.266.307,5.172,5.172,0,0,0-.881.3.344.344,0,0,1-.4-.079l-.146-.161a1.061,1.061,0,0,0-1.5-.1l0,0h0l-.127.108a1.06,1.06,0,0,0-.1,1.5l0,0h0l.145.163a.345.345,0,0,1,.031.4,4.911,4.911,0,0,0-.41.837.344.344,0,0,1-.343.224l-.211-.012a1.064,1.064,0,0,0-1.129.995v.005l-.011.168a1.064,1.064,0,0,0,.995,1.129h.005l.21.012a.349.349,0,0,1,.308.265,5,5,0,0,0,.3.881.343.343,0,0,1-.078.4l-.163.145a1.062,1.062,0,0,0-.1,1.5l0,0h0l.108.129a1.063,1.063,0,0,0,1.5.092h0l.164-.144a.334.334,0,0,1,.4-.031,4.929,4.929,0,0,0,.839.41.337.337,0,0,1,.223.338l-.012.211a1.065,1.065,0,0,0,1,1.128h0l.168.013a1.066,1.066,0,0,0,1.129-1h0l.012-.211a.344.344,0,0,1,.266-.307,5,5,0,0,0,.881-.3.344.344,0,0,1,.4.079l.144.164a1.063,1.063,0,0,0,1.5.093h0l.127-.115a1.062,1.062,0,0,0,.094-1.5h0l-.144-.163a.342.342,0,0,1-.031-.4,4.915,4.915,0,0,0,.41-.837.344.344,0,0,1,.338-.223l.212.012a1.067,1.067,0,0,0,1.129-1l.011-.169A1.057,1.057,0,0,0,1517.743,629.713Zm-5.192,3.389a2.558,2.558,0,1,1,2.558-2.559h0A2.559,2.559,0,0,1,1512.551,633.1Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "999",
				label: "GPS signal lost",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="23.357" height="27.31" viewBox="0 0 23.357 27.31"><g transform="translate(-727.486 -715.341)"><path class="a" d="M740.445,730.764l-5.026-5.025A5.609,5.609,0,0,0,740.445,730.764Z"/><path class="a" d="M749.893,729.378c-.328.536-.66,1.081-1,1.66l-1.9,3.12-3.808-3.808a5.61,5.61,0,1,0-7.353-7.356l-3.1-3.108a9.826,9.826,0,0,1,17.164,9.492Zm-20.5-10.591a1.115,1.115,0,0,0-1.577,1.577l3.448,3.448a9.723,9.723,0,0,0,.85,5.567H732.1l.082.145a9.723,9.723,0,0,0,.6,1.056l6.279,11.09a1.933,1.933,0,0,0,3.335.052l2.563-4.215,2.711,2.711a1.108,1.108,0,0,0,.788.327v0a1.115,1.115,0,0,0,.788-1.9Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "001",
				label: "SOS button",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="28.975" height="29.109" viewBox="0 0 28.975 29.109"><g transform="translate(-980.385 -711.449)"><path class="a" d="M986.8,735.692a2.433,2.433,0,1,0,2.435,2.433A2.434,2.434,0,0,0,986.8,735.692Zm0,3.939a1.505,1.505,0,1,1,1.506-1.505A1.505,1.505,0,0,1,986.806,739.631Zm17.866-3.939a2.433,2.433,0,1,0,2.435,2.433A2.434,2.434,0,0,0,1004.672,735.692Zm0,3.939a1.505,1.505,0,1,1,1.506-1.505A1.505,1.505,0,0,1,1004.672,739.631Zm4.509-3.654h-.088v-.284h0v-2.615h-.013a.938.938,0,0,0-.565-.822l-2.383-.837a.837.837,0,0,1-.453-.407l-1.777-3.388a.785.785,0,0,0-.683-.448h-2.7a.883.883,0,0,1-.8-.945v-2.175a.883.883,0,0,0-.8-.943H981.188a.881.881,0,0,0-.8.943v13.126a.883.883,0,0,0,.8.945h2.682v0a2.935,2.935,0,0,1,5.87,0v0h12v0a2.928,2.928,0,0,1,5.847-.227l.505-.419h.869a.185.185,0,0,0,.172-.159l.222-1.087a.153.153,0,0,0,.007-.036A.2.2,0,0,0,1009.181,735.977Zm-14.1-4.478a.535.535,0,0,1-.535.533h-1.977a.534.534,0,0,0-.534.533v1.978a.535.535,0,0,1-.533.533h-1.772a.536.536,0,0,1-.534-.533v-1.978a.533.533,0,0,0-.532-.533h-1.977a.535.535,0,0,1-.536-.533v-1.772a.535.535,0,0,1,.536-.533h1.977a.534.534,0,0,0,.532-.535v-1.975a.535.535,0,0,1,.534-.535h1.772a.535.535,0,0,1,.533.535v1.975a.536.536,0,0,0,.534.535h1.977a.535.535,0,0,1,.535.533Zm9.817-.18a.406.406,0,0,1-.344.2h-4.1a.471.471,0,0,1-.426-.5v-2.925a.47.47,0,0,1,.426-.5l2.663,0a.418.418,0,0,1,.37.251l1.436,2.925A.573.573,0,0,1,1004.9,731.319Z"/><path class="a" d="M1000.222,724.092v2.036a1.274,1.274,0,0,0,.463-.971v-.26a.41.41,0,0,1,.3-.39,5.559,5.559,0,0,0,1.046-.433.437.437,0,0,1,.2-.051.4.4,0,0,1,.284.116l.183.185a1.293,1.293,0,0,0,1.825,0l.145-.147a1.286,1.286,0,0,0,0-1.823l-.183-.183a.412.412,0,0,1-.067-.486,5.66,5.66,0,0,0,.435-1.046.41.41,0,0,1,.39-.3h.26a1.29,1.29,0,0,0,1.289-1.289v-.2a1.293,1.293,0,0,0-1.289-1.292h-.26a.408.408,0,0,1-.39-.3,5.567,5.567,0,0,0-.435-1.046.409.409,0,0,1,.067-.486l.183-.183a1.289,1.289,0,0,0,0-1.826l-.145-.144a1.293,1.293,0,0,0-1.825,0l-.183.183a.39.39,0,0,1-.282.117.437.437,0,0,1-.2-.052,5.823,5.823,0,0,0-1.046-.433.41.41,0,0,1-.3-.39v-.26a1.292,1.292,0,0,0-1.292-1.289h-.2a1.291,1.291,0,0,0-1.289,1.289V713a.409.409,0,0,1-.3.39,5.855,5.855,0,0,0-1.046.433.431.431,0,0,1-.2.052.4.4,0,0,1-.283-.117l-.183-.183a1.29,1.29,0,0,0-1.823,0l-.146.144a1.3,1.3,0,0,0,0,1.826l.185.183a.409.409,0,0,1,.065.486,5.652,5.652,0,0,0-.433,1.046.408.408,0,0,1-.39.3h-.259a1.294,1.294,0,0,0-1.292,1.292v.2a1.292,1.292,0,0,0,1.292,1.289h.259a.41.41,0,0,1,.39.3,5.652,5.652,0,0,0,.433,1.046.412.412,0,0,1-.065.486l-.185.183a1.247,1.247,0,0,0-.173.259h5.17A1.4,1.4,0,0,1,1000.222,724.092Zm-4.048-5.143a3.127,3.127,0,0,1,3.124-3.122h0a3.123,3.123,0,1,1-3.124,3.122Zm-10.4,3.665h-2.1a.757.757,0,0,1-.688-.75v-.12a.766.766,0,0,1,.763-.765h.154a.242.242,0,0,0,.23-.178,3.839,3.839,0,0,1,.258-.618.244.244,0,0,0-.039-.289l-.107-.108a.768.768,0,0,1,0-1.083l.084-.086a.764.764,0,0,1,1.083,0l.107.111a.242.242,0,0,0,.168.069.268.268,0,0,0,.121-.031,3.267,3.267,0,0,1,.621-.257.243.243,0,0,0,.176-.231v-.154a.766.766,0,0,1,.765-.765h.12a.764.764,0,0,1,.765.765v.154a.244.244,0,0,0,.178.231,3.24,3.24,0,0,1,.618.257.269.269,0,0,0,.122.031.236.236,0,0,0,.167-.069l.109-.111a.763.763,0,0,1,1.082,0l.085.086a.771.771,0,0,1,0,1.083l-.111.108a.245.245,0,0,0-.039.289,3.24,3.24,0,0,1,.258.618.244.244,0,0,0,.231.178h.154a.767.767,0,0,1,.766.765v.12a.759.759,0,0,1-.687.749h-2.1a1.825,1.825,0,0,0,.2-.811,1.855,1.855,0,0,0-1.853-1.852h0a1.854,1.854,0,0,0-1.85,1.853A1.832,1.832,0,0,0,985.779,722.614Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "019",
				label: "Sweeper",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="28.502" height="25.088" viewBox="0 0 28.502 25.088"><path class="a" d="M1265.108,739.125l-2.856-4.711a.452.452,0,0,0-.318-.2.584.584,0,0,0-.226-1.122h-.276l-.033-1.832a.373.373,0,0,0-.373-.371h-.255a.617.617,0,0,0,.546-.68l-.291-2.533a.668.668,0,0,0-.07-.22l-1.022-1.917-.022-.041c0-.009-.013-.018-.013-.027l-.068-.178h2.273a.242.242,0,0,0,.24-.291l-.345-1.525a.239.239,0,0,0-.236-.191h-.02l-1.628.136a.249.249,0,0,0-.222.235l-.019.589a.243.243,0,0,1-.244.236.235.235,0,0,0-.1.023l-.606-1.566a7.028,7.028,0,0,0-6.982-8.211h-1.749a7.029,7.029,0,0,0-6.992,8.133l-.605,1.641a.277.277,0,0,0-.106-.023.239.239,0,0,1-.239-.235l-.023-.589a.245.245,0,0,0-.221-.235l-1.628-.136h-.02a.24.24,0,0,0-.236.191l-.345,1.525a.253.253,0,0,0,.051.207.245.245,0,0,0,.189.088h2.284l-.108.291a.531.531,0,0,1-.047.1l-1.119,1.86a.667.667,0,0,0-.087.26l-.211,2.313a.621.621,0,0,0,.161.47.608.608,0,0,0,.452.2h3.518a.6.6,0,0,1,.164.023l-3.973-.021a.377.377,0,0,0-.272.113.372.372,0,0,0-.1.268l.027,1.92h-.5a.583.583,0,0,0-.584.584.577.577,0,0,0,.424.552.439.439,0,0,0-.258.177l-3.05,4.711a.453.453,0,0,0,.381.7H1250.6a.215.215,0,0,1,.39-.072.46.46,0,0,0,.247.072h13.481a.454.454,0,0,0,.388-.69Zm-26.019.081-.6-.089c-.092-.014.04-.4.268-.794l1.52-2.6c.161-.276.32-.463.385-.454l.3.044c.059.012.015.212-.112.484l-1.216,2.646C1239.451,738.843,1239.181,739.22,1239.089,739.206Zm3.412-3.41-.53,2.7c-.079.407-.3.783-.436.76l-.912-.15c-.14-.023-.13-.425.018-.819l.992-2.624c.1-.279.249-.463.347-.446l.45.073C1242.527,735.307,1242.556,735.514,1242.5,735.8Zm2.114,3.431h-1.564c-.242,0-.418-.4-.356-.813l.41-2.723c.042-.283.188-.481.356-.479h.77c.169,0,.316.2.357.492l.383,2.723C1245.029,738.832,1244.854,739.227,1244.615,739.227Zm15.732-10.942a.374.374,0,0,1,.349.335l.077.741a.366.366,0,0,1-.094.288.377.377,0,0,1-.276.125l-2.914.016a.378.378,0,0,1-.373-.406l.054-.647a.377.377,0,0,1,.258-.324l.709-.228a.341.341,0,0,1,.114-.019l.024,0Zm-17.075-4.653,1.277-2.772.225-.488a.69.69,0,0,1,.048-.073.736.736,0,0,1,.621-.354l3.064,0h8.166a.74.74,0,0,1,.68.448l1.4,3.256.006.016a.736.736,0,0,1-.685,1.011h-14.131a.735.735,0,0,1-.671-1.042Zm13.121,6-.131,1.855a.8.8,0,0,1-.8.746h-8.78a.808.808,0,0,1-.8-.732l-.162-1.855a.8.8,0,0,1,.8-.873l9.075,0a.8.8,0,0,1,.8.856Zm-11.441.011a.37.37,0,0,1-.275.121l-2.911-.019a.366.366,0,0,1-.275-.121.379.379,0,0,1-.1-.289l.078-.741a.374.374,0,0,1,.349-.335l2.072-.117h.027a.346.346,0,0,1,.111.015l.71.23a.371.371,0,0,1,.256.324l.057.647A.371.371,0,0,1,1244.952,729.646Zm2.291,9.46-.912.15c-.137.023-.357-.353-.437-.76l-.53-2.7c-.056-.282-.027-.489.072-.506l.449-.073c.1-.017.242.167.347.446l.992,2.624C1247.373,738.681,1247.382,739.083,1247.243,739.106Zm2.1.011-.6.089c-.093.014-.363-.363-.546-.763l-1.216-2.646c-.127-.272-.172-.472-.111-.484l.3-.044c.065-.009.224.178.385.454l1.52,2.6C1249.307,738.717,1249.439,739.1,1249.347,739.117Zm1.575-.1-1.742-2.874h3.6Zm2.243.192-.612-.089c-.094-.014.041-.4.273-.794l1.551-2.6c.164-.276.327-.463.393-.454l.3.044c.067.012.022.212-.107.484l-1.241,2.646C1253.535,738.843,1253.259,739.22,1253.165,739.206Zm3.484-3.41-.541,2.7c-.081.407-.3.783-.446.76l-.931-.15c-.143-.023-.133-.425.019-.819l1.012-2.624c.108-.279.254-.463.354-.446l.459.073C1256.675,735.307,1256.7,735.514,1256.649,735.8Zm2.16,3.431h-1.6c-.246,0-.426-.4-.363-.813l.418-2.723c.044-.283.193-.481.367-.479h.787c.172,0,.322.2.364.492l.391,2.723C1259.232,738.832,1259.053,739.227,1258.809,739.227Zm2.679-.121-.931.15c-.146.023-.365-.353-.446-.76l-.541-2.7c-.056-.282-.027-.489.074-.506l.459-.073c.1-.017.246.167.354.446l1.012,2.624C1261.621,738.681,1261.631,739.083,1261.488,739.106Zm2.146.011-.612.089c-.094.014-.37-.363-.557-.763l-1.241-2.646c-.129-.272-.174-.472-.107-.484l.3-.044c.066-.009.228.178.393.454l1.551,2.6C1263.593,738.717,1263.728,739.1,1263.634,739.117Z" transform="translate(-1236.672 -714.727)"/></svg>',
				active: false,
				visible: true,
			},
			{
				code: "021",
				label: "Crane",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="32.004" height="17.345" viewBox="0 0 32.004 17.345"><path class="a" d="M1496.447,731.66a2.933,2.933,0,1,0,2.933,2.933A2.933,2.933,0,0,0,1496.447,731.66Zm0,4.443a1.51,1.51,0,1,1,1.51-1.51A1.51,1.51,0,0,1,1496.447,736.1Zm17.358-4.443a2.933,2.933,0,1,0,2.933,2.933A2.933,2.933,0,0,0,1513.805,731.66Zm0,4.443a1.51,1.51,0,1,1,1.51-1.51A1.51,1.51,0,0,1,1513.805,736.1Zm8.146-8.637a1.553,1.553,0,0,0-.15-.376,1.537,1.537,0,0,0-.137-.194,1.084,1.084,0,0,1-.5,1.271,1.069,1.069,0,0,1-.555.14.75.75,0,0,1-.691-.767l0-.265v-5.44h0a1.653,1.653,0,0,0-3.277-.307h-1.366a.265.265,0,0,0-.188.078l-7.855,7.855h-2.145a.723.723,0,0,1-.722-.721V723.6a.723.723,0,0,0-.721-.721h-7.084a.829.829,0,0,0-.728.477l-1.9,3.626a.9.9,0,0,1-.487.436l-2.548.9a1,1,0,0,0-.6.879h-.016v2.8h.006v.3h-.1a.216.216,0,0,0-.189.241.2.2,0,0,0,.006.033l.238,1.161a.2.2,0,0,0,.183.17h.924l.612.509a.78.78,0,0,0,.493.183h.561a3.433,3.433,0,1,1,6.866,0h10.492a3.433,3.433,0,1,1,6.866,0h.268a.946.946,0,0,0,.864-1.015v-3.56a.559.559,0,0,0-.559-.557h-.11v-6.076a1.6,1.6,0,0,0,1.227-.039v4.33a1.535,1.535,0,0,0,.389,1.218l.032.034a1.528,1.528,0,0,0,1.484.42A1.548,1.548,0,0,0,1521.951,727.466Zm-21.981-.473h0a.5.5,0,0,1-.459.538h-4.382a.433.433,0,0,1-.368-.219.617.617,0,0,1-.03-.592l1.538-3.128a.451.451,0,0,1,.4-.27h2.842a.506.506,0,0,1,.459.541Zm16.053,2.468H1509.5l6.116-6.116a.265.265,0,0,1,.454.191C1516.043,724.907,1515.99,728.042,1516.023,729.461Z" transform="translate(-1489.996 -720.181)"/></svg>',
				active: false,
				visible: true,
			},
			{
				code: "200",
				label: "Sharp turn left",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="18.128" viewBox="0 0 20 18.128"> <g id="Grupo_6113" data-name="Grupo 6113" transform="translate(0 -1.856)"> <g id="Grupo_5090-2" data-name="Grupo 5090-2" transform="translate(4.855 5.264)"> <path id="Trazado_12150" data-name="Trazado 12150" d="M446.327,272.4l1.02-.58c-.067-.518-.133-1.044-.206-1.6.411,0,.764-.027,1.111,0,.909.082,1.822.146,2.72.3a3.1,3.1,0,0,1,1.2.532,1.314,1.314,0,0,1,.4.736,7.637,7.637,0,0,1,.041,2.6c-.065.63-.168,1.255-.266,1.958l-1.6-.488-.788.879a7.325,7.325,0,0,0,9.989-9.689l-.934.762.249.728a29.484,29.484,0,0,0-5.97-.6,26.186,26.186,0,0,0-5.9.776,6.12,6.12,0,0,1,7.5-4.461l.779-.968a7.2,7.2,0,0,0-7.08,1.3A7.293,7.293,0,0,0,446.327,272.4Zm8.439,3.834c-.079-.347-.163-.652-.215-.963-.11-.661-.237-1.322-.29-1.988a8.294,8.294,0,0,1,.05-1.513.927.927,0,0,1,.621-.757,9.52,9.52,0,0,1,2.788-.621c.581-.065,1.163-.121,1.734-.181a5.283,5.283,0,0,1-.868,3.245,6.207,6.207,0,0,1-3.819,2.777ZM451,268.756a8.225,8.225,0,0,1,4.648,0Z" transform="translate(-445.543 -262.864)" /> <path id="Trazado_12151" data-name="Trazado 12151" d="M448.557,266.326c.154.346.376.446.678.222.463-.343.892-.733,1.323-1.117a.44.44,0,0,0,.077-.571,3.658,3.658,0,0,0-2.08-1.888,1.327,1.327,0,0,0-.84.02,2.063,2.063,0,0,0-1.225,1.308c-.168.468-.005.725.48.822.009.488.216.679.7.654C447.893,266.228,448,266.294,448.557,266.326Z" transform="translate(-435.956 -262.87)" /> <path id="Trazado_12152" data-name="Trazado 12152" d="M460.515,274.461c-.106-.346-.322-.474-.614-.292-.5.31-.962.665-1.429,1.02a.457.457,0,0,0-.123.588,3.807,3.807,0,0,0,1.906,2.028,1.12,1.12,0,0,0,.975.012,2.227,2.227,0,0,0,1.216-1.216c.183-.443.033-.712-.426-.823,0-.52-.192-.722-.676-.715C461.215,274.625,461.06,274.511,460.515,274.461Z" transform="translate(-458.292 -264.136)" /> </g> <g id="Grupo_6107" data-name="Grupo 6107" transform="translate(0 1.856)"> <g id="Grupo_6105" data-name="Grupo 6105" transform="translate(1.658)"> <path id="Trazado_12228" data-name="Trazado 12228" d="M454.449,270.365a.577.577,0,0,0,.577-.576,9.627,9.627,0,0,1,9.616-9.616.576.576,0,1,0,0-1.153,10.781,10.781,0,0,0-10.77,10.768A.576.576,0,0,0,454.449,270.365Z" transform="translate(-453.873 -259.02)" /> </g> <g id="Grupo_6106" data-name="Grupo 6106" transform="translate(0 8.129)"> <path id="Trazado_12229" data-name="Trazado 12229" d="M465.183,271.636l2.517-1.97a.576.576,0,1,0-.71-.907l-1.609,1.258-1.259-1.608a.576.576,0,1,0-.907.709Z" transform="translate(-463.091 -268.188)" /> </g> </g> </g> </svg>`,
				active: false,
				visible: true,
			},
			{
				code: "201",
				label: "Sharp turn right",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="18.128" viewBox="0 0 20 18.128"> <g id="Grupo_6112" data-name="Grupo 6112" transform="translate(-445.984 -259.02)"> <g id="Grupo_5090-2" data-name="Grupo 5090-2" transform="translate(445.984 262.429)"> <path id="Trazado_12150" data-name="Trazado 12150" d="M460.344,272.4l-1.02-.58c.067-.518.133-1.044.206-1.6-.411,0-.764-.027-1.111,0-.909.082-1.822.146-2.72.3a3.1,3.1,0,0,0-1.2.532,1.314,1.314,0,0,0-.4.736,7.637,7.637,0,0,0-.041,2.6c.065.63.168,1.255.266,1.958l1.6-.488.788.879a7.325,7.325,0,0,1-9.989-9.689l.934.762-.249.728a29.484,29.484,0,0,1,5.97-.6,26.185,26.185,0,0,1,5.9.776,6.12,6.12,0,0,0-7.5-4.461l-.779-.968a7.2,7.2,0,0,1,7.08,1.3A7.293,7.293,0,0,1,460.344,272.4Zm-8.439,3.834c.079-.347.163-.652.215-.963.11-.661.237-1.322.29-1.988a8.294,8.294,0,0,0-.05-1.513.927.927,0,0,0-.621-.757,9.523,9.523,0,0,0-2.788-.621c-.581-.065-1.162-.121-1.734-.181a5.283,5.283,0,0,0,.868,3.245,6.207,6.207,0,0,0,3.819,2.777Zm3.769-7.477a8.225,8.225,0,0,0-4.648,0Z" transform="translate(-445.984 -262.864)" /> <path id="Trazado_12151" data-name="Trazado 12151" d="M448.577,266.326c-.154.346-.376.446-.678.222-.463-.343-.892-.733-1.323-1.117a.44.44,0,0,1-.077-.571,3.658,3.658,0,0,1,2.08-1.888,1.327,1.327,0,0,1,.84.02,2.063,2.063,0,0,1,1.225,1.308c.168.468.005.725-.48.822-.009.488-.216.679-.7.654C449.241,266.228,449.135,266.294,448.577,266.326Z" transform="translate(-446.034 -262.87)" /> <path id="Trazado_12152" data-name="Trazado 12152" d="M460.3,274.461c.106-.346.322-.474.614-.292.5.31.962.665,1.429,1.02a.457.457,0,0,1,.123.588,3.807,3.807,0,0,1-1.906,2.028,1.12,1.12,0,0,1-.975.012,2.227,2.227,0,0,1-1.216-1.216c-.183-.443-.033-.712.426-.823,0-.52.192-.722.676-.715C459.6,274.625,459.754,274.511,460.3,274.461Z" transform="translate(-447.378 -264.135)" /> </g> <g id="Grupo_6107" data-name="Grupo 6107" transform="translate(452.979 259.02)"> <g id="Grupo_6105" data-name="Grupo 6105"> <path id="Trazado_12228" data-name="Trazado 12228" d="M464.643,270.365a.577.577,0,0,1-.577-.576,9.627,9.627,0,0,0-9.617-9.616.576.576,0,1,1,0-1.153,10.781,10.781,0,0,1,10.77,10.768A.576.576,0,0,1,464.643,270.365Z" transform="translate(-453.873 -259.02)" /> </g> <g id="Grupo_6106" data-name="Grupo 6106" transform="translate(8.174 8.129)"> <path id="Trazado_12229" data-name="Trazado 12229" d="M465.83,271.636l-2.517-1.97a.576.576,0,1,1,.71-.907l1.609,1.258,1.259-1.608a.576.576,0,1,1,.907.709Z" transform="translate(-463.091 -268.188)" /> </g> </g> </g> </svg> `,
				active: false,
				visible: true,
			},
			{
				code: "400",
				label: "Jamming detected",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20"> <defs> <clipPath id="clip-path"> <rect id="Rectángulo_6978" data-name="Rectángulo 6978" width="20" height="20" /> </clipPath> </defs> <g id="Grupo_7170" data-name="Grupo 7170" clip-path="url(#clip-path)"> <path id="Trazado_12652" data-name="Trazado 12652" d="M160.849,85.2a.4.4,0,0,0,.418-.1c.037-.035.074-.07.112-.1a1.864,1.864,0,0,1,2.161-.175,2.56,2.56,0,0,1,.376.3.379.379,0,0,0,.338.1.412.412,0,0,0,.332-.3.394.394,0,0,0-.121-.42,2.69,2.69,0,0,0-3.587-.165.716.716,0,0,0-.321.417v.113a.074.074,0,0,1,.007.015.4.4,0,0,0,.284.322" transform="translate(-154.242 -80.433)" /> <path id="Trazado_12653" data-name="Trazado 12653" d="M261.5,274.69v-1l-1.424,1.424h1a.42.42,0,0,0,.42-.42" transform="translate(-249.842 -262.92)" /> <path id="Trazado_12654" data-name="Trazado 12654" d="M190.247,221.123l-1.235,1.235v1.836a1.244,1.244,0,0,1-1.259,1.257h-1.835l-.412.412.215.007a.407.407,0,0,1,.388.428.416.416,0,0,1-.422.4h-.816a.453.453,0,0,1-.165-.033l-.954.954a2.085,2.085,0,0,0,.851.307.3.3,0,0,1,.054.018h3.732c.119-.026.24-.047.357-.08a2.063,2.063,0,0,0,1.507-1.961q.009-2.319,0-4.638a1.086,1.086,0,0,0-.006-.14M188.6,226.3a.415.415,0,0,1-.417.392h-.826a.415.415,0,0,1-.416-.393.4.4,0,0,1,.364-.428,8.8,8.8,0,0,1,.931,0,.4.4,0,0,1,.363.429" transform="translate(-176.525 -212.425)" /> <path id="Trazado_12655" data-name="Trazado 12655" d="M182.1,112.565c-.054.006-.152.012-.247.03a1.473,1.473,0,0,0-.824.445.382.382,0,0,0-.073.433.394.394,0,0,0,.364.254.434.434,0,0,0,.328-.134.721.721,0,0,1,1,.006.413.413,0,0,0,.693-.153.389.389,0,0,0-.111-.437,1.567,1.567,0,0,0-1.126-.445" transform="translate(-173.803 -108.137)" /> <path id="Trazado_12656" data-name="Trazado 12656" d="M17.071,2.929a10,10,0,1,0,0,14.142,10,10,0,0,0,0-14.142M2.163,10A7.832,7.832,0,0,1,14.721,3.75L11.667,6.8c-.928-.007-1.856,0-2.784,0H8.755V5.994a.415.415,0,0,0-.83,0q-.005.374,0,.749c0,.076-.014.11-.1.131A2.072,2.072,0,0,0,6.284,8.615a.705.705,0,0,1-.018.074V12.2L3.75,14.721A7.8,7.8,0,0,1,2.163,10M9.592,8.879H8.763a.42.42,0,0,0-.42.42v.829l-.833.833V9.3A1.243,1.243,0,0,1,8.765,8.048h1.659ZM10,17.837a7.8,7.8,0,0,1-4.721-1.586L16.251,5.279A7.832,7.832,0,0,1,10,17.837" /> </g> </svg> `,
				active: false,
				visible: true,
			},
			{
				code: "090",
				label: "Padlock cable cut",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20"> <defs> <clipPath id="clip-path"> <rect id="Rectángulo_6978" data-name="Rectángulo 6978" width="20" height="20" /> </clipPath> </defs> <g id="Grupo_7170" data-name="Grupo 7170" clip-path="url(#clip-path)"> <path id="Trazado_12652" data-name="Trazado 12652" d="M160.849,85.2a.4.4,0,0,0,.418-.1c.037-.035.074-.07.112-.1a1.864,1.864,0,0,1,2.161-.175,2.56,2.56,0,0,1,.376.3.379.379,0,0,0,.338.1.412.412,0,0,0,.332-.3.394.394,0,0,0-.121-.42,2.69,2.69,0,0,0-3.587-.165.716.716,0,0,0-.321.417v.113a.074.074,0,0,1,.007.015.4.4,0,0,0,.284.322" transform="translate(-154.242 -80.433)" /> <path id="Trazado_12653" data-name="Trazado 12653" d="M261.5,274.69v-1l-1.424,1.424h1a.42.42,0,0,0,.42-.42" transform="translate(-249.842 -262.92)" /> <path id="Trazado_12654" data-name="Trazado 12654" d="M190.247,221.123l-1.235,1.235v1.836a1.244,1.244,0,0,1-1.259,1.257h-1.835l-.412.412.215.007a.407.407,0,0,1,.388.428.416.416,0,0,1-.422.4h-.816a.453.453,0,0,1-.165-.033l-.954.954a2.085,2.085,0,0,0,.851.307.3.3,0,0,1,.054.018h3.732c.119-.026.24-.047.357-.08a2.063,2.063,0,0,0,1.507-1.961q.009-2.319,0-4.638a1.086,1.086,0,0,0-.006-.14M188.6,226.3a.415.415,0,0,1-.417.392h-.826a.415.415,0,0,1-.416-.393.4.4,0,0,1,.364-.428,8.8,8.8,0,0,1,.931,0,.4.4,0,0,1,.363.429" transform="translate(-176.525 -212.425)" /> <path id="Trazado_12655" data-name="Trazado 12655" d="M182.1,112.565c-.054.006-.152.012-.247.03a1.473,1.473,0,0,0-.824.445.382.382,0,0,0-.073.433.394.394,0,0,0,.364.254.434.434,0,0,0,.328-.134.721.721,0,0,1,1,.006.413.413,0,0,0,.693-.153.389.389,0,0,0-.111-.437,1.567,1.567,0,0,0-1.126-.445" transform="translate(-173.803 -108.137)" /> <path id="Trazado_12656" data-name="Trazado 12656" d="M17.071,2.929a10,10,0,1,0,0,14.142,10,10,0,0,0,0-14.142M2.163,10A7.832,7.832,0,0,1,14.721,3.75L11.667,6.8c-.928-.007-1.856,0-2.784,0H8.755V5.994a.415.415,0,0,0-.83,0q-.005.374,0,.749c0,.076-.014.11-.1.131A2.072,2.072,0,0,0,6.284,8.615a.705.705,0,0,1-.018.074V12.2L3.75,14.721A7.8,7.8,0,0,1,2.163,10M9.592,8.879H8.763a.42.42,0,0,0-.42.42v.829l-.833.833V9.3A1.243,1.243,0,0,1,8.765,8.048h1.659ZM10,17.837a7.8,7.8,0,0,1-4.721-1.586L16.251,5.279A7.832,7.832,0,0,1,10,17.837" /> </g> </svg> `,
				active: false,
				visible: true,
			},
			{
				code: "091",
				label: "Padlock locked",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20"> <defs> <clipPath id="clip-path"> <rect id="Rectángulo_6978" data-name="Rectángulo 6978" width="20" height="20" /> </clipPath> </defs> <g id="Grupo_7170" data-name="Grupo 7170" clip-path="url(#clip-path)"> <path id="Trazado_12652" data-name="Trazado 12652" d="M160.849,85.2a.4.4,0,0,0,.418-.1c.037-.035.074-.07.112-.1a1.864,1.864,0,0,1,2.161-.175,2.56,2.56,0,0,1,.376.3.379.379,0,0,0,.338.1.412.412,0,0,0,.332-.3.394.394,0,0,0-.121-.42,2.69,2.69,0,0,0-3.587-.165.716.716,0,0,0-.321.417v.113a.074.074,0,0,1,.007.015.4.4,0,0,0,.284.322" transform="translate(-154.242 -80.433)" /> <path id="Trazado_12653" data-name="Trazado 12653" d="M261.5,274.69v-1l-1.424,1.424h1a.42.42,0,0,0,.42-.42" transform="translate(-249.842 -262.92)" /> <path id="Trazado_12654" data-name="Trazado 12654" d="M190.247,221.123l-1.235,1.235v1.836a1.244,1.244,0,0,1-1.259,1.257h-1.835l-.412.412.215.007a.407.407,0,0,1,.388.428.416.416,0,0,1-.422.4h-.816a.453.453,0,0,1-.165-.033l-.954.954a2.085,2.085,0,0,0,.851.307.3.3,0,0,1,.054.018h3.732c.119-.026.24-.047.357-.08a2.063,2.063,0,0,0,1.507-1.961q.009-2.319,0-4.638a1.086,1.086,0,0,0-.006-.14M188.6,226.3a.415.415,0,0,1-.417.392h-.826a.415.415,0,0,1-.416-.393.4.4,0,0,1,.364-.428,8.8,8.8,0,0,1,.931,0,.4.4,0,0,1,.363.429" transform="translate(-176.525 -212.425)" /> <path id="Trazado_12655" data-name="Trazado 12655" d="M182.1,112.565c-.054.006-.152.012-.247.03a1.473,1.473,0,0,0-.824.445.382.382,0,0,0-.073.433.394.394,0,0,0,.364.254.434.434,0,0,0,.328-.134.721.721,0,0,1,1,.006.413.413,0,0,0,.693-.153.389.389,0,0,0-.111-.437,1.567,1.567,0,0,0-1.126-.445" transform="translate(-173.803 -108.137)" /> <path id="Trazado_12656" data-name="Trazado 12656" d="M17.071,2.929a10,10,0,1,0,0,14.142,10,10,0,0,0,0-14.142M2.163,10A7.832,7.832,0,0,1,14.721,3.75L11.667,6.8c-.928-.007-1.856,0-2.784,0H8.755V5.994a.415.415,0,0,0-.83,0q-.005.374,0,.749c0,.076-.014.11-.1.131A2.072,2.072,0,0,0,6.284,8.615a.705.705,0,0,1-.018.074V12.2L3.75,14.721A7.8,7.8,0,0,1,2.163,10M9.592,8.879H8.763a.42.42,0,0,0-.42.42v.829l-.833.833V9.3A1.243,1.243,0,0,1,8.765,8.048h1.659ZM10,17.837a7.8,7.8,0,0,1-4.721-1.586L16.251,5.279A7.832,7.832,0,0,1,10,17.837" /> </g> </svg> `,
				active: false,
				visible: true,
			},
			{
				code: "092",
				label: "Padlock unlocked",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20"> <defs> <clipPath id="clip-path"> <rect id="Rectángulo_6978" data-name="Rectángulo 6978" width="20" height="20" /> </clipPath> </defs> <g id="Grupo_7170" data-name="Grupo 7170" clip-path="url(#clip-path)"> <path id="Trazado_12652" data-name="Trazado 12652" d="M160.849,85.2a.4.4,0,0,0,.418-.1c.037-.035.074-.07.112-.1a1.864,1.864,0,0,1,2.161-.175,2.56,2.56,0,0,1,.376.3.379.379,0,0,0,.338.1.412.412,0,0,0,.332-.3.394.394,0,0,0-.121-.42,2.69,2.69,0,0,0-3.587-.165.716.716,0,0,0-.321.417v.113a.074.074,0,0,1,.007.015.4.4,0,0,0,.284.322" transform="translate(-154.242 -80.433)" /> <path id="Trazado_12653" data-name="Trazado 12653" d="M261.5,274.69v-1l-1.424,1.424h1a.42.42,0,0,0,.42-.42" transform="translate(-249.842 -262.92)" /> <path id="Trazado_12654" data-name="Trazado 12654" d="M190.247,221.123l-1.235,1.235v1.836a1.244,1.244,0,0,1-1.259,1.257h-1.835l-.412.412.215.007a.407.407,0,0,1,.388.428.416.416,0,0,1-.422.4h-.816a.453.453,0,0,1-.165-.033l-.954.954a2.085,2.085,0,0,0,.851.307.3.3,0,0,1,.054.018h3.732c.119-.026.24-.047.357-.08a2.063,2.063,0,0,0,1.507-1.961q.009-2.319,0-4.638a1.086,1.086,0,0,0-.006-.14M188.6,226.3a.415.415,0,0,1-.417.392h-.826a.415.415,0,0,1-.416-.393.4.4,0,0,1,.364-.428,8.8,8.8,0,0,1,.931,0,.4.4,0,0,1,.363.429" transform="translate(-176.525 -212.425)" /> <path id="Trazado_12655" data-name="Trazado 12655" d="M182.1,112.565c-.054.006-.152.012-.247.03a1.473,1.473,0,0,0-.824.445.382.382,0,0,0-.073.433.394.394,0,0,0,.364.254.434.434,0,0,0,.328-.134.721.721,0,0,1,1,.006.413.413,0,0,0,.693-.153.389.389,0,0,0-.111-.437,1.567,1.567,0,0,0-1.126-.445" transform="translate(-173.803 -108.137)" /> <path id="Trazado_12656" data-name="Trazado 12656" d="M17.071,2.929a10,10,0,1,0,0,14.142,10,10,0,0,0,0-14.142M2.163,10A7.832,7.832,0,0,1,14.721,3.75L11.667,6.8c-.928-.007-1.856,0-2.784,0H8.755V5.994a.415.415,0,0,0-.83,0q-.005.374,0,.749c0,.076-.014.11-.1.131A2.072,2.072,0,0,0,6.284,8.615a.705.705,0,0,1-.018.074V12.2L3.75,14.721A7.8,7.8,0,0,1,2.163,10M9.592,8.879H8.763a.42.42,0,0,0-.42.42v.829l-.833.833V9.3A1.243,1.243,0,0,1,8.765,8.048h1.659ZM10,17.837a7.8,7.8,0,0,1-4.721-1.586L16.251,5.279A7.832,7.832,0,0,1,10,17.837" /> </g> </svg> `,
				active: false,
				visible: true,
			},
			{
				code: "093",
				label: "Padlock wrong password",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20"> <defs> <clipPath id="clip-path"> <rect id="Rectángulo_6978" data-name="Rectángulo 6978" width="20" height="20" /> </clipPath> </defs> <g id="Grupo_7170" data-name="Grupo 7170" clip-path="url(#clip-path)"> <path id="Trazado_12652" data-name="Trazado 12652" d="M160.849,85.2a.4.4,0,0,0,.418-.1c.037-.035.074-.07.112-.1a1.864,1.864,0,0,1,2.161-.175,2.56,2.56,0,0,1,.376.3.379.379,0,0,0,.338.1.412.412,0,0,0,.332-.3.394.394,0,0,0-.121-.42,2.69,2.69,0,0,0-3.587-.165.716.716,0,0,0-.321.417v.113a.074.074,0,0,1,.007.015.4.4,0,0,0,.284.322" transform="translate(-154.242 -80.433)" /> <path id="Trazado_12653" data-name="Trazado 12653" d="M261.5,274.69v-1l-1.424,1.424h1a.42.42,0,0,0,.42-.42" transform="translate(-249.842 -262.92)" /> <path id="Trazado_12654" data-name="Trazado 12654" d="M190.247,221.123l-1.235,1.235v1.836a1.244,1.244,0,0,1-1.259,1.257h-1.835l-.412.412.215.007a.407.407,0,0,1,.388.428.416.416,0,0,1-.422.4h-.816a.453.453,0,0,1-.165-.033l-.954.954a2.085,2.085,0,0,0,.851.307.3.3,0,0,1,.054.018h3.732c.119-.026.24-.047.357-.08a2.063,2.063,0,0,0,1.507-1.961q.009-2.319,0-4.638a1.086,1.086,0,0,0-.006-.14M188.6,226.3a.415.415,0,0,1-.417.392h-.826a.415.415,0,0,1-.416-.393.4.4,0,0,1,.364-.428,8.8,8.8,0,0,1,.931,0,.4.4,0,0,1,.363.429" transform="translate(-176.525 -212.425)" /> <path id="Trazado_12655" data-name="Trazado 12655" d="M182.1,112.565c-.054.006-.152.012-.247.03a1.473,1.473,0,0,0-.824.445.382.382,0,0,0-.073.433.394.394,0,0,0,.364.254.434.434,0,0,0,.328-.134.721.721,0,0,1,1,.006.413.413,0,0,0,.693-.153.389.389,0,0,0-.111-.437,1.567,1.567,0,0,0-1.126-.445" transform="translate(-173.803 -108.137)" /> <path id="Trazado_12656" data-name="Trazado 12656" d="M17.071,2.929a10,10,0,1,0,0,14.142,10,10,0,0,0,0-14.142M2.163,10A7.832,7.832,0,0,1,14.721,3.75L11.667,6.8c-.928-.007-1.856,0-2.784,0H8.755V5.994a.415.415,0,0,0-.83,0q-.005.374,0,.749c0,.076-.014.11-.1.131A2.072,2.072,0,0,0,6.284,8.615a.705.705,0,0,1-.018.074V12.2L3.75,14.721A7.8,7.8,0,0,1,2.163,10M9.592,8.879H8.763a.42.42,0,0,0-.42.42v.829l-.833.833V9.3A1.243,1.243,0,0,1,8.765,8.048h1.659ZM10,17.837a7.8,7.8,0,0,1-4.721-1.586L16.251,5.279A7.832,7.832,0,0,1,10,17.837" /> </g> </svg> `,
				active: false,
				visible: true,
			},
		],
		searchbar: {
			placeholder: {
				realtime: "Find the vehicle closest to...",
				geofences: "Search...",
			},
			filters: [
				{
					value: "all",
					label: "All",
				},
				{
					value: "establishments",
					label: "Establishments",
				},
				{
					value: "address",
					label: "Address",
				},
				{
					value: "coordinates",
					label: "Coordinates",
				},
			],
			coordinates: {
				valid: `Examples of supported formats for coordinates:<br>28.385200, -81.563900<br>28 23.112, -81 33.834<br>28°23'06.7"N 81°33'50.0"W<br>28.3852° N, 81.5639° W`,
				invalid: "Invalid format",
			},
		},
		roles: [
			{
				code: "1",
				label: "Cliente",
			},
			{
				code: "2",
				label: "Usuario",
			},
		],
		permissions: [
			{
				name: "Realtime",
				label: "Realtime",
				access: true,
				subModules: [],
				components: [
					{
						component: "Events",
						label: "Event's Table",
						access: false,
						controller: {
							name: "Trackings",
							method: "dailyPanel",
						},
					},
					{
						component: "Geofences",
						label: "Show/Hide Geofences",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Pois",
						label: "Show/Hide POI's",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Direction Accounts",
						label: "HIDDEN",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Quick History",
						label: "Quick History",
						access: false,
						controller: {
							name: "Trackings",
							method: "quickHistory",
						},
					},
					{
						component: "Center Device",
						label: "Center Device",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Show/Hide Device",
						label: "Show/Hide Device",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
				],
			},
			{
				name: "History",
				label: "History",
				access: false,
				subModules: [],
				components: [
					{
						component: "Consult History",
						label: "Consult History",
						access: false,
						controller: {
							name: "Trackings",
							method: "multiHistory",
						},
					},
					{
						component: "Geofences",
						label: "Show/Hide Geofences",
						access: false,
						controller: {
							name: "Geofences",
							method: "findAll",
						},
					},
					{
						component: "Pois",
						label: "Show/Hide POI's",
						access: false,
						controller: {
							name: "Points",
							method: "findAll",
						},
					},
					{
						component: "Center Device",
						label: "Center Device",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Show/Hide Device",
						label: "Show/Hide Device",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Show/Hide Route",
						label: "Show/Hide Route",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
				],
			},
			{
				name: "Reports",
				label: "Reports",
				access: false,
				subModules: [],
				components: [
					{
						component: "Consult Report",
						label: "Consult Report",
						access: false,
						controller: {
							name: "Trackings",
							method: "reports",
						},
					},
					{
						component: "Event Report",
						label: "Consult Event Report",
						access: false,
						controller: {
							name: "Trackings",
							method: "eventReport",
						},
					},
					{
						component: "Quick Report",
						label: "Consult Quick Event Report",
						access: false,
						controller: {
							name: "Trackings",
							method: "quickReport",
						},
					},
				],
			},
			{
				name: "Geofences",
				label: "Geofences",
				access: false,
				subModules: [],
				components: [
					{
						component: "Find Geofences",
						label: "Search Geofences",
						access: false,
						controller: {
							name: "Geofences",
							method: "findAll",
						},
					},
					{
						component: "Create Geofence",
						label: "Create Geofences",
						access: false,
						controller: {
							name: "Geofences",
							method: "create",
						},
					},
					{
						component: "Update Geofence",
						label: "Update Geofences",
						access: false,
						controller: {
							name: "Geofences",
							method: "update",
						},
					},
					{
						component: "Delete Geofence",
						label: "Delete Geofences",
						access: false,
						controller: {
							name: "Geofences",
							method: "delete",
						},
					},
					{
						component: "Import Geofences",
						label: "Import Geofences",
						access: false,
						controller: {
							name: "Geofences",
							method: "create",
						},
					},
					{
						component: "Export Geofences",
						label: "Export Geofences",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Find POI",
						label: "Find POIs",
						access: false,
						controller: {
							name: "Points",
							method: "findAll",
						},
					},
					{
						component: "Create POI",
						label: "Create POI",
						access: false,
						controller: {
							name: "Points",
							method: "create",
						},
					},
					{
						component: "Update POI",
						label: "Update POI",
						access: false,
						controller: {
							name: "Points",
							method: "update",
						},
					},
					{
						component: "Delete POI",
						label: "Delete POI",
						access: false,
						controller: {
							name: "Points",
							method: "delete",
						},
					},
					{
						component: "Import POIs",
						label: "Import POI's",
						access: false,
						controller: {
							name: "Points",
							method: "create",
						},
					},
					{
						component: "Export POIs",
						label: "Export POI's",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
				],
			},
			{
				name: "Maintenance",
				label: "Maintenance",
				access: false,
				subModules: [
					{
						controller: "Maintenances",
						label: "Dashboard",
						access: false,
						methods: [
							{
								name: "dashboard",
								label: "View Maintenance",
								access: false,
							},
						],
						components: [
							{
								name: "Load Schedule",
								label: "Edit Service",
								access: false,
								controller: {
									name: "Schedules",
									method: "findById",
								},
							},
							{
								name: "Load Service",
								label: "Log Service",
								access: false,
								controller: {
									name: "LogServices",
									method: "findById",
								},
							},
						],
					},
					{
						controller: "Schedules",
						label: "Schedule",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Search Schedules",
								access: false,
							},
							{
								name: "create",
								label: "Create Schedule",
								access: false,
							},
							{
								name: "update",
								label: "Update Schedule",
								access: false,
							},
							{
								name: "findById",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "LogServices",
						label: "Service Log",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Search Service Logs",
								access: false,
							},
							{
								name: "create",
								label: "Create Service Log",
								access: false,
							},
							{
								name: "update",
								label: "Update Service Log",
								access: false,
							},
							{
								name: "delete",
								label: "Remove Service Log",
								access: false,
							},
						],
						components: [
							{
								name: "Export LogServices",
								label: "Export Service Log",
								access: false,
								controller: {
									name: "",
									method: "",
								},
							},
						],
					},
					{
						controller: "DeviceErrorsCode",
						label: "Error Codes",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Search Error Codes",
								access: false,
							},
							{
								name: "create",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "update",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "delete",
								label: "Delete Error Code",
								access: false,
							},
						],
						components: [
							{
								name: "Export ErrorCode",
								label: "Export Error Codes",
								access: false,
								controller: {
									name: "",
									method: "",
								},
							},
						],
					},
				],
				components: [],
			},
			{
				name: "Routes",
				label: "Routes",
				access: false,
				subModules: [],
				components: [
					{
						component: "List Routes",
						label: "Search Routes",
						access: false,
						controller: {
							name: "Routes",
							method: "findAll",
						},
					},
					{
						component: "Create Routes",
						label: "Create Routes",
						access: false,
						controller: {
							name: "Routes",
							method: "create",
						},
					},
					{
						component: "Update Routes",
						label: "Update Routes",
						access: false,
						controller: {
							name: "Routes",
							method: "update",
						},
					},
					{
						component: "Delete Routes",
						label: "Delete Routes",
						access: false,
						controller: {
							name: "Routes",
							method: "delete",
						},
					},
				],
			},
			{
				name: "Admin",
				label: "Admin",
				access: false,
				subModules: [
					{
						controller: "Users",
						label: "Users",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Find Users",
								access: false,
							},
							{
								name: "create",
								label: "Create Users",
								access: false,
							},
							{
								name: "update",
								label: "Update Users",
								access: false,
							},
							{
								name: "delete",
								label: "Delete Users",
								access: false,
							},
							{
								name: "devices",
								label: "Assign Devices",
								access: false,
							},
						],
						components: [],
					},
					{
						controller: "Roles",
						label: "Roles",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Search Roles",
								access: false,
							},
							{
								name: "create",
								label: "Create Roles",
								access: false,
							},
							{
								name: "update",
								label: "Update Roles",
								access: false,
							},
							{
								name: "delete",
								label: "Delete Roles",
								access: false,
							},
						],
						components: [],
					},
					{
						controller: "Groups",
						label: "Groups",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Search Groups",
								access: false,
							},
							{
								name: "findById",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "create",
								label: "Create Groups",
								access: false,
							},
							{
								name: "update",
								label: "Update Groups",
								access: false,
							},
							{
								name: "delete",
								label: "Delete Groups",
								access: false,
							},
						],
						components: [],
					},
					{
						controller: "Devices",
						label: "Devices",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Search Devices",
								access: false,
							},
							{
								name: "update",
								label: "Update Devices",
								access: false,
							},
							{
								name: "drivers",
								label: "Assign Drivers",
								access: false,
							},
						],
						components: [],
					},
					{
						controller: "Drivers",
						label: "Drivers",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Search Drivers",
								access: false,
							},
							{
								name: "create",
								label: "Create Drivers",
								access: false,
							},
							{
								name: "update",
								label: "Update Drivers",
								access: false,
							},
							{
								name: "delete",
								label: "Delete Drivers",
								access: false,
							},
						],
						components: [],
					},
					{
						controller: "LinksTrackings",
						label: "Tracking Links",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Search Tracking Links",
								access: false,
							},
							{
								name: "create",
								label: "Create Tracking Links",
								access: false,
							},
							{
								name: "delete",
								label: "Delete Tracking Links",
								access: false,
							},
							{
								name: "findme",
								label: "Share Tracking Links",
								access: false,
							},
						],
						components: [],
					},
					{
						controller: "Alerts",
						label: "Alerts",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Search Alerts",
								access: false,
							},
							{
								name: "create",
								label: "Create Alerts",
								access: false,
							},
							{
								name: "update",
								label: "Update Alerts",
								access: false,
							},
							{
								name: "delete",
								label: "Delete Alerts",
								access: false,
							},
							{
								name: "findOne",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "findAllMyAlert",
								label: "Alert Settings",
								access: false,
							},
							{
								name: "createMyAlert",
								label: "Create Alert Settings",
								access: false,
							},
							{
								name: "updateMyAlert",
								label: "Update Alert Settings",
								access: false,
							},
							{
								name: "deleteMyAlert",
								label: "Delete Alert Settings",
								access: false,
							},
						],
						components: [],
					},
					// {
					// 	controller: "WexCard",
					// 	label: "WEX",
					// 	access: false,
					// 	methods: [{
					// 		name: "findAll",
					// 		label: "Search WEX card",
					// 		access: false
					// 	},
					// 	{
					// 		name: "create",
					// 		label: "Create WEX card",
					// 		access: false
					// 	},
					// 	{
					// 		name: "update",
					// 		label: "Update WEX card",
					// 		access: false
					// 	},
					// 	{
					// 		name: "delete",
					// 		label: "Delete WEX card",
					// 		access: false
					// 	}],
					// 	components: []
					// }
				],
				components: [],
			},
			{
				name: "Cameras",
				label: "Cameras",
				access: false,
				subModules: [],
				components: [],
			},
			{
				name: "Mix",
				label: "HIDDEN",
				access: true,
				subModules: [
					{
						controller: "Devices",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "findAll",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "Geofences",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "findAll",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "Roles",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "findAll",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "Points",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "findAll",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "Alerts",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "findAllAlerts",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "Users",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "addPlayer",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "deletePlayer",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "Maintenances",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "findAll",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "create",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "update",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "delete",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "LogsMobile",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "create",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
				],
				components: [],
			},
		],
		emails: {
			alert: '<h1 class="ql-align-center">Event Generated</h1><p><br></p><p>The <strong>GSDEVICE</strong> device has generated a <strong>GSEVENT</strong> event</p><p>Date: <strong>GSDATE</strong></p>',
		},
	},
	es: {
		groups: {
			devices: "Dispositivos",
			groups: "Grupos",
			all: "Todos los dispositivos",
		},
		maps: {
			center: {
				lat: 23.6266557,
				lng: -102.5377501,
			},
			zoom: "5",
			type: "1",
			infowindow: {
				tabs: {
					gral: "General",
					details: "Detalles",
					admin: "Admin",
					technical: "Detalles Técnicos",
					client: "Detalles del cliente",
					drivers: "Conductores",
				},
				status: {
					nosignal: "SIN SEÑAL",
					stop: "DETENIDO",
					idle: "ESTACIONADO",
					move: "EN MOVIMIENTO",
					nosignalgps: "SIN SEÑAL GPS",
					sleep: "EN AHORRO DE ENERGÍA",
					stopcommand: "CON COMANDO DE PARO DE MOTOR",
					sleepnogps: "AHORRO DE ENERGÍA / SIN SEÑAL GPS",
					noenergy: "SIN FUENTE DE ENERGÍA",
					gpsbattery: "GPS BATERÍA BAJA",
				},
				date: "Hoy | Ayer | {date}",
				brand: "Dispositivo",
				make: "Marca",
				model: "Modelo",
				year: "Año",
				speedlimit: "Límite de Vel.",
				street: "Calle",
				gas: "Gasolina",
				postspeed: "Posted speed",
				plates: "Placas",
				mileage: "Kilometraje",
				quickactions: "Acciones Rápidas",
				businessname: "Nombre empresarial",
				imei: "IMEI",
				phone: "Teléfono",
				port: "Puerto",
				device: "Dispositivo",
				alias: "Alias",
				contact: "Contacto",
				user: "Usuario",
				movil: "Móvil",
				city: "Ciudad",
				coords: "Coordenadas",
			},
			styles: {
				stylers: [
					{ visibility: "simplified" },
					{ hue: "#006eff" },
					{ lightness: 4 },
					{ gamma: 0.52 },
					{ saturation: -32 },
				],
			},
		},
		units: {
			distance: 1.0,
			temperature: {
				min: -40,
				max: 85,
			},
			temperatureDetail: {
				C: {
					min: -40,
					max: 85,
				},
				F: {
					min: -40,
					max: 185,
				},
			},
			gasoline: {
				min: 0,
				max: 100,
			},
			storage: 1024,
		},
		langs: [
			{ value: "ES", label: "Español" },
			{ value: "EN", label: "Inglés" },
		],
		week: [
			{ value: "monday", label: "Lunes", short: "Lun" },
			{ value: "tuesday", label: "Martes", short: "Ma" },
			{ value: "wednesday", label: "Miércoles", short: "Mie" },
			{ value: "thursday", label: "Jueves", short: "Jue" },
			{ value: "friday", label: "Viernes", short: "Vie" },
			{ value: "saturday", label: "Sábado", short: "Sab" },
			{ value: "sunday", label: "Domingo", short: "Dom" },
		],
		months: [
			{ value: "01", label: "Enero", short: "Ene" },
			{ value: "02", label: "Febrero", short: "Feb" },
			{ value: "03", label: "Marzo", short: "Mar" },
			{ value: "04", label: "Abril", short: "Abr" },
			{ value: "05", label: "Mayo", short: "May" },
			{ value: "06", label: "Junio", short: "Jun" },
			{ value: "07", label: "Julio", short: "Jul" },
			{ value: "08", label: "Agosto", short: "Ago" },
			{ value: "09", label: "Septiembre", short: "Sep" },
			{ value: "10", label: "Octubre", short: "Oct" },
			{ value: "11", label: "Noviembre", short: "Nov" },
			{ value: "12", label: "Diciembre", short: "Dic" },
		],
		measurements: [
			{ value: "KM", label: "Kilometros" },
			{ value: "HR", label: "Horas" },
		],
		markers: [
			{ value: "car", label: "Auto", img: "car-green.svg" },
			{ value: "bus", label: "Autobus", img: "bus-green.svg" },
			{ value: "truck", label: "Camión", img: "truck-green.svg" },
			{ value: "sweeper", label: "Barredora", img: "sweeper-green.svg" },
			{ value: "pickup", label: "Pickup", img: "pickup-green.svg" },
			{ value: "moto", label: "Motocicleta", img: "moto-green.svg" },
			{ value: "tesla", label: "Tesla", img: "tesla-green.svg" },
			{ value: "van", label: "Camioneta", img: "van-green.svg" },
			{ value: "suv", label: "SUV", img: "suv-green.svg" },
			{
				value: "lighttruck",
				label: "Camión ligero",
				img: "lighttruck-green.svg",
			},
			{
				value: "jettruck",
				label: "Jet Truck",
				img: "jettruck-green.svg",
			},
			{
				value: "snowplower",
				label: "Barredora de nieve",
				img: "snowplower-green.svg",
			},
			{ value: "flatbed", label: "Grua", img: "flatbed-green.svg" },
			{
				value: "crane",
				label: "Grua industrial",
				img: "crane-green.svg",
			},
			{
				value: "forklift",
				label: "Montacargas",
				img: "forklift-green.svg",
			},
			{ value: "scissor", label: "Elevador", img: "scissor-green.svg" },
			{ value: "welder", label: "Soldadora", img: "welder-green.svg" },
			{
				value: "manlift",
				label: "Camión elevador",
				img: "manlift-green.svg",
			},
			{
				value: "lightplant",
				label: "Planta de luz",
				img: "lightplant-green.svg",
			},
			{ value: "ram", label: "RAM", img: "ram-green.svg" },
			{ value: "tesla3", label: "Tesla 3", img: "tesla3-green.svg" },
			{
				value: "minicharger",
				label: "Mini Cargadora",
				img: "minicharger-green.svg",
			},
			{
				value: "excavator",
				label: "Excavadora",
				img: "excavator-green.svg",
			},
			{
				value: "generator",
				label: "Generador",
				img: "generator-green.svg",
			},
			{
				value: "compressor",
				label: "Compresor",
				img: "compressor-green.svg",
			},
			{
				value: "otrailer",
				label: "Trailer abierto",
				img: "otrailer-green.svg",
			},
			{
				value: "ctrailer",
				label: "Trailer cerrado",
				img: "ctrailer-green.svg",
			},
		],
		workshifts: [
			{ value: "AM", label: "Matutino" },
			{ value: "PM", label: "Vespertino" },
			{ value: "FULL", label: "Completo" },
		],
		alarms: [
			{
				code: "035",
				label: "Entrada a geocerca",
				short: "Entrada",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="29.764" height="20.387" viewBox="0 0 29.764 20.387"><g transform="translate(-215.031 -403.778)"><path class="a" d="M221.459,403.778a6.416,6.416,0,0,0-5.807,9.17h-.008l.054.1a6.508,6.508,0,0,0,.391.69l4.1,7.249a1.264,1.264,0,0,0,2.18.033l4.244-6.983c.223-.379.439-.735.652-1.085a6.417,6.417,0,0,0-5.808-9.17Zm0,10.095a3.666,3.666,0,1,1,3.666-3.666h0A3.666,3.666,0,0,1,221.459,413.873Z"/><path class="b" d="M220.413,413.182a3.1,3.1,0,0,0,3.76-1.37h-1.705A2.315,2.315,0,0,0,220.413,413.182Z"/><path class="b" d="M244.6,420.645l-2.939-7.32a2.328,2.328,0,0,0-2.134-1.513H228.194a6.944,6.944,0,0,1-.477,1.355l-.08.132h11.888a.849.849,0,0,1,.753.58l2.94,7.321a1.2,1.2,0,0,1-.1,1.1.789.789,0,0,1-.645.374h-4v0H237.32v0H224.379v0h-4.849a.791.791,0,0,1-.646-.374,1.2,1.2,0,0,1-.108-1.1l.4-.992-.935-1.655-.839,2.093a2.667,2.667,0,0,0,.257,2.491,2.251,2.251,0,0,0,1.877,1.027h22.93a2.25,2.25,0,0,0,1.878-1.028A2.669,2.669,0,0,0,244.6,420.645Z"/><path class="b" d="M225.02,422.179h12.187l-.9-3.951-11.385,1.343-.452,2.6h.554Z"/><path class="b" d="M219.3,422.028a.293.293,0,0,0,.242.147h3.784l.432-2.484-.966,1.589a1.771,1.771,0,0,1-.637.618,1.75,1.75,0,0,1-.867.23,1.792,1.792,0,0,1-.474-.064,1.753,1.753,0,0,1-1.064-.831l-.264-.467-.249.621A.7.7,0,0,0,219.3,422.028Z"/><path class="b" d="M227.043,414.291l-1.689,2.78-.236,1.357,10.937-1.29-.763-3.34h-7.954C227.24,413.962,227.141,414.126,227.043,414.291Z"/><path class="b" d="M242.687,422.042a.7.7,0,0,0,.068-.653l-2.941-7.324a.364.364,0,0,0-.321-.267h-3.054l1.915,8.381h4.114A.282.282,0,0,0,242.687,422.042Z"/></g></svg>',
				active: false,
				visible: false,
			},
			{
				code: "036",
				label: "Salida de geocerca",
				short: "Salida",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="27.592" height="22.401" viewBox="0 0 27.592 22.401"><g transform="translate(-472.203 -401.764)"><path class="a" d="M499.6,420.645l-2.939-7.32a2.3,2.3,0,0,0-.708-.963l-.789,1.3a.843.843,0,0,1,.112.22l2.94,7.321a1.2,1.2,0,0,1-.109,1.1.789.789,0,0,1-.645.374H474.53a.791.791,0,0,1-.646-.374,1.2,1.2,0,0,1-.108-1.1l2.933-7.321a.851.851,0,0,1,.754-.581h14.43l-.842-1.488H477.467a2.327,2.327,0,0,0-2.135,1.514l-2.933,7.321a2.667,2.667,0,0,0,.257,2.491,2.251,2.251,0,0,0,1.877,1.027h22.93a2.251,2.251,0,0,0,1.878-1.028A2.669,2.669,0,0,0,499.6,420.645Z"/><path class="b" d="M493.736,401.764a4.543,4.543,0,0,0-4.113,6.5h-.006l.038.068a4.517,4.517,0,0,0,.277.489l2.907,5.135a.9.9,0,0,0,1.543.024l3.007-4.946c.158-.268.311-.52.461-.769a4.545,4.545,0,0,0-4.114-6.5Zm0,7.15a2.6,2.6,0,1,1,2.6-2.6h0a2.6,2.6,0,0,1-2.6,2.6Z"/><path class="a" d="M479.787,413.8l-.373,2.152-2.663-.833.433-1.08a.349.349,0,0,1,.3-.239Zm-5.547,7.588a.7.7,0,0,0,.063.641.293.293,0,0,0,.242.147h3.785l.89-5.12-2.884-.9Zm16.052-7.588h-9.369l-.8,4.629,10.937-1.29Zm-10.373,5.772-.452,2.6h12.739l-.9-3.947Zm14.4-4.855a1.389,1.389,0,0,1-.7.188,1.4,1.4,0,0,1-1.214-.7l-.231-.408h-.736l1.914,8.376h4.107a.282.282,0,0,0,.219-.136.708.708,0,0,0,.071-.652l-2.9-7.217-.043.07A1.4,1.4,0,0,1,494.32,414.716Z"/></g></svg>',
				active: false,
				visible: false,
			},
			{
				code: "002",
				label: "Encendido de motor",
				short: "Encendido",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="21.869" height="26.086" viewBox="0 0 21.869 26.086"><g transform="translate(-728.426 -400.077)"><path class="a" d="M745.693,405.027h-.619a.309.309,0,0,1-.276-.333V400.41a.309.309,0,0,1,.276-.333h.619a.309.309,0,0,1,.276.333V404.7A.309.309,0,0,1,745.693,405.027Z"/><path class="b" d="M738.22,409.971v-4.248a1.342,1.342,0,0,0-1.372-1.311h0a1.343,1.343,0,0,0-1.371,1.311v10.586a1.342,1.342,0,0,1-1.372,1.311l-4.308-1.655a1.343,1.343,0,0,0-1.371,1.311v.289a1.3,1.3,0,0,0,.722,1.155l2.927,1.5,2.487,1.277a1.3,1.3,0,0,1,.722,1.155v2.2a1.341,1.341,0,0,0,1.37,1.311h6.189a1.341,1.341,0,0,0,1.371-1.31h0v-2.6a1.266,1.266,0,0,1,.214-.7l1.915-1.481a1.273,1.273,0,0,0,.214-.7v-5.989a1.342,1.342,0,0,0-1.372-1.311h-.007l-5.578-.8a1.342,1.342,0,0,1-1.38-1.3Z"/><path class="a" d="M745.343,409.943a5.051,5.051,0,0,1-4.869-5.192,4.894,4.894,0,0,1,2.85-4.191.229.229,0,0,1,.3.123h0l.25.619a.22.22,0,0,1-.116.282,3.8,3.8,0,1,0,3.184-.026.22.22,0,0,1-.12-.281l.24-.623a.228.228,0,0,1,.3-.13h0a4.918,4.918,0,0,1-2.026,9.417Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "003",
				label: "Apagado de motor",
				short: "Apagado",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="22.85" height="26.976" viewBox="0 0 22.85 26.976"><g transform="translate(-983.297 -399.189)"><path class="a" d="M1004.061,403.814l1.729-1.729a1.219,1.219,0,0,0,0-1.724l-.815-.815a1.219,1.219,0,0,0-1.724,0h0l-1.729,1.729a.859.859,0,0,1-1.213,0h0l-1.729-1.729a1.217,1.217,0,0,0-1.722,0h0l-.815.815a1.219,1.219,0,0,0,0,1.724h0l1.729,1.729a.856.856,0,0,1,0,1.212h0l-1.729,1.729a1.219,1.219,0,0,0,0,1.724h0l.815.815a1.218,1.218,0,0,0,1.723,0h0l1.729-1.729a.858.858,0,0,1,1.213,0h0l1.729,1.729a1.219,1.219,0,0,0,1.724,0h0l.815-.815a1.219,1.219,0,0,0,0-1.724l-1.729-1.729a.857.857,0,0,1,0-1.212Z"/><path class="a" d="M993.09,409.972v-4.248a1.343,1.343,0,0,0-1.371-1.311h0a1.342,1.342,0,0,0-1.372,1.311V416.31a1.342,1.342,0,0,1-1.372,1.311l-4.307-1.655a1.342,1.342,0,0,0-1.372,1.311v.289a1.3,1.3,0,0,0,.722,1.155l2.928,1.5,2.486,1.277a1.3,1.3,0,0,1,.722,1.155v2.2a1.342,1.342,0,0,0,1.372,1.311h6.184a1.342,1.342,0,0,0,1.372-1.311v-2.6a1.265,1.265,0,0,1,.214-.7l1.916-1.471a1.274,1.274,0,0,0,.215-.7v-5.989a1.342,1.342,0,0,0-1.374-1.311h-.006l-5.578-.8a1.343,1.343,0,0,1-1.379-1.306Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "030",
				label: "Parada",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="30.279" height="28.225" viewBox="0 0 30.279 28.225"><path class="a" d="M1266.068,413.341l-6.724-12.225a1.888,1.888,0,0,0-1.654-.977h-12.012a4.206,4.206,0,0,0-3.686,2.18l-5.448,9.9a4.2,4.2,0,0,0,0,4.055l5.447,9.9a4.209,4.209,0,0,0,3.687,2.18h10.64a4.206,4.206,0,0,0,3.687-2.18l6.063-11.024A1.879,1.879,0,0,0,1266.068,413.341Zm-2.659,2.029-5.26,9.564a2.32,2.32,0,0,1-2.031,1.2H1254v-3.786l.005-.393a.961.961,0,0,1,.238-.622l2.87-3.276a.963.963,0,0,0,.238-.633v-4.9a.962.962,0,0,0-.962-.961h-.02a.963.963,0,0,0-.961.961v3.247h-.684v-8.93h0a.961.961,0,0,0-.961-.961h-.007a.962.962,0,0,0-.961.961v5.877h-.48V405.8a.962.962,0,0,0-.961-.961h-.106a.961.961,0,0,0-.961.961v7h-.633v-6.172a.961.961,0,1,0-1.922,0v6.506h-.559v-4a.773.773,0,0,0-1.545,0v8.67a.964.964,0,0,0,.072.367l1.281,3.107a.948.948,0,0,1,.073.356l.006.557h0v3.945h-1.181a2.318,2.318,0,0,1-2.031-1.2l-5.26-9.564a2.317,2.317,0,0,1,0-2.235l5.26-9.564a2.318,2.318,0,0,1,2.031-1.2h10.24a2.32,2.32,0,0,1,2.031,1.2l5.26,9.564A2.318,2.318,0,0,1,1263.409,415.37Z" transform="translate(-1236.024 -400.139)"/></svg>',
				active: false,
				visible: true,
			},
			{
				code: "",
				label: "Geocercas",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="27.591" height="25.113" viewBox="0 0 27.591 25.113"><path class="a" d="M1495.814,413.938l-.374,2.151-2.669-.835.431-1.077a.352.352,0,0,1,.3-.239Zm-5.554,7.587a.7.7,0,0,0,.064.641.3.3,0,0,0,.243.148h3.79l.89-5.121-2.892-.9Zm23.221.789a.285.285,0,0,0,.219-.137.709.709,0,0,0,.071-.653l-2.94-7.319a.364.364,0,0,0-.321-.268h-3.051l1.914,8.377Zm-18,0h12.738l-.9-3.948-11.383,1.343Zm.652-3.752,10.937-1.29-.762-3.335h-1.282l-1.673,2.753a1.791,1.791,0,0,1-.637.619,1.768,1.768,0,0,1-2.406-.667l-1.529-2.7h-1.844Zm19.482,2.221-2.94-7.32a2.328,2.328,0,0,0-2.134-1.513h-4.307l-.905,1.488h5.208a.849.849,0,0,1,.754.58l2.94,7.321a1.2,1.2,0,0,1-.109,1.1.79.79,0,0,1-.645.375h-22.93a.79.79,0,0,1-.646-.375,1.2,1.2,0,0,1-.109-1.1l2.933-7.321a.853.853,0,0,1,.755-.58h5.018l-.842-1.488h-4.172a2.326,2.326,0,0,0-2.135,1.515l-2.934,7.321a2.669,2.669,0,0,0,.258,2.49,2.25,2.25,0,0,0,1.877,1.028h22.93a2.249,2.249,0,0,0,1.878-1.029A2.672,2.672,0,0,0,1515.619,420.783Zm-13.6-21.591a6.418,6.418,0,0,1,5.808,9.171c-.213.349-.429.706-.652,1.084l-4.244,6.983a1.265,1.265,0,0,1-2.18-.034l-4.1-7.249a6.5,6.5,0,0,1-.391-.69l-.054-.1h.008a6.417,6.417,0,0,1,5.807-9.171Zm0,10.094a3.666,3.666,0,1,0-3.666-3.666,3.666,3.666,0,0,0,3.666,3.666Z" transform="translate(-1488.224 -399.191)"/></svg>',
				active: false,
				visible: true,
			},
			{
				code: "028",
				label: "Desaceleración",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="31.552" height="12.003" viewBox="0 0 31.552 12.003"><g transform="translate(-216.002 -513.061)"><path class="a" d="M221.983,522.89h-5.609a.373.373,0,0,1-.372-.372h0a.371.371,0,0,1,.372-.372h5.609a.372.372,0,0,1,0,.744Z"/><path class="a" d="M224.983,519.79h-8.609a.373.373,0,0,1-.372-.372h0a.371.371,0,0,1,.372-.372h8.609a.369.369,0,1,1,0,.738Z"/><path class="a" d="M225.193,516.655h-8.609a.372.372,0,0,1,0-.744h6.084a.342.342,0,0,0,.434.068l.113-.069h1.978a.373.373,0,0,1,.372.372h0a.371.371,0,0,1-.372.366Z"/><path class="a" d="M228.128,513.177h-8.606a.372.372,0,0,0-.374.372v.009a.365.365,0,0,0,.374.36h7.054l-.009,0h1.561v-.006a.372.372,0,0,0,.372-.368h0A.373.373,0,0,0,228.128,513.177Z"/><path class="a" d="M242.28,520.758a2.153,2.153,0,1,0,2.153,2.153A2.153,2.153,0,0,0,242.28,520.758Zm0,3.548a1.4,1.4,0,1,1,1.4-1.4A1.395,1.395,0,0,1,242.28,524.306Z"/><path class="a" d="M246.36,521.678a.263.263,0,0,1,.24-.175h.913l.035-.4a2.022,2.022,0,0,0-.039-.581l-.256-1.153a1.713,1.713,0,0,0-1.122-1.294l-5.017-1.6c-.032-.009-.059-.019-.091-.031l-.4.247a.931.931,0,0,1-.5.148.946.946,0,0,1-.638-.247l-3.444-3.038.242-.121-.2-.127a1.536,1.536,0,0,0-.817-.245h-7.019a1.526,1.526,0,0,0-.682.167l-.484.247a.406.406,0,0,1-.18.255l-3.8,2.249a.316.316,0,0,1-.174.049.382.382,0,0,1-.36-.294h-.013a.846.846,0,0,1-.109.023l-1.042.177a1.72,1.72,0,0,0-1.364,1.583l-.125,1.338a1.891,1.891,0,0,1-.266.815,1.9,1.9,0,0,0-.275.992v.466a1.9,1.9,0,0,0,.33,1.081l.081.117a1.644,1.644,0,0,0,.744.6l1.61.635a1.47,1.47,0,0,0,.549.1h.384a2.622,2.622,0,0,1-.121-.75,2.653,2.653,0,1,1,5.306,0,2.622,2.622,0,0,1-.121.75h11.612a2.622,2.622,0,0,1-.121-.75,2.653,2.653,0,1,1,5.306,0,2.619,2.619,0,0,1-.114.728,1.262,1.262,0,0,0,.164-.016l1.279-.341a1.588,1.588,0,0,0,.841-.56l-.761.083h-.026a.253.253,0,0,1-.209-.115.311.311,0,0,1-.031-.288Zm-7.909-4.9a.407.407,0,0,1-.38.276h-12.05a.41.41,0,0,1-.391-.292.476.476,0,0,1,.153-.536l3.366-2.6a.411.411,0,0,1,.238-.083h5.831a.414.414,0,0,1,.265.107l2.851,2.6A.479.479,0,0,1,238.451,516.78Z"/><path class="a" d="M225.6,520.758a2.153,2.153,0,1,0,2.153,2.153A2.153,2.153,0,0,0,225.6,520.758Zm0,3.548a1.4,1.4,0,1,1,1.395-1.4A1.395,1.395,0,0,1,225.6,524.306Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "027",
				label: "Aceleración",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="31.867" height="9.985" viewBox="0 0 31.867 9.985"><g transform="translate(-470.258 -514.078)"><path class="a" d="M481.336,523.667H470.8c-.3,0-.54-.166-.54-.371s.242-.373.54-.373h10.536c.3,0,.543.167.543.373S481.636,523.667,481.336,523.667Z"/><path class="a" d="M481.336,520.686H470.8c-.3,0-.54-.166-.54-.371s.242-.373.54-.373h10.536c.3,0,.543.167.543.373s-.24.366-.54.366Z"/><path class="a" d="M483.643,517.551H471.108c-.3,0-.543-.166-.543-.371s.243-.371.543-.371h12.535c.3,0,.541.166.541.371s-.243.366-.54.366Z"/><path class="a" d="M487.125,514.822H485.4a.33.33,0,0,0,.094-.17l-.333.17h-9.778c-.3,0-.54-.166-.54-.371s.242-.373.54-.373h12.536c.3,0,.543.167.543.373a.324.324,0,0,1-.167.267h-.927a.322.322,0,0,0-.193.066l-.048.038Z"/><path class="a" d="M497.837,520.567a1.748,1.748,0,1,0,1.748,1.748A1.748,1.748,0,0,0,497.837,520.567Zm0,2.91a1.168,1.168,0,1,1,1.168-1.168A1.168,1.168,0,0,1,497.837,523.477Z"/><path class="a" d="M501.15,521.306a.211.211,0,0,1,.2-.139h.741l.028-.322a1.586,1.586,0,0,0-.03-.471l-.208-.938a1.4,1.4,0,0,0-.914-1.051l-4.072-1.3a.389.389,0,0,1-.054-.019l-.017-.007-.322.2a.751.751,0,0,1-.411.119.778.778,0,0,1-.517-.2l-2.8-2.468.2-.1-.162-.1a1.246,1.246,0,0,0-.665-.2h-5.7a1.211,1.211,0,0,0-.556.135l-.395.2a.309.309,0,0,1-.145.205l-3.083,1.828a.288.288,0,0,1-.142.038.315.315,0,0,1-.292-.238c-.034.007-.067.015-.1.02l-.845.145a1.4,1.4,0,0,0-1.107,1.286l-.1,1.085a1.515,1.515,0,0,1-.216.662,1.516,1.516,0,0,0-.223.806v.375a1.575,1.575,0,0,0,.266.875l.069.1a1.3,1.3,0,0,0,.6.487l1.307.517a1.177,1.177,0,0,0,.446.084h.213a2.226,2.226,0,0,1-.094-.608,2.248,2.248,0,0,1,4.5,0,2.225,2.225,0,0,1-.094.608h9.232a2.225,2.225,0,0,1-.094-.608,2.248,2.248,0,0,1,4.5,0,2.217,2.217,0,0,1-.083.573c.01,0,.021,0,.031,0l1.04-.274a1.287,1.287,0,0,0,.681-.457l-.616.069h-.021a.2.2,0,0,1-.171-.095.242.242,0,0,1-.026-.23Zm-6.421-3.963a.333.333,0,0,1-.309.223h-9.787a.333.333,0,0,1-.314-.239.382.382,0,0,1,.122-.434l2.733-2.115a.315.315,0,0,1,.193-.066H492.1a.33.33,0,0,1,.216.084l2.316,2.115A.392.392,0,0,1,494.729,517.343Z"/><path class="a" d="M484.3,520.567a1.748,1.748,0,1,0,1.748,1.748A1.748,1.748,0,0,0,484.3,520.567Zm0,2.91a1.168,1.168,0,1,1,1.168-1.168A1.168,1.168,0,0,1,484.3,523.477Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "037",
				label: "Tiempo mínimo incumplido",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18.191" height="25.117" viewBox="0 0 18.191 25.117"><g transform="translate(-731.678 -507.024)"><path class="a" d="M747.347,532.141H734.2a2.524,2.524,0,0,1-2.52-2.52v-4.2a2.518,2.518,0,0,1,1.081-2.069l3.325-2.313a1.378,1.378,0,0,0-.058-2.3l-2.858-1.785a2.507,2.507,0,0,1-1.185-2.138v-5.272a2.522,2.522,0,0,1,2.519-2.52h12.846a2.524,2.524,0,0,1,2.521,2.52v5.292A2.53,2.53,0,0,1,748.624,517l-2.967,1.739a1.369,1.369,0,0,0-.681,1.144,1.351,1.351,0,0,0,.6,1.186l3.186,2.163a2.521,2.521,0,0,1,1.1,2.085v4.3A2.524,2.524,0,0,1,747.347,532.141ZM734.5,508.161a1.38,1.38,0,0,0-1.377,1.378v5.272a1.371,1.371,0,0,0,.647,1.17l2.859,1.785a2.52,2.52,0,0,1,.1,4.206l-3.325,2.314a1.381,1.381,0,0,0-.591,1.132v4.2A1.38,1.38,0,0,0,734.2,531h13.149a1.38,1.38,0,0,0,1.379-1.378v-4.3a1.378,1.378,0,0,0-.6-1.14l-3.186-2.164a2.519,2.519,0,0,1,.142-4.259l2.967-1.738a1.384,1.384,0,0,0,.682-1.19v-5.292a1.38,1.38,0,0,0-1.379-1.378Z"/><path class="a" d="M733.935,527.382v2.125a.377.377,0,0,0,.377.377h12.922a.379.379,0,0,0,.377-.377v-2.125Z"/></g></svg>',
				active: false,
				visible: false,
			},
			{
				code: "038",
				label: "Tiempo máximo excedido",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18.191" height="25.117" viewBox="0 0 18.191 25.117"><g transform="translate(-986.678 -507.024)"><path class="a" d="M1002.347,532.141H989.2a2.524,2.524,0,0,1-2.52-2.52v-4.2a2.521,2.521,0,0,1,1.081-2.069l3.325-2.313a1.378,1.378,0,0,0-.058-2.3l-2.858-1.785a2.507,2.507,0,0,1-1.185-2.138v-5.272a2.522,2.522,0,0,1,2.519-2.52h12.846a2.524,2.524,0,0,1,2.521,2.52v5.292a2.531,2.531,0,0,1-1.246,2.174l-2.967,1.739a1.369,1.369,0,0,0-.681,1.144,1.351,1.351,0,0,0,.6,1.186l3.186,2.163a2.521,2.521,0,0,1,1.1,2.085v4.3A2.525,2.525,0,0,1,1002.347,532.141ZM989.5,508.161a1.379,1.379,0,0,0-1.378,1.378v5.272a1.371,1.371,0,0,0,.647,1.17l2.859,1.785a2.52,2.52,0,0,1,.1,4.206l-3.325,2.314a1.381,1.381,0,0,0-.591,1.132v4.2A1.38,1.38,0,0,0,989.2,531h13.149a1.38,1.38,0,0,0,1.379-1.378v-4.3a1.375,1.375,0,0,0-.6-1.14l-3.186-2.164a2.52,2.52,0,0,1,.143-4.259l2.966-1.738a1.385,1.385,0,0,0,.682-1.19v-5.292a1.38,1.38,0,0,0-1.379-1.378Z"/><path class="a" d="M1002.233,529.885H989.311a.376.376,0,0,1-.375-.378v-4.031a.375.375,0,0,1,.161-.31l3.277-2.279a3.631,3.631,0,0,0,1.447-3.879,3.78,3.78,0,0,0-1.718-2.262l-2.686-1.677a.377.377,0,0,1-.178-.32v-5.1a.379.379,0,0,1,.378-.378h8.449l.618.708-1.394,1.458,1,1.725-1,2.255,2.421-2.455-1.027-1.393,2.64-2.3h.909a.379.379,0,0,1,.378.378v5.113a.384.384,0,0,1-.186.325l-2.911,1.706a3.621,3.621,0,0,0-1.74,3.8,3.727,3.727,0,0,0,1.634,2.414l3.037,2.062a.376.376,0,0,1,.166.313V529.5a.379.379,0,0,1-.377.381Z"/></g></svg>',
				active: false,
				visible: false,
			},
			{
				code: "997",
				label: "Error del motor",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24.938" height="24.939" viewBox="0 0 24.938 24.939"><g transform="translate(-1238.402 -503.85)"><path class="a" d="M1263.274,527.878l-11.857-23.68a.629.629,0,0,0-1.125,0l-11.823,23.68a.629.629,0,0,0,.563.911h23.68a.629.629,0,0,0,.562-.911Zm-11.139-2.357a.87.87,0,0,1-.87.87h-.462a.871.871,0,0,1-.87-.87v-.727a.87.87,0,0,1,.87-.87h.462a.869.869,0,0,1,.87.87Zm0-3.749a.674.674,0,0,1-.674.674h-.854a.674.674,0,0,1-.674-.674v-8.629a.674.674,0,0,1,.674-.674h.854a.674.674,0,0,1,.674.674Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "026",
				label: "Revoluciones por minuto",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="25.35" height="26.264" viewBox="0 0 25.35 26.264"><g transform="translate(-218.326 -608.23)"><path class="a" d="M236.452,623.073a.885.885,0,0,1-.519-.037l-5.174-1.991a1.165,1.165,0,0,1-.716-.823l-1.2-5.185a.888.888,0,0,1,1.713-.467c.006.022.012.044.016.067l.988,4.266a1.167,1.167,0,0,0,.716.823l4.247,1.634a.923.923,0,0,1,.6,1.036A.89.89,0,0,1,236.452,623.073Z"/><path class="a" d="M219.53,627.047a.753.753,0,0,1,.671-.752c.517-.052,1.138-.084,1.8-.084a4.2,4.2,0,0,1,2.658.647,2.087,2.087,0,0,1,.756,1.719,2.183,2.183,0,0,1-1.451,2.025v.036a2.077,2.077,0,0,1,1.1,1.537c.125.455.251.945.365,1.364a.754.754,0,0,1-.528.926.77.77,0,0,1-.2.027h-.349a.747.747,0,0,1-.718-.517c-.106-.339-.231-.81-.372-1.4-.22-1.025-.574-1.3-1.329-1.317h-.561v2.475a.756.756,0,0,1-.756.756h-.328a.755.755,0,0,1-.756-.756h0Zm1.841,2.871h.732c.927,0,1.476-.463,1.476-1.183,0-.756-.512-1.135-1.366-1.146a4.735,4.735,0,0,0-.841.06Z"/><path class="a" d="M226.765,627.047a.759.759,0,0,1,.689-.754c.486-.049,1.084-.079,1.823-.079a3.938,3.938,0,0,1,2.512.658,2.4,2.4,0,0,1,.879,1.9,2.624,2.624,0,0,1-.757,1.951,3.806,3.806,0,0,1-2.67.865,4.816,4.816,0,0,1-.635-.036v2.183a.757.757,0,0,1-.756.756h-.333a.756.756,0,0,1-.756-.756h0Zm1.841,3.069a2.822,2.822,0,0,0,.622.048c.988,0,1.6-.5,1.6-1.341,0-.756-.524-1.207-1.451-1.207a3.152,3.152,0,0,0-.769.073Z"/><path class="a" d="M240.634,631.343c-.037-.988-.074-2.183-.074-3.378h-.036c-.256,1.049-.6,2.22-.915,3.183l-.836,2.676a.756.756,0,0,1-.722.532h-.318A.757.757,0,0,1,237,633.8l-.725-2.628c-.268-.963-.548-2.134-.744-3.207h-.024c-.049,1.11-.085,2.378-.147,3.4l-.112,2.4a.757.757,0,0,1-.756.721H234.3a.756.756,0,0,1-.756-.758v-.042l.428-6.706a.758.758,0,0,1,.756-.708h1.2a.757.757,0,0,1,.726.543l.645,2.2c.256.951.512,1.976.695,2.94h.037c.231-.951.512-2.037.78-2.951l.709-2.207a.755.755,0,0,1,.72-.525H241.4a.757.757,0,0,1,.756.715l.369,6.706a.757.757,0,0,1-.713.8h-.333a.757.757,0,0,1-.756-.727Z"/><path class="a" d="M240.316,612.23,238,614.806a9.351,9.351,0,0,1,.948,1.306l3.252-1.286A12.737,12.737,0,0,0,240.316,612.23Z"/><path class="a" d="M243.676,621.913h-3.463a9.144,9.144,0,0,1-.8,2.843h3.706A12.631,12.631,0,0,0,243.676,621.913Z"/><path class="a" d="M232.314,611.722a9.18,9.18,0,0,1,3.741,1.393l2.327-2.585a12.628,12.628,0,0,0-6.068-2.3Z"/><path class="a" d="M239.95,618.482c.075.281.136.566.185.856h3.488a12.616,12.616,0,0,0-.441-2.134Z"/><path class="a" d="M222.647,624.756a9.221,9.221,0,0,1,7.092-13.033v-3.487a12.692,12.692,0,0,0-10.8,16.52Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "025",
				label: "Idle",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20.002" height="27.644" viewBox="0 0 20.002 27.644"><g transform="translate(-475.999 -608.525)"><path class="a" d="M495.776,625a.286.286,0,0,0,.222-.319l-.071-.481a.286.286,0,0,0-.266-.243l-1.193-.065a.283.283,0,0,0-.146.031l-.324.167a.274.274,0,0,0-.133.3l-1.645-2.829a2.067,2.067,0,0,0-1.788-1.028H481.57a2.066,2.066,0,0,0-1.785,1.033l-1.651,2.862a.28.28,0,0,0-.133-.34l-.324-.167a.283.283,0,0,0-.146-.031l-1.193.065a.286.286,0,0,0-.266.243l-.07.481a.284.284,0,0,0,.222.319l1.3.281a.272.272,0,0,0,.129-.017l-1.08,1.872a2.058,2.058,0,0,0-.276,1.007l-.044,3.557a2.052,2.052,0,0,0,.348,1.165,1.06,1.06,0,0,0-.218.619v1.6a1.083,1.083,0,1,0,2.167,0v-1.259l7.377.653v.009l.055-.005.054.005-.006-.007,7.46-.654v1.258a1.084,1.084,0,1,0,2.167,0v-1.6a1.061,1.061,0,0,0-.218-.62,2.061,2.061,0,0,0,.346-1.163l-.045-3.552a2.078,2.078,0,0,0-.28-1.014l-1.086-1.867a.269.269,0,0,0,.1.013Zm-17.312-.273,1.82-3.272a.447.447,0,0,1,.39-.229h10.674a.447.447,0,0,1,.387.223l1.884,3.272a.446.446,0,0,1-.387.669H478.855a.446.446,0,0,1-.391-.663Zm2.38,4.565a.294.294,0,0,1-.157.031l-3.721-.3a.291.291,0,0,1-.266-.314.283.283,0,0,1,.024-.1l.522-1.171a.292.292,0,0,1,.326-.166l2.724.573a.291.291,0,0,1,.2.149l.475.9A.292.292,0,0,1,480.844,629.3Zm8.592.264-3.393.345-3.312-.306-1.036-1.4h8.635Zm5.352-2.113.523,1.171a.29.29,0,0,1-.243.409l-3.721.3a.288.288,0,0,1-.165-.035.292.292,0,0,1-.116-.4l.475-.9a.291.291,0,0,1,.2-.149l2.721-.566A.291.291,0,0,1,494.788,627.447Z"/><rect class="a" width="3.575" height="10.213" rx="1.005" transform="translate(481.148 608.525)"/><rect class="a" width="3.575" height="10.213" rx="1.005" transform="translate(487.276 608.525)"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "071",
				label: "Desvio de ruta",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="29.392" height="26.504" viewBox="0 0 29.392 26.504"><path class="a" d="M755.737,632.321l-2.266-13.014a1.355,1.355,0,0,0-1.338-1.126H730.441a1.363,1.363,0,0,0-1.329,1.082l-2.718,13.014a1.357,1.357,0,0,0,1.329,1.635H754.4a1.358,1.358,0,0,0,1.339-1.591Zm-8.391-10.832.008.074a.747.747,0,0,1-.663.82h-.072a.74.74,0,0,1-.738-.664l-.007-.074a.743.743,0,0,1,.659-.82c.023,0,.047,0,.071,0A.739.739,0,0,1,747.346,621.489Zm-1.555-2.894h.071a.738.738,0,0,1,.747.666l.01.074a.74.74,0,0,1-.66.817h-.082a.744.744,0,0,1-.738-.663l-.009-.074A.749.749,0,0,1,745.791,618.595ZM731.258,631.8a.794.794,0,0,1-.744.587.59.59,0,0,1-.172-.022.763.763,0,0,1-.458-.326.684.684,0,0,1-.082-.545l.021-.072a.743.743,0,0,1,.718-.554h0a.753.753,0,0,1,.641.369A.737.737,0,0,1,731.258,631.8Zm.583-2.234a.8.8,0,0,1-.746.594.635.635,0,0,1-.168-.022l-.026-.006a.711.711,0,0,1-.518-.863l.019-.072a.741.741,0,0,1,.718-.558h0a.723.723,0,0,1,.185.024.744.744,0,0,1,.536.9Zm.9-1.542a.8.8,0,0,1-.5.173.726.726,0,0,1-.567-.255l-.012-.014a.712.712,0,0,1,.077-1l.069-.059a.747.747,0,0,1,.467-.165h0a.746.746,0,0,1,.466,1.325Zm1.691-.557h-.074a.744.744,0,1,1,0-1.488h.074a.744.744,0,0,1,0,1.488Zm2.3,0a.775.775,0,0,1-.782-.745c0-.011,0-.021,0-.032a.71.71,0,0,1,.709-.711h.074a.744.744,0,0,1,0,1.488Zm2.3,0h-.072a.744.744,0,1,1,0-1.488h.072a.744.744,0,1,1,0,1.488Zm2.3,0h-.077a.744.744,0,0,1,0-1.488h.077a.744.744,0,0,1,0,1.488Zm2.323,0h-.1a.744.744,0,0,1,0-1.488l.014,0a.8.8,0,0,1,.809.72A.75.75,0,0,1,743.662,627.467Zm2.589-1.046-.06.055a.735.735,0,0,1-.5.193.743.743,0,0,1-.743-.788.731.731,0,0,1,.245-.507l.05-.047a.737.737,0,0,1,.494-.2.747.747,0,0,1,.753.778A.739.739,0,0,1,746.251,626.421Zm1.248-2.435v.059a.744.744,0,0,1-.734.636.568.568,0,0,1-.108-.01.743.743,0,0,1-.489-.291.735.735,0,0,1-.14-.551l.01-.054a.742.742,0,0,1,.738-.656c.026,0,.052,0,.077.005a.75.75,0,0,1,.652.829A.189.189,0,0,0,747.5,623.986Zm-1.65-6.958.008.074a.744.744,0,0,1-.659.819.752.752,0,0,1-.082,0,.741.741,0,0,1-.737-.663l-.008-.074a.743.743,0,0,1,1.478-.16Zm.008-2.157a.743.743,0,0,1-.658.819h0a.752.752,0,0,1-.082,0,.741.741,0,0,1-.737-.663l-.008-.074a.743.743,0,1,1,1.478-.159Zm-4.54-5.559a1.115,1.115,0,0,1,1.577-1.577l2.219,2.218,2.214-2.214a1.115,1.115,0,0,1,1.577,1.577l-2.214,2.215,2.214,2.214a1.116,1.116,0,0,1-.788,1.9v0a1.11,1.11,0,0,1-.788-.327l-2.215-2.214-2.218,2.218a1.115,1.115,0,0,1-1.577-1.577l2.219-2.218Z" transform="translate(-726.365 -607.408)"/></svg>',
				active: false,
				visible: false,
			},
			{
				code: "007",
				label: "Bateria baja",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="17.854" height="29.789" viewBox="0 0 17.854 29.789"><path class="a" d="M1002.233,629.577h-12.7v3.565a.966.966,0,0,0,1.009.9h10.68a1,1,0,0,0,1.012-.924Zm-4.446,2.307h-3.811v-.743h3.811Zm6.077-21.32h-3.615a.943.943,0,0,1-.943-.944.945.945,0,0,0-.945-.944h-5.03a.945.945,0,0,0-.944.944.944.944,0,0,1-.944.944H987.9a.944.944,0,0,0-.943.944v26.013a.944.944,0,0,0,.943.944h15.967a.945.945,0,0,0,.945-.944V611.508A.945.945,0,0,0,1003.864,610.564Zm-1.131,22.577a1.47,1.47,0,0,1-1.534,1.4H990.563a1.47,1.47,0,0,1-1.53-1.4v-.623c0-.013,0-.025,0-.038V616.609a2.062,2.062,0,0,1,2.059-2.058h9.58a2.06,2.06,0,0,1,2.016,1.646,2.009,2.009,0,0,1,.044.42v12.46h0ZM997.906,617.9h-1.052a.482.482,0,0,1-.482-.482h0v-1.053h-.743v1.053a.482.482,0,0,1-.482.482h-1.052v.743h1.052a.482.482,0,0,1,.482.482h0v1.052h.743v-1.052a.484.484,0,0,1,.482-.483h1.052Z" transform="translate(-986.954 -608.676)"/></svg>',
				active: false,
				visible: true,
			},
			{
				code: "006",
				label: "Desconexión de GPS",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="17.852" height="29.787" viewBox="0 0 17.852 29.787"><path class="a" d="M1259.806,613.417h-17.852v-1.606a.943.943,0,0,1,.943-.943h3.547a.943.943,0,0,0,.942-.943.945.945,0,0,1,.946-.943h5.029a.943.943,0,0,1,.942.943.944.944,0,0,0,.944.943h3.617a.943.943,0,0,1,.942.943Zm-17.852,24.409a.943.943,0,0,0,.943.943h15.967a.943.943,0,0,0,.941-.944v-1.54h-17.851Zm0-23.909v12.409h0l7.38-4.607a1.605,1.605,0,0,1,2.456,1.362V626.1l8.014-4.908v-7.28Zm10.628,3.56h-1.052a.482.482,0,0,0-.482.482v1.052h-.744v-1.052h0a.482.482,0,0,0-.482-.482h-1.052v-.743h1.052a.482.482,0,0,0,.482-.482V615.2h.744v1.053h0a.482.482,0,0,0,.482.482h1.052Zm7.223,6.329-7.8,4.777a1.6,1.6,0,0,1-2.445-1.364v-3.012l-7.607,4.75v6.828h17.852V623.806Zm-7.223,8.754h-3.813v-.743h3.813Z" transform="translate(-1241.954 -608.982)"/></svg>',
				active: false,
				visible: true,
			},
			{
				code: "032",
				label: "Exceso de velocidad",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="31.545" height="28.278" viewBox="0 0 31.545 28.278"><path class="a" d="M231.8,736.221a.414.414,0,0,1-.4.532l-.224,0a.415.415,0,0,1-.4-.527l.209-.748c.1-.348.118-.512.207-.868h.164c.089.356.119.509.226.865Zm10.483-2.152v4.477a2.931,2.931,0,0,1-2.931,2.931h-18.2a2.931,2.931,0,0,1-2.931-2.931v-4.477a2.931,2.931,0,0,1,2.931-2.931h18.2A2.931,2.931,0,0,1,242.28,734.069Zm-14.3,4.811-.284-5.18a.415.415,0,0,0-.415-.392H226.2a.415.415,0,0,0-.4.287l-.549,1.71c-.2.668-.4,1.457-.571,2.157h-.026c-.133-.7-.321-1.448-.508-2.148l-.5-1.708a.415.415,0,0,0-.4-.3H222.14a.415.415,0,0,0-.414.388l-.33,5.18v.026a.415.415,0,0,0,.415.415h.419a.413.413,0,0,0,.415-.4l.089-1.887c.044-.749.071-1.676.107-2.488h.017c.144.785.344,1.645.544,2.345l.558,2.023a.415.415,0,0,0,.4.3h.44a.413.413,0,0,0,.4-.291l.641-2.054c.232-.7.481-1.56.668-2.327h.027c0,.87.027,1.748.054,2.47l.068,1.906a.416.416,0,0,0,.415.4h.514A.414.414,0,0,0,227.978,738.88Zm5.934-.109-1.607-5.18a.414.414,0,0,0-.4-.292h-1.171a.413.413,0,0,0-.4.293l-1.583,5.18a.433.433,0,0,0-.018.124.415.415,0,0,0,.418.412h.532a.417.417,0,0,0,.4-.3l.259-.935a.416.416,0,0,1,.393-.316h1.1a.417.417,0,0,1,.4.3l.286.951a.414.414,0,0,0,.4.3h.591a.438.438,0,0,0,.125-.018A.416.416,0,0,0,233.912,738.771Zm5.126-.084-1.3-2.246a.411.411,0,0,1,0-.415l1.215-2.1a.414.414,0,0,0-.359-.622h-.568a.414.414,0,0,0-.376.24l-.4.856c-.151.349-.267.617-.41,1h-.017c-.143-.34-.277-.634-.455-1l-.413-.861a.415.415,0,0,0-.374-.235h-.589a.414.414,0,0,0-.361.618l1.211,2.145a.416.416,0,0,1,0,.41l-1.267,2.215a.411.411,0,0,0-.054.2.415.415,0,0,0,.415.415h.57a.415.415,0,0,0,.377-.241l.388-.847c.187-.419.339-.731.464-1.079h.017c.169.348.312.66.535,1.079l.429.859a.413.413,0,0,0,.371.229l.592,0a.411.411,0,0,0,.208-.056A.415.415,0,0,0,239.038,738.687Zm-3.045-14.97-6.468-.616h0c-.083-.008-.167-.012-.251-.012a2.526,2.526,0,1,0,1.42,4.614h0l5.447-3.361a.338.338,0,0,0-.148-.625Zm-17.4,3.454a10.9,10.9,0,0,1,.537-2.01.793.793,0,0,0-.391-.969l-1.783-.927a.8.8,0,0,0-1.078.343.731.731,0,0,0-.05.119,15.814,15.814,0,0,0-.751,3.263.79.79,0,0,0,.7.869c.03,0,.06,0,.09,0H217.8A.807.807,0,0,0,218.594,727.171Zm2.3-5.106a11.082,11.082,0,0,1,1.915-1.865.786.786,0,0,0,.178-1.037l-1.278-2.071a.8.8,0,0,0-1.1-.257.73.73,0,0,0-.11.082,15.966,15.966,0,0,0-2.863,3.227.79.79,0,0,0,.236,1.092.714.714,0,0,0,.07.04l1.951,1.015A.807.807,0,0,0,220.894,722.065Zm11.475-3.7a10.98,10.98,0,0,1,2.647,1.114.785.785,0,0,0,1.025-.231l2.342-3.22a.8.8,0,0,0-.291-1.185,15.779,15.779,0,0,0-5.361-1.636.79.79,0,0,0-.865.707c0,.021,0,.043,0,.064l-.1,3.593A.806.806,0,0,0,232.369,718.361Zm5.392,3.392a9.565,9.565,0,0,1,2.572,5.417.791.791,0,0,0,.789.692h4.7a.793.793,0,0,0,.8-.788c0-.027,0-.054,0-.08a14.8,14.8,0,0,0-5.212-9.871.8.8,0,0,0-1.17.13l-2.535,3.485A.807.807,0,0,0,237.761,721.753Zm-8.908-3.761a.845.845,0,0,0,.7-.711h0l.089-3.243a.8.8,0,0,0-.78-.82.811.811,0,0,0-.14.009,15.806,15.806,0,0,0-4.845,1.455.8.8,0,0,0-.39,1.062.808.808,0,0,0,.044.082L225,718.211a.806.806,0,0,0,.953.329,10.936,10.936,0,0,1,2.9-.549Z" transform="translate(-215.074 -713.199)"/></svg>',
				active: false,
				visible: true,
			},
			{
				code: "004",
				label: "Puerta abierta",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18.84" height="29.637" viewBox="0 0 18.84 29.637"><g transform="translate(-475.1 -713.352)"><path class="a" d="M479.529,725l-3.449,5.3a1.168,1.168,0,0,1-.98.532l3.379-5.251a1.174,1.174,0,0,1,.714-.505Zm14.4.006a.085.085,0,0,1-.109.051l-1.062-.4v14.544a3.789,3.789,0,0,1-3.783,3.783h-5.667a3.788,3.788,0,0,1-3.784-3.784v-8.369h.555l.078,4.869a.174.174,0,0,0,.173.176.172.172,0,0,0,.127-.052l1.178-1.177a.176.176,0,0,0,.051-.124v-3.691h0v-2.448a1.125,1.125,0,0,0-.079-.421l-1.45-3.756v.145a.086.086,0,0,1-.057.081l-1.665.62a.086.086,0,0,1-.11-.049.088.088,0,0,1,0-.062l.14-.348a.084.084,0,0,1,.044-.047l1.295-.573a.089.089,0,0,0,.034-.027l.131-.177a.231.231,0,0,0-.193-.112.25.25,0,0,0-.254.219v-6.748a3.787,3.787,0,0,1,3.784-3.781h5.667a3.787,3.787,0,0,1,3.784,3.781v6.981l.987.437a.1.1,0,0,1,.044.047l.139.348A.088.088,0,0,1,493.934,725.006Zm-13.431-8.2,2.321-2.5a.242.242,0,0,0,.044-.065l.081-.171a.258.258,0,0,0-.12-.343.255.255,0,0,0-.18-.016l-.616.164a4.689,4.689,0,0,0-2.016,2.065l-.133.575a.257.257,0,0,0,.169.3l.18.06A.257.257,0,0,0,480.5,716.806Zm2.348,9.965h6.589a1.224,1.224,0,0,0,1.193-.951l.863-3.756a1.226,1.226,0,0,0-.919-1.469c-.032-.007-.065-.013-.1-.018l-4.148-.6a1.26,1.26,0,0,0-.368,0l-4.164.66a1.224,1.224,0,0,0-1.017,1.4c0,.029.01.058.017.086l.86,3.7A1.226,1.226,0,0,0,482.851,726.771Zm7.71,11.213-.268-1.548a1.225,1.225,0,0,0-1.207-1.016h-5.954a1.223,1.223,0,0,0-1.2.971l-.328,1.55a1.242,1.242,0,0,0-.022.149,1.225,1.225,0,0,0,1.116,1.325l3.3.282a1.079,1.079,0,0,0,.212,0l3.25-.284c.034,0,.068-.007.1-.013A1.225,1.225,0,0,0,490.561,737.984Zm1.543-14.119a.175.175,0,0,0-.345-.046l-1.177,4.323a.175.175,0,0,0-.006.046v6.335a.175.175,0,0,0,.051.124l1.178,1.177a.174.174,0,0,0,.247,0,.171.171,0,0,0,.052-.119Zm.2-7.344-.21-.912a4.692,4.692,0,0,0-1.727-1.671l-.828-.221a.257.257,0,0,0-.316.179.255.255,0,0,0,.016.18l.081.171a.24.24,0,0,0,.044.065l2.321,2.5a.255.255,0,0,0,.269.069l.181-.06A.257.257,0,0,0,492.3,716.521Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "",
				label: "Mantenimiento",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24.703" height="24.701" viewBox="0 0 24.703 24.701"><g transform="translate(-1494.018 -612.009)"><path class="a" d="M1497.109,615.88v-3.093a.772.772,0,0,1,1.544-.013v.013h0v3.093a.772.772,0,0,1-1.544.013Z"/><path class="a" d="M1510.23,616.651a.77.77,0,0,0,.772-.765v-3.1a.772.772,0,1,0-1.545,0v3.093a.77.77,0,0,0,.768.772h.005Z"/><rect class="a" width="3.09" height="3.089" transform="translate(1497.108 621.286)"/><rect class="a" width="3.089" height="3.085" transform="translate(1497.109 625.918)"/><rect class="a" width="3.092" height="3.089" transform="translate(1501.738 621.286)"/><rect class="a" width="3.092" height="3.089" transform="translate(1501.738 625.918)"/><path class="a" d="M1495.564,630.4V619.738h16.988v3.093h1.545v-6.022a1.684,1.684,0,0,0-1.668-1.7h-.649v.772a1.547,1.547,0,1,1-3.093.081h0v-.853h-9.266v.772a1.547,1.547,0,1,1-3.093.078q0-.039,0-.078v-.772h-.638a1.685,1.685,0,0,0-1.672,1.7v0h0V630.4a1.686,1.686,0,0,0,1.672,1.695h9.14v-1.541h-9.14a.146.146,0,0,1-.129-.151Z"/><rect class="a" width="3.09" height="3.089" transform="translate(1506.375 621.286)"/><path class="a" d="M1517.743,629.713h-.015l-.211-.011a.344.344,0,0,1-.307-.266,5.086,5.086,0,0,0-.3-.881.342.342,0,0,1,.078-.4l.164-.145a1.062,1.062,0,0,0,.094-1.5h0l-.115-.129a1.061,1.061,0,0,0-1.5-.094l0,0h0l-.163.144a.334.334,0,0,1-.4.031,4.954,4.954,0,0,0-.837-.41.343.343,0,0,1-.223-.338l.012-.211a1.065,1.065,0,0,0-1-1.128h0l-.169-.013a1.068,1.068,0,0,0-1.129,1l-.011.211a.345.345,0,0,1-.266.307,5.172,5.172,0,0,0-.881.3.344.344,0,0,1-.4-.079l-.146-.161a1.061,1.061,0,0,0-1.5-.1l0,0h0l-.127.108a1.06,1.06,0,0,0-.1,1.5l0,0h0l.145.163a.345.345,0,0,1,.031.4,4.911,4.911,0,0,0-.41.837.344.344,0,0,1-.343.224l-.211-.012a1.064,1.064,0,0,0-1.129.995v.005l-.011.168a1.064,1.064,0,0,0,.995,1.129h.005l.21.012a.349.349,0,0,1,.308.265,5,5,0,0,0,.3.881.343.343,0,0,1-.078.4l-.163.145a1.062,1.062,0,0,0-.1,1.5l0,0h0l.108.129a1.063,1.063,0,0,0,1.5.092h0l.164-.144a.334.334,0,0,1,.4-.031,4.929,4.929,0,0,0,.839.41.337.337,0,0,1,.223.338l-.012.211a1.065,1.065,0,0,0,1,1.128h0l.168.013a1.066,1.066,0,0,0,1.129-1h0l.012-.211a.344.344,0,0,1,.266-.307,5,5,0,0,0,.881-.3.344.344,0,0,1,.4.079l.144.164a1.063,1.063,0,0,0,1.5.093h0l.127-.115a1.062,1.062,0,0,0,.094-1.5h0l-.144-.163a.342.342,0,0,1-.031-.4,4.915,4.915,0,0,0,.41-.837.344.344,0,0,1,.338-.223l.212.012a1.067,1.067,0,0,0,1.129-1l.011-.169A1.057,1.057,0,0,0,1517.743,629.713Zm-5.192,3.389a2.558,2.558,0,1,1,2.558-2.559h0A2.559,2.559,0,0,1,1512.551,633.1Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "999",
				label: "Perdida de Señal",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="23.357" height="27.31" viewBox="0 0 23.357 27.31"><g transform="translate(-727.486 -715.341)"><path class="a" d="M740.445,730.764l-5.026-5.025A5.609,5.609,0,0,0,740.445,730.764Z"/><path class="a" d="M749.893,729.378c-.328.536-.66,1.081-1,1.66l-1.9,3.12-3.808-3.808a5.61,5.61,0,1,0-7.353-7.356l-3.1-3.108a9.826,9.826,0,0,1,17.164,9.492Zm-20.5-10.591a1.115,1.115,0,0,0-1.577,1.577l3.448,3.448a9.723,9.723,0,0,0,.85,5.567H732.1l.082.145a9.723,9.723,0,0,0,.6,1.056l6.279,11.09a1.933,1.933,0,0,0,3.335.052l2.563-4.215,2.711,2.711a1.108,1.108,0,0,0,.788.327v0a1.115,1.115,0,0,0,.788-1.9Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "001",
				label: "Botón de panico",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="28.975" height="29.109" viewBox="0 0 28.975 29.109"><g transform="translate(-980.385 -711.449)"><path class="a" d="M986.8,735.692a2.433,2.433,0,1,0,2.435,2.433A2.434,2.434,0,0,0,986.8,735.692Zm0,3.939a1.505,1.505,0,1,1,1.506-1.505A1.505,1.505,0,0,1,986.806,739.631Zm17.866-3.939a2.433,2.433,0,1,0,2.435,2.433A2.434,2.434,0,0,0,1004.672,735.692Zm0,3.939a1.505,1.505,0,1,1,1.506-1.505A1.505,1.505,0,0,1,1004.672,739.631Zm4.509-3.654h-.088v-.284h0v-2.615h-.013a.938.938,0,0,0-.565-.822l-2.383-.837a.837.837,0,0,1-.453-.407l-1.777-3.388a.785.785,0,0,0-.683-.448h-2.7a.883.883,0,0,1-.8-.945v-2.175a.883.883,0,0,0-.8-.943H981.188a.881.881,0,0,0-.8.943v13.126a.883.883,0,0,0,.8.945h2.682v0a2.935,2.935,0,0,1,5.87,0v0h12v0a2.928,2.928,0,0,1,5.847-.227l.505-.419h.869a.185.185,0,0,0,.172-.159l.222-1.087a.153.153,0,0,0,.007-.036A.2.2,0,0,0,1009.181,735.977Zm-14.1-4.478a.535.535,0,0,1-.535.533h-1.977a.534.534,0,0,0-.534.533v1.978a.535.535,0,0,1-.533.533h-1.772a.536.536,0,0,1-.534-.533v-1.978a.533.533,0,0,0-.532-.533h-1.977a.535.535,0,0,1-.536-.533v-1.772a.535.535,0,0,1,.536-.533h1.977a.534.534,0,0,0,.532-.535v-1.975a.535.535,0,0,1,.534-.535h1.772a.535.535,0,0,1,.533.535v1.975a.536.536,0,0,0,.534.535h1.977a.535.535,0,0,1,.535.533Zm9.817-.18a.406.406,0,0,1-.344.2h-4.1a.471.471,0,0,1-.426-.5v-2.925a.47.47,0,0,1,.426-.5l2.663,0a.418.418,0,0,1,.37.251l1.436,2.925A.573.573,0,0,1,1004.9,731.319Z"/><path class="a" d="M1000.222,724.092v2.036a1.274,1.274,0,0,0,.463-.971v-.26a.41.41,0,0,1,.3-.39,5.559,5.559,0,0,0,1.046-.433.437.437,0,0,1,.2-.051.4.4,0,0,1,.284.116l.183.185a1.293,1.293,0,0,0,1.825,0l.145-.147a1.286,1.286,0,0,0,0-1.823l-.183-.183a.412.412,0,0,1-.067-.486,5.66,5.66,0,0,0,.435-1.046.41.41,0,0,1,.39-.3h.26a1.29,1.29,0,0,0,1.289-1.289v-.2a1.293,1.293,0,0,0-1.289-1.292h-.26a.408.408,0,0,1-.39-.3,5.567,5.567,0,0,0-.435-1.046.409.409,0,0,1,.067-.486l.183-.183a1.289,1.289,0,0,0,0-1.826l-.145-.144a1.293,1.293,0,0,0-1.825,0l-.183.183a.39.39,0,0,1-.282.117.437.437,0,0,1-.2-.052,5.823,5.823,0,0,0-1.046-.433.41.41,0,0,1-.3-.39v-.26a1.292,1.292,0,0,0-1.292-1.289h-.2a1.291,1.291,0,0,0-1.289,1.289V713a.409.409,0,0,1-.3.39,5.855,5.855,0,0,0-1.046.433.431.431,0,0,1-.2.052.4.4,0,0,1-.283-.117l-.183-.183a1.29,1.29,0,0,0-1.823,0l-.146.144a1.3,1.3,0,0,0,0,1.826l.185.183a.409.409,0,0,1,.065.486,5.652,5.652,0,0,0-.433,1.046.408.408,0,0,1-.39.3h-.259a1.294,1.294,0,0,0-1.292,1.292v.2a1.292,1.292,0,0,0,1.292,1.289h.259a.41.41,0,0,1,.39.3,5.652,5.652,0,0,0,.433,1.046.412.412,0,0,1-.065.486l-.185.183a1.247,1.247,0,0,0-.173.259h5.17A1.4,1.4,0,0,1,1000.222,724.092Zm-4.048-5.143a3.127,3.127,0,0,1,3.124-3.122h0a3.123,3.123,0,1,1-3.124,3.122Zm-10.4,3.665h-2.1a.757.757,0,0,1-.688-.75v-.12a.766.766,0,0,1,.763-.765h.154a.242.242,0,0,0,.23-.178,3.839,3.839,0,0,1,.258-.618.244.244,0,0,0-.039-.289l-.107-.108a.768.768,0,0,1,0-1.083l.084-.086a.764.764,0,0,1,1.083,0l.107.111a.242.242,0,0,0,.168.069.268.268,0,0,0,.121-.031,3.267,3.267,0,0,1,.621-.257.243.243,0,0,0,.176-.231v-.154a.766.766,0,0,1,.765-.765h.12a.764.764,0,0,1,.765.765v.154a.244.244,0,0,0,.178.231,3.24,3.24,0,0,1,.618.257.269.269,0,0,0,.122.031.236.236,0,0,0,.167-.069l.109-.111a.763.763,0,0,1,1.082,0l.085.086a.771.771,0,0,1,0,1.083l-.111.108a.245.245,0,0,0-.039.289,3.24,3.24,0,0,1,.258.618.244.244,0,0,0,.231.178h.154a.767.767,0,0,1,.766.765v.12a.759.759,0,0,1-.687.749h-2.1a1.825,1.825,0,0,0,.2-.811,1.855,1.855,0,0,0-1.853-1.852h0a1.854,1.854,0,0,0-1.85,1.853A1.832,1.832,0,0,0,985.779,722.614Z"/></g></svg>',
				active: false,
				visible: true,
			},
			{
				code: "019",
				label: "Barredora",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="28.502" height="25.088" viewBox="0 0 28.502 25.088"><path class="a" d="M1265.108,739.125l-2.856-4.711a.452.452,0,0,0-.318-.2.584.584,0,0,0-.226-1.122h-.276l-.033-1.832a.373.373,0,0,0-.373-.371h-.255a.617.617,0,0,0,.546-.68l-.291-2.533a.668.668,0,0,0-.07-.22l-1.022-1.917-.022-.041c0-.009-.013-.018-.013-.027l-.068-.178h2.273a.242.242,0,0,0,.24-.291l-.345-1.525a.239.239,0,0,0-.236-.191h-.02l-1.628.136a.249.249,0,0,0-.222.235l-.019.589a.243.243,0,0,1-.244.236.235.235,0,0,0-.1.023l-.606-1.566a7.028,7.028,0,0,0-6.982-8.211h-1.749a7.029,7.029,0,0,0-6.992,8.133l-.605,1.641a.277.277,0,0,0-.106-.023.239.239,0,0,1-.239-.235l-.023-.589a.245.245,0,0,0-.221-.235l-1.628-.136h-.02a.24.24,0,0,0-.236.191l-.345,1.525a.253.253,0,0,0,.051.207.245.245,0,0,0,.189.088h2.284l-.108.291a.531.531,0,0,1-.047.1l-1.119,1.86a.667.667,0,0,0-.087.26l-.211,2.313a.621.621,0,0,0,.161.47.608.608,0,0,0,.452.2h3.518a.6.6,0,0,1,.164.023l-3.973-.021a.377.377,0,0,0-.272.113.372.372,0,0,0-.1.268l.027,1.92h-.5a.583.583,0,0,0-.584.584.577.577,0,0,0,.424.552.439.439,0,0,0-.258.177l-3.05,4.711a.453.453,0,0,0,.381.7H1250.6a.215.215,0,0,1,.39-.072.46.46,0,0,0,.247.072h13.481a.454.454,0,0,0,.388-.69Zm-26.019.081-.6-.089c-.092-.014.04-.4.268-.794l1.52-2.6c.161-.276.32-.463.385-.454l.3.044c.059.012.015.212-.112.484l-1.216,2.646C1239.451,738.843,1239.181,739.22,1239.089,739.206Zm3.412-3.41-.53,2.7c-.079.407-.3.783-.436.76l-.912-.15c-.14-.023-.13-.425.018-.819l.992-2.624c.1-.279.249-.463.347-.446l.45.073C1242.527,735.307,1242.556,735.514,1242.5,735.8Zm2.114,3.431h-1.564c-.242,0-.418-.4-.356-.813l.41-2.723c.042-.283.188-.481.356-.479h.77c.169,0,.316.2.357.492l.383,2.723C1245.029,738.832,1244.854,739.227,1244.615,739.227Zm15.732-10.942a.374.374,0,0,1,.349.335l.077.741a.366.366,0,0,1-.094.288.377.377,0,0,1-.276.125l-2.914.016a.378.378,0,0,1-.373-.406l.054-.647a.377.377,0,0,1,.258-.324l.709-.228a.341.341,0,0,1,.114-.019l.024,0Zm-17.075-4.653,1.277-2.772.225-.488a.69.69,0,0,1,.048-.073.736.736,0,0,1,.621-.354l3.064,0h8.166a.74.74,0,0,1,.68.448l1.4,3.256.006.016a.736.736,0,0,1-.685,1.011h-14.131a.735.735,0,0,1-.671-1.042Zm13.121,6-.131,1.855a.8.8,0,0,1-.8.746h-8.78a.808.808,0,0,1-.8-.732l-.162-1.855a.8.8,0,0,1,.8-.873l9.075,0a.8.8,0,0,1,.8.856Zm-11.441.011a.37.37,0,0,1-.275.121l-2.911-.019a.366.366,0,0,1-.275-.121.379.379,0,0,1-.1-.289l.078-.741a.374.374,0,0,1,.349-.335l2.072-.117h.027a.346.346,0,0,1,.111.015l.71.23a.371.371,0,0,1,.256.324l.057.647A.371.371,0,0,1,1244.952,729.646Zm2.291,9.46-.912.15c-.137.023-.357-.353-.437-.76l-.53-2.7c-.056-.282-.027-.489.072-.506l.449-.073c.1-.017.242.167.347.446l.992,2.624C1247.373,738.681,1247.382,739.083,1247.243,739.106Zm2.1.011-.6.089c-.093.014-.363-.363-.546-.763l-1.216-2.646c-.127-.272-.172-.472-.111-.484l.3-.044c.065-.009.224.178.385.454l1.52,2.6C1249.307,738.717,1249.439,739.1,1249.347,739.117Zm1.575-.1-1.742-2.874h3.6Zm2.243.192-.612-.089c-.094-.014.041-.4.273-.794l1.551-2.6c.164-.276.327-.463.393-.454l.3.044c.067.012.022.212-.107.484l-1.241,2.646C1253.535,738.843,1253.259,739.22,1253.165,739.206Zm3.484-3.41-.541,2.7c-.081.407-.3.783-.446.76l-.931-.15c-.143-.023-.133-.425.019-.819l1.012-2.624c.108-.279.254-.463.354-.446l.459.073C1256.675,735.307,1256.7,735.514,1256.649,735.8Zm2.16,3.431h-1.6c-.246,0-.426-.4-.363-.813l.418-2.723c.044-.283.193-.481.367-.479h.787c.172,0,.322.2.364.492l.391,2.723C1259.232,738.832,1259.053,739.227,1258.809,739.227Zm2.679-.121-.931.15c-.146.023-.365-.353-.446-.76l-.541-2.7c-.056-.282-.027-.489.074-.506l.459-.073c.1-.017.246.167.354.446l1.012,2.624C1261.621,738.681,1261.631,739.083,1261.488,739.106Zm2.146.011-.612.089c-.094.014-.37-.363-.557-.763l-1.241-2.646c-.129-.272-.174-.472-.107-.484l.3-.044c.066-.009.228.178.393.454l1.551,2.6C1263.593,738.717,1263.728,739.1,1263.634,739.117Z" transform="translate(-1236.672 -714.727)"/></svg>',
				active: false,
				visible: true,
			},
			{
				code: "021",
				label: "Grua",
				short: "",
				icon: '<svg xmlns="http://www.w3.org/2000/svg" width="32.004" height="17.345" viewBox="0 0 32.004 17.345"><path class="a" d="M1496.447,731.66a2.933,2.933,0,1,0,2.933,2.933A2.933,2.933,0,0,0,1496.447,731.66Zm0,4.443a1.51,1.51,0,1,1,1.51-1.51A1.51,1.51,0,0,1,1496.447,736.1Zm17.358-4.443a2.933,2.933,0,1,0,2.933,2.933A2.933,2.933,0,0,0,1513.805,731.66Zm0,4.443a1.51,1.51,0,1,1,1.51-1.51A1.51,1.51,0,0,1,1513.805,736.1Zm8.146-8.637a1.553,1.553,0,0,0-.15-.376,1.537,1.537,0,0,0-.137-.194,1.084,1.084,0,0,1-.5,1.271,1.069,1.069,0,0,1-.555.14.75.75,0,0,1-.691-.767l0-.265v-5.44h0a1.653,1.653,0,0,0-3.277-.307h-1.366a.265.265,0,0,0-.188.078l-7.855,7.855h-2.145a.723.723,0,0,1-.722-.721V723.6a.723.723,0,0,0-.721-.721h-7.084a.829.829,0,0,0-.728.477l-1.9,3.626a.9.9,0,0,1-.487.436l-2.548.9a1,1,0,0,0-.6.879h-.016v2.8h.006v.3h-.1a.216.216,0,0,0-.189.241.2.2,0,0,0,.006.033l.238,1.161a.2.2,0,0,0,.183.17h.924l.612.509a.78.78,0,0,0,.493.183h.561a3.433,3.433,0,1,1,6.866,0h10.492a3.433,3.433,0,1,1,6.866,0h.268a.946.946,0,0,0,.864-1.015v-3.56a.559.559,0,0,0-.559-.557h-.11v-6.076a1.6,1.6,0,0,0,1.227-.039v4.33a1.535,1.535,0,0,0,.389,1.218l.032.034a1.528,1.528,0,0,0,1.484.42A1.548,1.548,0,0,0,1521.951,727.466Zm-21.981-.473h0a.5.5,0,0,1-.459.538h-4.382a.433.433,0,0,1-.368-.219.617.617,0,0,1-.03-.592l1.538-3.128a.451.451,0,0,1,.4-.27h2.842a.506.506,0,0,1,.459.541Zm16.053,2.468H1509.5l6.116-6.116a.265.265,0,0,1,.454.191C1516.043,724.907,1515.99,728.042,1516.023,729.461Z" transform="translate(-1489.996 -720.181)"/></svg>',
				active: false,
				visible: true,
			},
			{
				code: "200",
				label: "Giro brusco a la izquierda",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="18.128" viewBox="0 0 20 18.128"> <g id="Grupo_6113" data-name="Grupo 6113" transform="translate(0 -1.856)"> <g id="Grupo_5090-2" data-name="Grupo 5090-2" transform="translate(4.855 5.264)"> <path id="Trazado_12150" data-name="Trazado 12150" d="M446.327,272.4l1.02-.58c-.067-.518-.133-1.044-.206-1.6.411,0,.764-.027,1.111,0,.909.082,1.822.146,2.72.3a3.1,3.1,0,0,1,1.2.532,1.314,1.314,0,0,1,.4.736,7.637,7.637,0,0,1,.041,2.6c-.065.63-.168,1.255-.266,1.958l-1.6-.488-.788.879a7.325,7.325,0,0,0,9.989-9.689l-.934.762.249.728a29.484,29.484,0,0,0-5.97-.6,26.186,26.186,0,0,0-5.9.776,6.12,6.12,0,0,1,7.5-4.461l.779-.968a7.2,7.2,0,0,0-7.08,1.3A7.293,7.293,0,0,0,446.327,272.4Zm8.439,3.834c-.079-.347-.163-.652-.215-.963-.11-.661-.237-1.322-.29-1.988a8.294,8.294,0,0,1,.05-1.513.927.927,0,0,1,.621-.757,9.52,9.52,0,0,1,2.788-.621c.581-.065,1.163-.121,1.734-.181a5.283,5.283,0,0,1-.868,3.245,6.207,6.207,0,0,1-3.819,2.777ZM451,268.756a8.225,8.225,0,0,1,4.648,0Z" transform="translate(-445.543 -262.864)" /> <path id="Trazado_12151" data-name="Trazado 12151" d="M448.557,266.326c.154.346.376.446.678.222.463-.343.892-.733,1.323-1.117a.44.44,0,0,0,.077-.571,3.658,3.658,0,0,0-2.08-1.888,1.327,1.327,0,0,0-.84.02,2.063,2.063,0,0,0-1.225,1.308c-.168.468-.005.725.48.822.009.488.216.679.7.654C447.893,266.228,448,266.294,448.557,266.326Z" transform="translate(-435.956 -262.87)" /> <path id="Trazado_12152" data-name="Trazado 12152" d="M460.515,274.461c-.106-.346-.322-.474-.614-.292-.5.31-.962.665-1.429,1.02a.457.457,0,0,0-.123.588,3.807,3.807,0,0,0,1.906,2.028,1.12,1.12,0,0,0,.975.012,2.227,2.227,0,0,0,1.216-1.216c.183-.443.033-.712-.426-.823,0-.52-.192-.722-.676-.715C461.215,274.625,461.06,274.511,460.515,274.461Z" transform="translate(-458.292 -264.136)" /> </g> <g id="Grupo_6107" data-name="Grupo 6107" transform="translate(0 1.856)"> <g id="Grupo_6105" data-name="Grupo 6105" transform="translate(1.658)"> <path id="Trazado_12228" data-name="Trazado 12228" d="M454.449,270.365a.577.577,0,0,0,.577-.576,9.627,9.627,0,0,1,9.616-9.616.576.576,0,1,0,0-1.153,10.781,10.781,0,0,0-10.77,10.768A.576.576,0,0,0,454.449,270.365Z" transform="translate(-453.873 -259.02)" /> </g> <g id="Grupo_6106" data-name="Grupo 6106" transform="translate(0 8.129)"> <path id="Trazado_12229" data-name="Trazado 12229" d="M465.183,271.636l2.517-1.97a.576.576,0,1,0-.71-.907l-1.609,1.258-1.259-1.608a.576.576,0,1,0-.907.709Z" transform="translate(-463.091 -268.188)" /> </g> </g> </g> </svg>`,
				active: false,
				visible: true,
			},
			{
				code: "201",
				label: "Giro brusco a la derecha",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="18.128" viewBox="0 0 20 18.128"> <g id="Grupo_6112" data-name="Grupo 6112" transform="translate(-445.984 -259.02)"> <g id="Grupo_5090-2" data-name="Grupo 5090-2" transform="translate(445.984 262.429)"> <path id="Trazado_12150" data-name="Trazado 12150" d="M460.344,272.4l-1.02-.58c.067-.518.133-1.044.206-1.6-.411,0-.764-.027-1.111,0-.909.082-1.822.146-2.72.3a3.1,3.1,0,0,0-1.2.532,1.314,1.314,0,0,0-.4.736,7.637,7.637,0,0,0-.041,2.6c.065.63.168,1.255.266,1.958l1.6-.488.788.879a7.325,7.325,0,0,1-9.989-9.689l.934.762-.249.728a29.484,29.484,0,0,1,5.97-.6,26.185,26.185,0,0,1,5.9.776,6.12,6.12,0,0,0-7.5-4.461l-.779-.968a7.2,7.2,0,0,1,7.08,1.3A7.293,7.293,0,0,1,460.344,272.4Zm-8.439,3.834c.079-.347.163-.652.215-.963.11-.661.237-1.322.29-1.988a8.294,8.294,0,0,0-.05-1.513.927.927,0,0,0-.621-.757,9.523,9.523,0,0,0-2.788-.621c-.581-.065-1.162-.121-1.734-.181a5.283,5.283,0,0,0,.868,3.245,6.207,6.207,0,0,0,3.819,2.777Zm3.769-7.477a8.225,8.225,0,0,0-4.648,0Z" transform="translate(-445.984 -262.864)" /> <path id="Trazado_12151" data-name="Trazado 12151" d="M448.577,266.326c-.154.346-.376.446-.678.222-.463-.343-.892-.733-1.323-1.117a.44.44,0,0,1-.077-.571,3.658,3.658,0,0,1,2.08-1.888,1.327,1.327,0,0,1,.84.02,2.063,2.063,0,0,1,1.225,1.308c.168.468.005.725-.48.822-.009.488-.216.679-.7.654C449.241,266.228,449.135,266.294,448.577,266.326Z" transform="translate(-446.034 -262.87)" /> <path id="Trazado_12152" data-name="Trazado 12152" d="M460.3,274.461c.106-.346.322-.474.614-.292.5.31.962.665,1.429,1.02a.457.457,0,0,1,.123.588,3.807,3.807,0,0,1-1.906,2.028,1.12,1.12,0,0,1-.975.012,2.227,2.227,0,0,1-1.216-1.216c-.183-.443-.033-.712.426-.823,0-.52.192-.722.676-.715C459.6,274.625,459.754,274.511,460.3,274.461Z" transform="translate(-447.378 -264.135)" /> </g> <g id="Grupo_6107" data-name="Grupo 6107" transform="translate(452.979 259.02)"> <g id="Grupo_6105" data-name="Grupo 6105"> <path id="Trazado_12228" data-name="Trazado 12228" d="M464.643,270.365a.577.577,0,0,1-.577-.576,9.627,9.627,0,0,0-9.617-9.616.576.576,0,1,1,0-1.153,10.781,10.781,0,0,1,10.77,10.768A.576.576,0,0,1,464.643,270.365Z" transform="translate(-453.873 -259.02)" /> </g> <g id="Grupo_6106" data-name="Grupo 6106" transform="translate(8.174 8.129)"> <path id="Trazado_12229" data-name="Trazado 12229" d="M465.83,271.636l-2.517-1.97a.576.576,0,1,1,.71-.907l1.609,1.258,1.259-1.608a.576.576,0,1,1,.907.709Z" transform="translate(-463.091 -268.188)" /> </g> </g> </g> </svg>`,
				active: false,
				visible: true,
			},
			{
				code: "400",
				label: "Jamming detectado",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20"> <defs> <clipPath id="clip-path"> <rect id="Rectángulo_6978" data-name="Rectángulo 6978" width="20" height="20" /> </clipPath> </defs> <g id="Grupo_7170" data-name="Grupo 7170" clip-path="url(#clip-path)"> <path id="Trazado_12652" data-name="Trazado 12652" d="M160.849,85.2a.4.4,0,0,0,.418-.1c.037-.035.074-.07.112-.1a1.864,1.864,0,0,1,2.161-.175,2.56,2.56,0,0,1,.376.3.379.379,0,0,0,.338.1.412.412,0,0,0,.332-.3.394.394,0,0,0-.121-.42,2.69,2.69,0,0,0-3.587-.165.716.716,0,0,0-.321.417v.113a.074.074,0,0,1,.007.015.4.4,0,0,0,.284.322" transform="translate(-154.242 -80.433)" /> <path id="Trazado_12653" data-name="Trazado 12653" d="M261.5,274.69v-1l-1.424,1.424h1a.42.42,0,0,0,.42-.42" transform="translate(-249.842 -262.92)" /> <path id="Trazado_12654" data-name="Trazado 12654" d="M190.247,221.123l-1.235,1.235v1.836a1.244,1.244,0,0,1-1.259,1.257h-1.835l-.412.412.215.007a.407.407,0,0,1,.388.428.416.416,0,0,1-.422.4h-.816a.453.453,0,0,1-.165-.033l-.954.954a2.085,2.085,0,0,0,.851.307.3.3,0,0,1,.054.018h3.732c.119-.026.24-.047.357-.08a2.063,2.063,0,0,0,1.507-1.961q.009-2.319,0-4.638a1.086,1.086,0,0,0-.006-.14M188.6,226.3a.415.415,0,0,1-.417.392h-.826a.415.415,0,0,1-.416-.393.4.4,0,0,1,.364-.428,8.8,8.8,0,0,1,.931,0,.4.4,0,0,1,.363.429" transform="translate(-176.525 -212.425)" /> <path id="Trazado_12655" data-name="Trazado 12655" d="M182.1,112.565c-.054.006-.152.012-.247.03a1.473,1.473,0,0,0-.824.445.382.382,0,0,0-.073.433.394.394,0,0,0,.364.254.434.434,0,0,0,.328-.134.721.721,0,0,1,1,.006.413.413,0,0,0,.693-.153.389.389,0,0,0-.111-.437,1.567,1.567,0,0,0-1.126-.445" transform="translate(-173.803 -108.137)" /> <path id="Trazado_12656" data-name="Trazado 12656" d="M17.071,2.929a10,10,0,1,0,0,14.142,10,10,0,0,0,0-14.142M2.163,10A7.832,7.832,0,0,1,14.721,3.75L11.667,6.8c-.928-.007-1.856,0-2.784,0H8.755V5.994a.415.415,0,0,0-.83,0q-.005.374,0,.749c0,.076-.014.11-.1.131A2.072,2.072,0,0,0,6.284,8.615a.705.705,0,0,1-.018.074V12.2L3.75,14.721A7.8,7.8,0,0,1,2.163,10M9.592,8.879H8.763a.42.42,0,0,0-.42.42v.829l-.833.833V9.3A1.243,1.243,0,0,1,8.765,8.048h1.659ZM10,17.837a7.8,7.8,0,0,1-4.721-1.586L16.251,5.279A7.832,7.832,0,0,1,10,17.837" /> </g> </svg> `,
				active: false,
				visible: true,
			},
			{
				code: "090",
				label: "Cable de candado cortado",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20"> <defs> <clipPath id="clip-path"> <rect id="Rectángulo_6978" data-name="Rectángulo 6978" width="20" height="20" /> </clipPath> </defs> <g id="Grupo_7170" data-name="Grupo 7170" clip-path="url(#clip-path)"> <path id="Trazado_12652" data-name="Trazado 12652" d="M160.849,85.2a.4.4,0,0,0,.418-.1c.037-.035.074-.07.112-.1a1.864,1.864,0,0,1,2.161-.175,2.56,2.56,0,0,1,.376.3.379.379,0,0,0,.338.1.412.412,0,0,0,.332-.3.394.394,0,0,0-.121-.42,2.69,2.69,0,0,0-3.587-.165.716.716,0,0,0-.321.417v.113a.074.074,0,0,1,.007.015.4.4,0,0,0,.284.322" transform="translate(-154.242 -80.433)" /> <path id="Trazado_12653" data-name="Trazado 12653" d="M261.5,274.69v-1l-1.424,1.424h1a.42.42,0,0,0,.42-.42" transform="translate(-249.842 -262.92)" /> <path id="Trazado_12654" data-name="Trazado 12654" d="M190.247,221.123l-1.235,1.235v1.836a1.244,1.244,0,0,1-1.259,1.257h-1.835l-.412.412.215.007a.407.407,0,0,1,.388.428.416.416,0,0,1-.422.4h-.816a.453.453,0,0,1-.165-.033l-.954.954a2.085,2.085,0,0,0,.851.307.3.3,0,0,1,.054.018h3.732c.119-.026.24-.047.357-.08a2.063,2.063,0,0,0,1.507-1.961q.009-2.319,0-4.638a1.086,1.086,0,0,0-.006-.14M188.6,226.3a.415.415,0,0,1-.417.392h-.826a.415.415,0,0,1-.416-.393.4.4,0,0,1,.364-.428,8.8,8.8,0,0,1,.931,0,.4.4,0,0,1,.363.429" transform="translate(-176.525 -212.425)" /> <path id="Trazado_12655" data-name="Trazado 12655" d="M182.1,112.565c-.054.006-.152.012-.247.03a1.473,1.473,0,0,0-.824.445.382.382,0,0,0-.073.433.394.394,0,0,0,.364.254.434.434,0,0,0,.328-.134.721.721,0,0,1,1,.006.413.413,0,0,0,.693-.153.389.389,0,0,0-.111-.437,1.567,1.567,0,0,0-1.126-.445" transform="translate(-173.803 -108.137)" /> <path id="Trazado_12656" data-name="Trazado 12656" d="M17.071,2.929a10,10,0,1,0,0,14.142,10,10,0,0,0,0-14.142M2.163,10A7.832,7.832,0,0,1,14.721,3.75L11.667,6.8c-.928-.007-1.856,0-2.784,0H8.755V5.994a.415.415,0,0,0-.83,0q-.005.374,0,.749c0,.076-.014.11-.1.131A2.072,2.072,0,0,0,6.284,8.615a.705.705,0,0,1-.018.074V12.2L3.75,14.721A7.8,7.8,0,0,1,2.163,10M9.592,8.879H8.763a.42.42,0,0,0-.42.42v.829l-.833.833V9.3A1.243,1.243,0,0,1,8.765,8.048h1.659ZM10,17.837a7.8,7.8,0,0,1-4.721-1.586L16.251,5.279A7.832,7.832,0,0,1,10,17.837" /> </g> </svg> `,
				active: false,
				visible: true,
			},
			{
				code: "091",
				label: "Candado cerrado",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20"> <defs> <clipPath id="clip-path"> <rect id="Rectángulo_6978" data-name="Rectángulo 6978" width="20" height="20" /> </clipPath> </defs> <g id="Grupo_7170" data-name="Grupo 7170" clip-path="url(#clip-path)"> <path id="Trazado_12652" data-name="Trazado 12652" d="M160.849,85.2a.4.4,0,0,0,.418-.1c.037-.035.074-.07.112-.1a1.864,1.864,0,0,1,2.161-.175,2.56,2.56,0,0,1,.376.3.379.379,0,0,0,.338.1.412.412,0,0,0,.332-.3.394.394,0,0,0-.121-.42,2.69,2.69,0,0,0-3.587-.165.716.716,0,0,0-.321.417v.113a.074.074,0,0,1,.007.015.4.4,0,0,0,.284.322" transform="translate(-154.242 -80.433)" /> <path id="Trazado_12653" data-name="Trazado 12653" d="M261.5,274.69v-1l-1.424,1.424h1a.42.42,0,0,0,.42-.42" transform="translate(-249.842 -262.92)" /> <path id="Trazado_12654" data-name="Trazado 12654" d="M190.247,221.123l-1.235,1.235v1.836a1.244,1.244,0,0,1-1.259,1.257h-1.835l-.412.412.215.007a.407.407,0,0,1,.388.428.416.416,0,0,1-.422.4h-.816a.453.453,0,0,1-.165-.033l-.954.954a2.085,2.085,0,0,0,.851.307.3.3,0,0,1,.054.018h3.732c.119-.026.24-.047.357-.08a2.063,2.063,0,0,0,1.507-1.961q.009-2.319,0-4.638a1.086,1.086,0,0,0-.006-.14M188.6,226.3a.415.415,0,0,1-.417.392h-.826a.415.415,0,0,1-.416-.393.4.4,0,0,1,.364-.428,8.8,8.8,0,0,1,.931,0,.4.4,0,0,1,.363.429" transform="translate(-176.525 -212.425)" /> <path id="Trazado_12655" data-name="Trazado 12655" d="M182.1,112.565c-.054.006-.152.012-.247.03a1.473,1.473,0,0,0-.824.445.382.382,0,0,0-.073.433.394.394,0,0,0,.364.254.434.434,0,0,0,.328-.134.721.721,0,0,1,1,.006.413.413,0,0,0,.693-.153.389.389,0,0,0-.111-.437,1.567,1.567,0,0,0-1.126-.445" transform="translate(-173.803 -108.137)" /> <path id="Trazado_12656" data-name="Trazado 12656" d="M17.071,2.929a10,10,0,1,0,0,14.142,10,10,0,0,0,0-14.142M2.163,10A7.832,7.832,0,0,1,14.721,3.75L11.667,6.8c-.928-.007-1.856,0-2.784,0H8.755V5.994a.415.415,0,0,0-.83,0q-.005.374,0,.749c0,.076-.014.11-.1.131A2.072,2.072,0,0,0,6.284,8.615a.705.705,0,0,1-.018.074V12.2L3.75,14.721A7.8,7.8,0,0,1,2.163,10M9.592,8.879H8.763a.42.42,0,0,0-.42.42v.829l-.833.833V9.3A1.243,1.243,0,0,1,8.765,8.048h1.659ZM10,17.837a7.8,7.8,0,0,1-4.721-1.586L16.251,5.279A7.832,7.832,0,0,1,10,17.837" /> </g> </svg> `,
				active: false,
				visible: true,
			},
			{
				code: "092",
				label: "Candado desbloqueado",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20"> <defs> <clipPath id="clip-path"> <rect id="Rectángulo_6978" data-name="Rectángulo 6978" width="20" height="20" /> </clipPath> </defs> <g id="Grupo_7170" data-name="Grupo 7170" clip-path="url(#clip-path)"> <path id="Trazado_12652" data-name="Trazado 12652" d="M160.849,85.2a.4.4,0,0,0,.418-.1c.037-.035.074-.07.112-.1a1.864,1.864,0,0,1,2.161-.175,2.56,2.56,0,0,1,.376.3.379.379,0,0,0,.338.1.412.412,0,0,0,.332-.3.394.394,0,0,0-.121-.42,2.69,2.69,0,0,0-3.587-.165.716.716,0,0,0-.321.417v.113a.074.074,0,0,1,.007.015.4.4,0,0,0,.284.322" transform="translate(-154.242 -80.433)" /> <path id="Trazado_12653" data-name="Trazado 12653" d="M261.5,274.69v-1l-1.424,1.424h1a.42.42,0,0,0,.42-.42" transform="translate(-249.842 -262.92)" /> <path id="Trazado_12654" data-name="Trazado 12654" d="M190.247,221.123l-1.235,1.235v1.836a1.244,1.244,0,0,1-1.259,1.257h-1.835l-.412.412.215.007a.407.407,0,0,1,.388.428.416.416,0,0,1-.422.4h-.816a.453.453,0,0,1-.165-.033l-.954.954a2.085,2.085,0,0,0,.851.307.3.3,0,0,1,.054.018h3.732c.119-.026.24-.047.357-.08a2.063,2.063,0,0,0,1.507-1.961q.009-2.319,0-4.638a1.086,1.086,0,0,0-.006-.14M188.6,226.3a.415.415,0,0,1-.417.392h-.826a.415.415,0,0,1-.416-.393.4.4,0,0,1,.364-.428,8.8,8.8,0,0,1,.931,0,.4.4,0,0,1,.363.429" transform="translate(-176.525 -212.425)" /> <path id="Trazado_12655" data-name="Trazado 12655" d="M182.1,112.565c-.054.006-.152.012-.247.03a1.473,1.473,0,0,0-.824.445.382.382,0,0,0-.073.433.394.394,0,0,0,.364.254.434.434,0,0,0,.328-.134.721.721,0,0,1,1,.006.413.413,0,0,0,.693-.153.389.389,0,0,0-.111-.437,1.567,1.567,0,0,0-1.126-.445" transform="translate(-173.803 -108.137)" /> <path id="Trazado_12656" data-name="Trazado 12656" d="M17.071,2.929a10,10,0,1,0,0,14.142,10,10,0,0,0,0-14.142M2.163,10A7.832,7.832,0,0,1,14.721,3.75L11.667,6.8c-.928-.007-1.856,0-2.784,0H8.755V5.994a.415.415,0,0,0-.83,0q-.005.374,0,.749c0,.076-.014.11-.1.131A2.072,2.072,0,0,0,6.284,8.615a.705.705,0,0,1-.018.074V12.2L3.75,14.721A7.8,7.8,0,0,1,2.163,10M9.592,8.879H8.763a.42.42,0,0,0-.42.42v.829l-.833.833V9.3A1.243,1.243,0,0,1,8.765,8.048h1.659ZM10,17.837a7.8,7.8,0,0,1-4.721-1.586L16.251,5.279A7.832,7.832,0,0,1,10,17.837" /> </g> </svg> `,
				active: false,
				visible: true,
			},
			{
				code: "093",
				label: "Contraseña incorrecta del candado",
				short: "",
				icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20"> <defs> <clipPath id="clip-path"> <rect id="Rectángulo_6978" data-name="Rectángulo 6978" width="20" height="20" /> </clipPath> </defs> <g id="Grupo_7170" data-name="Grupo 7170" clip-path="url(#clip-path)"> <path id="Trazado_12652" data-name="Trazado 12652" d="M160.849,85.2a.4.4,0,0,0,.418-.1c.037-.035.074-.07.112-.1a1.864,1.864,0,0,1,2.161-.175,2.56,2.56,0,0,1,.376.3.379.379,0,0,0,.338.1.412.412,0,0,0,.332-.3.394.394,0,0,0-.121-.42,2.69,2.69,0,0,0-3.587-.165.716.716,0,0,0-.321.417v.113a.074.074,0,0,1,.007.015.4.4,0,0,0,.284.322" transform="translate(-154.242 -80.433)" /> <path id="Trazado_12653" data-name="Trazado 12653" d="M261.5,274.69v-1l-1.424,1.424h1a.42.42,0,0,0,.42-.42" transform="translate(-249.842 -262.92)" /> <path id="Trazado_12654" data-name="Trazado 12654" d="M190.247,221.123l-1.235,1.235v1.836a1.244,1.244,0,0,1-1.259,1.257h-1.835l-.412.412.215.007a.407.407,0,0,1,.388.428.416.416,0,0,1-.422.4h-.816a.453.453,0,0,1-.165-.033l-.954.954a2.085,2.085,0,0,0,.851.307.3.3,0,0,1,.054.018h3.732c.119-.026.24-.047.357-.08a2.063,2.063,0,0,0,1.507-1.961q.009-2.319,0-4.638a1.086,1.086,0,0,0-.006-.14M188.6,226.3a.415.415,0,0,1-.417.392h-.826a.415.415,0,0,1-.416-.393.4.4,0,0,1,.364-.428,8.8,8.8,0,0,1,.931,0,.4.4,0,0,1,.363.429" transform="translate(-176.525 -212.425)" /> <path id="Trazado_12655" data-name="Trazado 12655" d="M182.1,112.565c-.054.006-.152.012-.247.03a1.473,1.473,0,0,0-.824.445.382.382,0,0,0-.073.433.394.394,0,0,0,.364.254.434.434,0,0,0,.328-.134.721.721,0,0,1,1,.006.413.413,0,0,0,.693-.153.389.389,0,0,0-.111-.437,1.567,1.567,0,0,0-1.126-.445" transform="translate(-173.803 -108.137)" /> <path id="Trazado_12656" data-name="Trazado 12656" d="M17.071,2.929a10,10,0,1,0,0,14.142,10,10,0,0,0,0-14.142M2.163,10A7.832,7.832,0,0,1,14.721,3.75L11.667,6.8c-.928-.007-1.856,0-2.784,0H8.755V5.994a.415.415,0,0,0-.83,0q-.005.374,0,.749c0,.076-.014.11-.1.131A2.072,2.072,0,0,0,6.284,8.615a.705.705,0,0,1-.018.074V12.2L3.75,14.721A7.8,7.8,0,0,1,2.163,10M9.592,8.879H8.763a.42.42,0,0,0-.42.42v.829l-.833.833V9.3A1.243,1.243,0,0,1,8.765,8.048h1.659ZM10,17.837a7.8,7.8,0,0,1-4.721-1.586L16.251,5.279A7.832,7.832,0,0,1,10,17.837" /> </g> </svg> `,
				active: false,
				visible: true,
			},
		],
		searchbar: {
			placeholder: {
				realtime: "Encontrar el vehículo más cercano a...",
				geofences: "Buscar....",
			},
			filters: [
				{
					value: "all",
					label: "Todos",
				},
				{
					value: "establishments",
					label: "Establecimientos",
				},
				{
					value: "address",
					label: "Dirección",
				},
				{
					value: "coordinates",
					label: "Coordenadas",
				},
			],
			coordinates: {
				valid: `Ejemplos de Fomatos admitidos para coordenadas:<br>28.385200, -81.563900<br>28 23.112, -81 33.834<br>28°23'06.7"N 81°33'50.0"W<br>28.3852° N, 81.5639° W`,
				invalid: "Formato inválido",
			},
		},
		roles: [
			{
				code: "1",
				label: "Cliente",
			},
			{
				code: "2",
				label: "Usuario",
			},
		],
		permissions: [
			{
				name: "Realtime",
				label: "Realtime",
				access: true,
				subModules: [],
				components: [
					{
						component: "Events",
						label: "Tabla de Eventos",
						access: false,
						controller: {
							name: "Trackings",
							method: "dailyPanel",
						},
					},
					{
						component: "Geofences",
						label: "Mostrar/Ocultar Geocercas",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Pois",
						label: "Mostrar/Ocultar POI's",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Direction Accounts",
						label: "HIDDEN",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Quick History",
						label: "Historial Rápido",
						access: false,
						controller: {
							name: "Trackings",
							method: "quickHistory",
						},
					},
					{
						component: "Center Device",
						label: "Centrar Dispositivo",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Show/Hide Device",
						label: "Mostrar/Ocultar Dispositivo",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
				],
			},
			{
				name: "History",
				label: "Histórico",
				access: false,
				subModules: [],
				components: [
					{
						component: "Consult History",
						label: "Consultar Historico",
						access: false,
						controller: {
							name: "Trackings",
							method: "multiHistory",
						},
					},
					{
						component: "Geofences",
						label: "Mostrar/Ocultar Geocercas",
						access: false,
						controller: {
							name: "Geofences",
							method: "findAll",
						},
					},
					{
						component: "Pois",
						label: "Mostrar/Ocultar POIs",
						access: false,
						controller: {
							name: "Points",
							method: "findAll",
						},
					},
					{
						component: "Center Device",
						label: "Centrar Dispositivo",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Show/Hide Device",
						label: "Mostrar/Ocultar Dispositivo",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Show/Hide Route",
						label: "Mostrar/Ocultar Ruta",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
				],
			},
			{
				name: "Reports",
				label: "Reportes",
				access: false,
				subModules: [],
				components: [
					{
						component: "Consult Report",
						label: "Consultar Reporte",
						access: false,
						controller: {
							name: "Trackings",
							method: "reports",
						},
					},
					{
						component: "Event Report",
						label: "Consultar Reporte de Eventos",
						access: false,
						controller: {
							name: "Trackings",
							method: "eventReport",
						},
					},
					{
						component: "Quick Report",
						label: "Consultar Reporte rápido de Eventos",
						access: false,
						controller: {
							name: "Trackings",
							method: "quickReport",
						},
					},
				],
			},
			{
				name: "Geofences",
				label: "Geocercas",
				access: false,
				subModules: [],
				components: [
					{
						component: "Find Geofences",
						label: "Buscar Geocercas",
						access: false,
						controller: {
							name: "Geofences",
							method: "findAll",
						},
					},
					{
						component: "Create Geofence",
						label: "Crear Geocerca",
						access: false,
						controller: {
							name: "Geofences",
							method: "create",
						},
					},
					{
						component: "Update Geofence",
						label: "Actualizar Geocerca",
						access: false,
						controller: {
							name: "Geofences",
							method: "update",
						},
					},
					{
						component: "Delete Geofence",
						label: "Eliminar Geocerca",
						access: false,
						controller: {
							name: "Geofences",
							method: "delete",
						},
					},
					{
						component: "Import Geofences",
						label: "Importar Geocercas",
						access: false,
						controller: {
							name: "Geofences",
							method: "create",
						},
					},
					{
						component: "Export Geofences",
						label: "Exportar Geocercas",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
					{
						component: "Find POI",
						label: "Buscar POIs",
						access: false,
						controller: {
							name: "Points",
							method: "findAll",
						},
					},
					{
						component: "Create POI",
						label: "Crear POI",
						access: false,
						controller: {
							name: "Points",
							method: "create",
						},
					},
					{
						component: "Update POI",
						label: "Actualizar POI",
						access: false,
						controller: {
							name: "Points",
							method: "update",
						},
					},
					{
						component: "Delete POI",
						label: "Eliminar POI",
						access: false,
						controller: {
							name: "Points",
							method: "delete",
						},
					},
					{
						component: "Import POIs",
						label: "Importar POI's",
						access: false,
						controller: {
							name: "Points",
							method: "create",
						},
					},
					{
						component: "Export POIs",
						label: "Exportar POI's",
						access: false,
						controller: {
							name: "NA",
							method: "NA",
						},
					},
				],
			},
			{
				name: "Maintenance",
				label: "Mantenimiento",
				access: false,
				subModules: [
					{
						controller: "Maintenances",
						label: "Tablero",
						access: false,
						methods: [
							{
								name: "dashboard",
								label: "Visualizar Mantenimientos",
								access: false,
							},
						],
						components: [
							{
								name: "Load Schedule",
								label: "Editar servicio",
								access: false,
								controller: {
									name: "Schedules",
									method: "findById",
								},
							},
							{
								name: "Load Service",
								label: "Registrar servicio",
								access: false,
								controller: {
									name: "LogServices",
									method: "findById",
								},
							},
						],
					},
					{
						controller: "Schedules",
						label: "Horario",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Buscar Horarios",
								access: false,
							},
							{
								name: "create",
								label: "Crear Horario",
								access: false,
							},
							{
								name: "update",
								label: "Actualizar Horario",
								access: false,
							},
							{
								name: "findById",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "LogServices",
						label: "Log de Servicios",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Buscar Logs de Servicios",
								access: false,
							},
							{
								name: "create",
								label: "Crear Log de Servicio",
								access: false,
							},
							{
								name: "update",
								label: "Actualizar Log de Servicio",
								access: false,
							},
							{
								name: "delete",
								label: "Eliminar Log de Servicio",
								access: false,
							},
						],
						components: [
							{
								name: "Export LogServices",
								label: "Exportar Log de Servicios",
								access: false,
							},
						],
					},
					{
						controller: "DeviceErrorsCode",
						label: "Códigos de Error",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Buscar Códigos de Error",
								access: false,
							},
							{
								name: "create",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "update",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "delete",
								label: "Eliminar Código de Error",
								access: false,
							},
						],
						components: [
							{
								name: "Export ErrorCode",
								label: "Exportar Códigos de Error",
								access: false,
							},
						],
					},
				],
				components: [],
			},
			{
				name: "Routes",
				label: "Rutas",
				access: false,
				subModules: [],
				components: [
					{
						component: "List Routes",
						label: "Buscar Rutas",
						access: false,
						controller: {
							name: "Routes",
							method: "findAll",
						},
					},
					{
						component: "Create Routes",
						label: "Crear Ruta",
						access: false,
						controller: {
							name: "Routes",
							method: "create",
						},
					},
					{
						component: "Update Routes",
						label: "Actualizar Ruta",
						access: false,
						controller: {
							name: "Routes",
							method: "update",
						},
					},
					{
						component: "Delete Routes",
						label: "Eliminar Ruta",
						access: false,
						controller: {
							name: "Routes",
							method: "delete",
						},
					},
				],
			},
			{
				name: "Admin",
				label: "Administrador",
				access: false,
				subModules: [
					{
						controller: "Users",
						label: "Usuarios",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Buscar Usuarios",
								access: false,
							},
							{
								name: "create",
								label: "Crear Usuarios",
								access: false,
							},
							{
								name: "update",
								label: "Actualizar Usuarios",
								access: false,
							},
							{
								name: "delete",
								label: "Eliminar Usuarios",
								access: false,
							},
							{
								name: "devices",
								label: "Asignar Dispositivos",
								access: false,
							},
						],
						components: [],
					},
					{
						controller: "Roles",
						label: "Roles",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Buscar Roles",
								access: false,
							},
							{
								name: "create",
								label: "Crear Roles",
								access: false,
							},
							{
								name: "update",
								label: "Actualizar Roles",
								access: false,
							},
							{
								name: "delete",
								label: "Eliminar Roles",
								access: false,
							},
						],
						components: [],
					},
					{
						controller: "Groups",
						label: "Grupos",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Buscar Grupos",
								access: false,
							},
							{
								name: "findById",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "create",
								label: "Crear Grupos",
								access: false,
							},
							{
								name: "update",
								label: "Actualizar Grupos",
								access: false,
							},
							{
								name: "delete",
								label: "Eliminar Grupos",
								access: false,
							},
						],
						components: [],
					},
					{
						controller: "Devices",
						label: "Dispositivos",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Buscar Dispositivos",
								access: false,
							},
							{
								name: "update",
								label: "Actualizar Dispositivos",
								access: false,
							},
							{
								name: "drivers",
								label: "Asignar Conductores",
								access: false,
							},
						],
						components: [],
					},
					{
						controller: "Drivers",
						label: "Conductores",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Buscar Conductores",
								access: false,
							},
							{
								name: "create",
								label: "Crear Conductores",
								access: false,
							},
							{
								name: "update",
								label: "Actualizar Conductores",
								access: false,
							},
							{
								name: "delete",
								label: "Eliminar Conductores",
								access: false,
							},
						],
						components: [],
					},
					{
						controller: "LinksTrackings",
						label: "Enlaces de Seguimiento",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Buscar Enlaces de Seguimiento",
								access: false,
							},
							{
								name: "create",
								label: "Crear Enlaces de Seguimiento",
								access: false,
							},
							{
								name: "delete",
								label: "Eliminar Enlaces de Seguimiento",
								access: false,
							},
							{
								name: "findme",
								label: "Compartir Enlaces de Seguimiento",
								access: false,
							},
						],
						components: [],
					},
					{
						controller: "Alerts",
						label: "Alertas",
						access: false,
						methods: [
							{
								name: "findAll",
								label: "Buscar Alertas",
								access: false,
							},
							{
								name: "create",
								label: "Crear Alertas",
								access: false,
							},
							{
								name: "update",
								label: "Actualizar Alertas",
								access: false,
							},
							{
								name: "delete",
								label: "Eliminar Alertas",
								access: false,
							},
							{
								name: "findOne",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "findAllMyAlert",
								label: "Configuración de Alerta",
								access: false,
							},
							{
								name: "createMyAlert",
								label: "Crear Configuración de Alerta",
								access: false,
							},
							{
								name: "updateMyAlert",
								label: "Actualizar Configuración de Alerta",
								access: false,
							},
							{
								name: "deleteMyAlert",
								label: "Eliminar Configuración de Alerta",
								access: false,
							},
						],
						components: [],
					},
					// {
					// 	controller: "WexCard",
					// 	label: "WEX",
					// 	access: false,
					// 	methods: [{
					// 		name: "findAll",
					// 		label: "Buscar tarjeta WEX",
					// 		access: false
					// 	},
					// 	{
					// 		name: "create",
					// 		label: "Crear tarjeta WEX",
					// 		access: false
					// 	},
					// 	{
					// 		name: "update",
					// 		label: "Actualizar tarjeta WEX",
					// 		access: false
					// 	},
					// 	{
					// 		name: "delete",
					// 		label: "Eliminar tarjeta WEX",
					// 		access: false
					// 	}],
					// 	components: []
					// }
				],
				components: [],
			},
			{
				name: "Cameras",
				label: "Cámaras",
				access: false,
				subModules: [],
				components: [],
			},
			{
				name: "Mix",
				label: "HIDDEN",
				access: true,
				subModules: [
					{
						controller: "Devices",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "findAll",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "Geofences",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "findAll",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "Roles",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "findAll",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "Points",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "findAll",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "Alerts",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "findAllAlerts",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "Users",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "addPlayer",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "deletePlayer",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "Maintenances",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "findAll",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "create",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "update",
								label: "HIDDEN",
								access: true,
							},
							{
								name: "delete",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
					{
						controller: "LogsMobile",
						label: "HIDDEN",
						access: true,
						methods: [
							{
								name: "create",
								label: "HIDDEN",
								access: true,
							},
						],
						components: [],
					},
				],
				components: [],
			},
		],
		emails: {
			alert: '<h1 class="ql-align-center">Evento Generado</h1><p><br></p><p>El dispositivo <strong>GSDEVICE</strong> ha generado un evento de <strong>GSEVENT</strong></p><p>Fecha: <strong>GSDATE</strong></p>',
		},
	},
};
